// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export const AbyssalHull = __t.object("AbyssalHull", {
  runId: __t.u64(),
  shipId: __t.u64(),
});
export type AbyssalHull = __Infer<typeof AbyssalHull>;

export const AbyssalRun = __t.object("AbyssalRun", {
  runId: __t.u64(),
  identity: __t.identity(),
  tier: __t.u32(),
  seed: __t.string(),
  state: __t.string(),
  roomsClaimed: __t.u32(),
  lastRoomAt: __t.timestamp(),
  startedAt: __t.timestamp(),
  expiresAt: __t.timestamp(),
});
export type AbyssalRun = __Infer<typeof AbyssalRun>;

export const Account = __t.object("Account", {
  identity: __t.identity(),
  accountId: __t.u64(),
  username: __t.string(),
  displayName: __t.string(),
  createdAt: __t.timestamp(),
  lastSeen: __t.timestamp(),
});
export type Account = __Infer<typeof Account>;

export const ActivityStation = __t.object("ActivityStation", {
  stationId: __t.u64(),
  worldId: __t.u64(),
  settlementId: __t.u64(),
  kind: __t.string(),
  x: __t.f32(),
  z: __t.f32(),
  facing: __t.f32(),
  capacity: __t.i32(),
  updatedAt: __t.timestamp(),
});
export type ActivityStation = __Infer<typeof ActivityStation>;

export const AdminPlacement = __t.object("AdminPlacement", {
  placementId: __t.u64(),
  worldId: __t.u64(),
  prefabKey: __t.string(),
  kind: __t.string(),
  posX: __t.f32(),
  posY: __t.f32(),
  posZ: __t.f32(),
  rotX: __t.f32(),
  rotY: __t.f32(),
  rotZ: __t.f32(),
  rotW: __t.f32(),
  scaleX: __t.f32(),
  scaleY: __t.f32(),
  scaleZ: __t.f32(),
  placedBy: __t.identity(),
  placedAt: __t.timestamp(),
  updatedAt: __t.timestamp(),
});
export type AdminPlacement = __Infer<typeof AdminPlacement>;

export const AirStrike = __t.object("AirStrike", {
  airId: __t.u64(),
  lastRunIdx: __t.u32(),
  updatedAt: __t.timestamp(),
});
export type AirStrike = __Infer<typeof AirStrike>;

export const ArcadeGame = __t.object("ArcadeGame", {
  gameId: __t.u64(),
  creator: __t.identity(),
  worldId: __t.u64(),
  mode: __t.string(),
  pinnedTo: __t.u64(),
  pinned: __t.bool(),
  certified: __t.bool(),
  createdAt: __t.timestamp(),
});
export type ArcadeGame = __Infer<typeof ArcadeGame>;

export const ArcadeGameDef = __t.object("ArcadeGameDef", {
  gameId: __t.u64(),
  contractId: __t.u64(),
  minPlayers: __t.u8(),
  maxPlayers: __t.u8(),
  teamSize: __t.u8(),
  ruleset: __t.string(),
  jurisdiction: __t.string(),
});
export type ArcadeGameDef = __Infer<typeof ArcadeGameDef>;

export const ArcadeSeason = __t.object("ArcadeSeason", {
  seasonId: __t.u64(),
  gameId: __t.u64(),
  seasonNum: __t.u32(),
  startsAt: __t.timestamp(),
  endsAt: __t.timestamp(),
  status: __t.string(),
});
export type ArcadeSeason = __Infer<typeof ArcadeSeason>;

export const ArcadeTabState = __t.object("ArcadeTabState", {
  id: __t.u64(),
  unlocked: __t.bool(),
});
export type ArcadeTabState = __Infer<typeof ArcadeTabState>;

export const Asset = __t.object("Asset", {
  assetId: __t.u64(),
  creator: __t.identity(),
  kind: __t.string(),
  contentRef: __t.string(),
  permCopy: __t.bool(),
  permModify: __t.bool(),
  permTransfer: __t.bool(),
  permRemix: __t.bool(),
  permTemplate: __t.bool(),
  isPremium: __t.bool(),
  parentAssetId: __t.u64(),
  createdAt: __t.timestamp(),
});
export type Asset = __Infer<typeof Asset>;

export const AssetBridge = __t.object("AssetBridge", {
  bridgeId: __t.u64(),
  assetId: __t.u64(),
  resultAssetId: __t.u64(),
  direction: __t.string(),
  fidelityTier: __t.u8(),
  actor: __t.identity(),
  at: __t.timestamp(),
});
export type AssetBridge = __Infer<typeof AssetBridge>;

export const AssetCollider = __t.object("AssetCollider", {
  assetId: __t.u64(),
  shape: __t.string(),
  colliderUri: __t.string(),
});
export type AssetCollider = __Infer<typeof AssetCollider>;

export const AssetFormat = __t.object("AssetFormat", {
  assetId: __t.u64(),
  gltfRef: __t.string(),
  fidelityVariants: __t.string(),
  authoringCaps: __t.string(),
  formatVersion: __t.u32(),
  updatedAt: __t.timestamp(),
});
export type AssetFormat = __Infer<typeof AssetFormat>;

export const AssetPack = __t.object("AssetPack", {
  packId: __t.u64(),
  name: __t.string(),
  uri: __t.string(),
  sizeBytes: __t.u64(),
  members: __t.string(),
  updatedAt: __t.timestamp(),
});
export type AssetPack = __Infer<typeof AssetPack>;

export const AssetUpload = __t.object("AssetUpload", {
  uploadId: __t.u64(),
  uploader: __t.identity(),
  originalFilename: __t.string(),
  rawUri: __t.string(),
  useClass: __t.string(),
  worldId: __t.u64(),
  status: __t.string(),
  rejectReason: __t.string(),
  assetId: __t.u64(),
  createdAt: __t.timestamp(),
});
export type AssetUpload = __Infer<typeof AssetUpload>;

export const AssetValidationLimits = __t.object("AssetValidationLimits", {
  useClass: __t.string(),
  maxTris: __t.u32(),
  maxTextures: __t.u16(),
  maxTexturePx: __t.u16(),
  maxMaterials: __t.u16(),
  maxBones: __t.u16(),
  maxNodes: __t.u16(),
  maxFileMb: __t.u16(),
  maxVramMb: __t.u32(),
});
export type AssetValidationLimits = __Infer<typeof AssetValidationLimits>;

export const AudioZone = __t.object("AudioZone", {
  zoneId: __t.u64(),
  worldId: __t.u64(),
  name: __t.string(),
  audioAssetId: __t.u64(),
  kind: __t.string(),
  shapeType: __t.string(),
  cx: __t.f32(),
  cy: __t.f32(),
  cz: __t.f32(),
  radius: __t.f32(),
  sx: __t.f32(),
  sy: __t.f32(),
  sz: __t.f32(),
  gain: __t.f32(),
  loop: __t.bool(),
  fadeDuration: __t.f32(),
  priority: __t.i32(),
});
export type AudioZone = __Infer<typeof AudioZone>;

export const AuthCredential = __t.object("AuthCredential", {
  identity: __t.identity(),
  username: __t.string(),
  subject: __t.string(),
  kdf: __t.string(),
  kdfN: __t.u32(),
  kdfR: __t.u32(),
  kdfP: __t.u32(),
  salt: __t.string(),
  hash: __t.string(),
  recoveryHashes: __t.string(),
  failedCount: __t.u32(),
  lockedUntilMicros: __t.u64(),
  sessionEpoch: __t.u32(),
  resetHash: __t.string(),
  resetUntilMicros: __t.u64(),
  createdAt: __t.timestamp(),
  updatedAt: __t.timestamp(),
});
export type AuthCredential = __Infer<typeof AuthCredential>;

export const Avatar = __t.object("Avatar", {
  identity: __t.identity(),
  bodyTemplate: __t.string(),
  skeletonId: __t.string(),
  materialSlots: __t.string(),
  attachments: __t.string(),
  complexity: __t.u32(),
  updatedAt: __t.timestamp(),
});
export type Avatar = __Infer<typeof Avatar>;

export const Bank = __t.object("Bank", {
  bankId: __t.u64(),
  kind: __t.string(),
  cityId: __t.u64(),
  name: __t.string(),
  status: __t.string(),
  charteredBy: __t.identity(),
  baseBps: __t.u32(),
  reserveRatioBps: __t.u32(),
  reserveFactorBps: __t.u32(),
  supplyIndex: __t.f64(),
  scaledDeposits: __t.f64(),
  savingsBps: __t.f64(),
  utilization: __t.f64(),
  loansOutstanding: __t.f64(),
  depositsTotal: __t.f64(),
  vaultCash: __t.f64(),
  equity: __t.f64(),
  avgLoanBps: __t.f64(),
  writtenOff: __t.i64(),
  interestEarned: __t.f64(),
  capitalFloor: __t.i64(),
  owesReserve: __t.f64(),
  lastAccrualAt: __t.timestamp(),
  lastWeeklyAt: __t.timestamp(),
  createdAt: __t.timestamp(),
});
export type Bank = __Infer<typeof Bank>;

export const BankAccount = __t.object("BankAccount", {
  accountKey: __t.string(),
  bankId: __t.u64(),
  identity: __t.identity(),
  scaled: __t.f64(),
  netDeposited: __t.i64(),
  openedAt: __t.timestamp(),
  lastActivityAt: __t.timestamp(),
});
export type BankAccount = __Infer<typeof BankAccount>;

export const BankCustody = __t.object("BankCustody", {
  entryId: __t.u64(),
  bankId: __t.u64(),
  identity: __t.identity(),
  purpose: __t.string(),
  loanId: __t.u64(),
  kind: __t.string(),
  itemKey: __t.string(),
  name: __t.string(),
  quality: __t.u32(),
  qty: __t.u32(),
  packedJson: __t.string(),
  appraisal: __t.i64(),
  storedAt: __t.timestamp(),
});
export type BankCustody = __Infer<typeof BankCustody>;

export const BankLoan = __t.object("BankLoan", {
  loanId: __t.u64(),
  bankId: __t.u64(),
  borrower: __t.identity(),
  principal: __t.i64(),
  fee: __t.i64(),
  rateBps: __t.u32(),
  termDays: __t.u32(),
  installment: __t.i64(),
  balance: __t.f64(),
  accruedAt: __t.timestamp(),
  due: __t.f64(),
  dueSince: __t.timestamp(),
  dueLate: __t.bool(),
  nextDueAt: __t.timestamp(),
  finalDueAt: __t.timestamp(),
  missed: __t.u32(),
  lateCount: __t.u32(),
  paidTotal: __t.i64(),
  secured: __t.bool(),
  autopay: __t.bool(),
  state: __t.string(),
  createdAt: __t.timestamp(),
  closedAt: __t.timestamp(),
});
export type BankLoan = __Infer<typeof BankLoan>;

export const BankRepoLot = __t.object("BankRepoLot", {
  lotId: __t.u64(),
  bankId: __t.u64(),
  fromLoanId: __t.u64(),
  kind: __t.string(),
  itemKey: __t.string(),
  name: __t.string(),
  quality: __t.u32(),
  qty: __t.u32(),
  packedJson: __t.string(),
  appraisal: __t.i64(),
  listedAt: __t.timestamp(),
});
export type BankRepoLot = __Infer<typeof BankRepoLot>;

export const BankStackPledge = __t.object("BankStackPledge", {
  stackId: __t.u64(),
  qty: __t.u32(),
});
export type BankStackPledge = __Infer<typeof BankStackPledge>;

export const BankTermDeposit = __t.object("BankTermDeposit", {
  cdId: __t.u64(),
  bankId: __t.u64(),
  identity: __t.identity(),
  principal: __t.i64(),
  rateBps: __t.f64(),
  termDays: __t.u32(),
  openedAt: __t.timestamp(),
  maturesAt: __t.timestamp(),
});
export type BankTermDeposit = __Infer<typeof BankTermDeposit>;

export const BankTxn = __t.object("BankTxn", {
  txnId: __t.u64(),
  identity: __t.identity(),
  bankId: __t.u64(),
  kind: __t.string(),
  amount: __t.i64(),
  memo: __t.string(),
  at: __t.timestamp(),
});
export type BankTxn = __Infer<typeof BankTxn>;

export const Battle = __t.object("Battle", {
  battleId: __t.u64(),
  warId: __t.u64(),
  worldId: __t.u64(),
  aggressorSid: __t.u64(),
  defenderSid: __t.u64(),
  phase: __t.string(),
  kind: __t.string(),
  targetX: __t.f32(),
  targetZ: __t.f32(),
  generalA: __t.u64(),
  generalB: __t.u64(),
  planA: __t.string(),
  planB: __t.string(),
  round: __t.u32(),
  strengthA: __t.u32(),
  strengthB: __t.u32(),
  winner: __t.string(),
  summary: __t.string(),
  startedAt: __t.timestamp(),
  engagedAt: __t.timestamp(),
  endsAt: __t.timestamp(),
  updatedAt: __t.timestamp(),
});
export type Battle = __Infer<typeof Battle>;

export const BattleAdvice = __t.object("BattleAdvice", {
  adviceId: __t.u64(),
  battleId: __t.u64(),
  worldId: __t.u64(),
  side: __t.string(),
  strategy: __t.string(),
  source: __t.string(),
  say: __t.string(),
  round: __t.u32(),
  at: __t.timestamp(),
});
export type BattleAdvice = __Infer<typeof BattleAdvice>;

export const BattleCall = __t.object("BattleCall", {
  callId: __t.u64(),
  battleId: __t.u64(),
  warId: __t.u64(),
  worldId: __t.u64(),
  side: __t.string(),
  wanted: __t.u32(),
  sent: __t.u32(),
  round: __t.u32(),
  state: __t.string(),
  calledAt: __t.timestamp(),
});
export type BattleCall = __Infer<typeof BattleCall>;

export const BattleEvent = __t.object("BattleEvent", {
  eventId: __t.u64(),
  battleId: __t.u64(),
  worldId: __t.u64(),
  seq: __t.u32(),
  kind: __t.string(),
  actorId: __t.u64(),
  targetId: __t.u64(),
  x: __t.f32(),
  z: __t.f32(),
  tx: __t.f32(),
  tz: __t.f32(),
  weaponKey: __t.string(),
  dmg: __t.i32(),
  detail: __t.string(),
  at: __t.timestamp(),
});
export type BattleEvent = __Infer<typeof BattleEvent>;

export const BattleLook = __t.object("BattleLook", {
  lookId: __t.u64(),
  battleId: __t.u64(),
  worldId: __t.u64(),
  versonaId: __t.u64(),
  archetype: __t.string(),
  civ: __t.string(),
  name: __t.string(),
});
export type BattleLook = __Infer<typeof BattleLook>;

export const BattleObjective = __t.object("BattleObjective", {
  objectiveId: __t.u64(),
  battleId: __t.u64(),
  warId: __t.u64(),
  worldId: __t.u64(),
  kind: __t.string(),
  x: __t.f32(),
  z: __t.f32(),
  radiusM: __t.f32(),
  controller: __t.string(),
  claimant: __t.string(),
  state: __t.string(),
  progress: __t.f32(),
  updatedAt: __t.timestamp(),
});
export type BattleObjective = __Infer<typeof BattleObjective>;

export const BattleOutpost = __t.object("BattleOutpost", {
  outpostId: __t.u64(),
  battleId: __t.u64(),
  warId: __t.u64(),
  worldId: __t.u64(),
  side: __t.string(),
  x: __t.f32(),
  z: __t.f32(),
  radiusM: __t.f32(),
  turrets: __t.u32(),
  medics: __t.u32(),
  mechanics: __t.u32(),
  updatedAt: __t.timestamp(),
});
export type BattleOutpost = __Infer<typeof BattleOutpost>;

export const BattleRecord = __t.object("BattleRecord", {
  battleId: __t.u64(),
  warId: __t.u64(),
  worldId: __t.u64(),
  aggressorSid: __t.u64(),
  defenderSid: __t.u64(),
  kind: __t.string(),
  x: __t.f32(),
  z: __t.f32(),
  units: __t.u32(),
  fallen: __t.u32(),
  winner: __t.string(),
  summary: __t.string(),
  resolvedAt: __t.timestamp(),
});
export type BattleRecord = __Infer<typeof BattleRecord>;

export const BattleSquad = __t.object("BattleSquad", {
  squadId: __t.u64(),
  battleId: __t.u64(),
  worldId: __t.u64(),
  side: __t.string(),
  index: __t.u32(),
  captainId: __t.u64(),
  plan: __t.string(),
  updatedAt: __t.timestamp(),
});
export type BattleSquad = __Infer<typeof BattleSquad>;

export const BattleUnit = __t.object("BattleUnit", {
  unitId: __t.u64(),
  battleId: __t.u64(),
  worldId: __t.u64(),
  versonaId: __t.u64(),
  side: __t.string(),
  role: __t.string(),
  weaponKey: __t.string(),
  hp: __t.i32(),
  morale: __t.i32(),
  state: __t.string(),
  x: __t.f32(),
  z: __t.f32(),
  targetId: __t.u64(),
  lastHit: __t.i32(),
  updatedAt: __t.timestamp(),
});
export type BattleUnit = __Infer<typeof BattleUnit>;

export const BeginnerMixerSuggestion = __t.object("BeginnerMixerSuggestion", {
  sugId: __t.u64(),
  identity: __t.identity(),
  eventId: __t.u64(),
  curator: __t.identity(),
  welcomingScore: __t.f32(),
  at: __t.timestamp(),
});
export type BeginnerMixerSuggestion = __Infer<typeof BeginnerMixerSuggestion>;

export const BetrayalRecord = __t.object("BetrayalRecord", {
  recordId: __t.u64(),
  betrayer: __t.identity(),
  victim: __t.identity(),
  kind: __t.string(),
  worldId: __t.u64(),
  at: __t.timestamp(),
});
export type BetrayalRecord = __Infer<typeof BetrayalRecord>;

export const BountyContract = __t.object("BountyContract", {
  bountyId: __t.u64(),
  target: __t.identity(),
  contractorKind: __t.string(),
  contractorId: __t.u64(),
  contractorLabel: __t.string(),
  placedBy: __t.identity(),
  spend: __t.i64(),
  tier: __t.u8(),
  hunterName: __t.string(),
  hunterHp: __t.i32(),
  hunterMaxHp: __t.i32(),
  state: __t.string(),
  placedAt: __t.timestamp(),
  attackAt: __t.timestamp(),
  lastHitAt: __t.timestamp(),
  resolvedAt: __t.timestamp(),
  updatedAt: __t.timestamp(),
});
export type BountyContract = __Infer<typeof BountyContract>;

export const BountyCue = __t.object("BountyCue", {
  cueId: __t.u64(),
  target: __t.identity(),
  kind: __t.string(),
  x: __t.f32(),
  z: __t.f32(),
  refId: __t.u64(),
  variant: __t.u8(),
  createdAt: __t.timestamp(),
  expiresAt: __t.timestamp(),
});
export type BountyCue = __Infer<typeof BountyCue>;

export const BountyDebug = __t.object("BountyDebug", {
  bountyId: __t.u64(),
  json: __t.string(),
  at: __t.timestamp(),
});
export type BountyDebug = __Infer<typeof BountyDebug>;

export const BountyEvent = __t.object("BountyEvent", {
  eventId: __t.u64(),
  bountyId: __t.u64(),
  target: __t.identity(),
  kind: __t.string(),
  detail: __t.string(),
  at: __t.timestamp(),
});
export type BountyEvent = __Infer<typeof BountyEvent>;

export const BountyHunt = __t.object("BountyHunt", {
  bountyId: __t.u64(),
  target: __t.identity(),
  phase: __t.string(),
  materialized: __t.bool(),
  x: __t.f32(),
  y: __t.f32(),
  z: __t.f32(),
  yaw: __t.f32(),
  revision: __t.u32(),
  domainEpoch: __t.u32(),
  since: __t.timestamp(),
  updatedAt: __t.timestamp(),
});
export type BountyHunt = __Infer<typeof BountyHunt>;

export const BountyHunterAgent = __t.object("BountyHunterAgent", {
  bountyId: __t.u64(),
  target: __t.identity(),
  worldId: __t.u64(),
  phase: __t.string(),
  phaseSince: __t.timestamp(),
  materialized: __t.bool(),
  x: __t.f32(),
  y: __t.f32(),
  z: __t.f32(),
  yaw: __t.f32(),
  goalX: __t.f32(),
  goalZ: __t.f32(),
  goalSetAt: __t.timestamp(),
  seenX: __t.f32(),
  seenZ: __t.f32(),
  seenAt: __t.timestamp(),
  seenVx: __t.f32(),
  seenVz: __t.f32(),
  confidence: __t.f32(),
  observedFacts: __t.u32(),
  armed: __t.bool(),
  heldS: __t.f32(),
  firstCueAt: __t.timestamp(),
  lastCueAt: __t.timestamp(),
  cueWindowStart: __t.timestamp(),
  cueCount: __t.u32(),
  activeS: __t.f32(),
  nextOpportunityAt: __t.timestamp(),
  searchUntil: __t.timestamp(),
  lostS: __t.f32(),
  noLosS: __t.f32(),
  blockedS: __t.f32(),
  shelterUntil: __t.timestamp(),
  shelterSince: __t.timestamp(),
  graceUntil: __t.timestamp(),
  lastShotAt: __t.timestamp(),
  prevPx: __t.f32(),
  prevPz: __t.f32(),
  prevPAt: __t.timestamp(),
  memoBearing: __t.f32(),
  memoUses: __t.u8(),
  lastTickAt: __t.timestamp(),
  revision: __t.u32(),
  domainEpoch: __t.u32(),
  reason: __t.string(),
  createdAt: __t.timestamp(),
  updatedAt: __t.timestamp(),
});
export type BountyHunterAgent = __Infer<typeof BountyHunterAgent>;

export const BountyPressure = __t.object("BountyPressure", {
  target: __t.identity(),
  intensity: __t.f32(),
  recoverUntil: __t.timestamp(),
  lastCommitAt: __t.timestamp(),
  lastHurtSeen: __t.timestamp(),
  encounters: __t.u32(),
  updatedAt: __t.timestamp(),
});
export type BountyPressure = __Infer<typeof BountyPressure>;

export const BountyTick = __t.object("BountyTick", {
  scheduledId: __t.u64(),
  scheduledAt: __t.scheduleAt(),
});
export type BountyTick = __Infer<typeof BountyTick>;

export const BridgeAudit = __t.object("BridgeAudit", {
  auditId: __t.u64(),
  settlementId: __t.u64(),
  playerHex: __t.string(),
  direction: __t.string(),
  commodity: __t.string(),
  qty: __t.i32(),
  sov: __t.i64(),
  coins: __t.i64(),
  at: __t.timestamp(),
});
export type BridgeAudit = __Infer<typeof BridgeAudit>;

export const CampaignAar = __t.object("CampaignAar", {
  aarKey: __t.string(),
  campaignId: __t.u64(),
  cyc: __t.u64(),
  generation: __t.u32(),
  rulesVersion: __t.u32(),
  winner: __t.string(),
  retreatSide: __t.i32(),
  fortKey: __t.string(),
  targetSystem: __t.string(),
  openedAt: __t.timestamp(),
  endsAt: __t.timestamp(),
  settledAt: __t.timestamp(),
  summary: __t.string(),
  checksum: __t.string(),
  sandbox: __t.bool(),
});
export type CampaignAar = __Infer<typeof CampaignAar>;

export const CampaignCapital = __t.object("CampaignCapital", {
  capId: __t.u64(),
  campaignId: __t.u64(),
  side: __t.u8(),
  slot: __t.u32(),
  alive: __t.bool(),
  killedBy: __t.string(),
  round: __t.u32(),
  killedAt: __t.timestamp(),
  updatedAt: __t.timestamp(),
});
export type CampaignCapital = __Infer<typeof CampaignCapital>;

export const CampaignEscort = __t.object("CampaignEscort", {
  escortId: __t.u64(),
  campaignId: __t.u64(),
  side: __t.u8(),
  cls: __t.string(),
  slot: __t.u32(),
  alive: __t.bool(),
  killedBy: __t.string(),
  round: __t.u32(),
  killedAt: __t.timestamp(),
  updatedAt: __t.timestamp(),
});
export type CampaignEscort = __Infer<typeof CampaignEscort>;

export const CampaignEvent = __t.object("CampaignEvent", {
  eventKey: __t.string(),
  campaignId: __t.u64(),
  seq: __t.u32(),
  generation: __t.u32(),
  rulesVersion: __t.u32(),
  at: __t.timestamp(),
  kind: __t.string(),
  cause: __t.string(),
  actor: __t.string(),
  target: __t.string(),
  side: __t.i32(),
  round: __t.u32(),
  before: __t.string(),
  after: __t.string(),
  detail: __t.string(),
});
export type CampaignEvent = __Infer<typeof CampaignEvent>;

export const CampaignMeta = __t.object("CampaignMeta", {
  campaignId: __t.u64(),
  rulesVersion: __t.u32(),
  generation: __t.u32(),
  nextSeq: __t.u32(),
  optionalRows: __t.u32(),
  dropped: __t.u32(),
  settledGen: __t.u32(),
  settledAt: __t.timestamp(),
  payTx: __t.string(),
  lateOpenS: __t.u32(),
  retreatCause: __t.string(),
  historyQuality: __t.string(),
  sandbox: __t.bool(),
  updatedAt: __t.timestamp(),
});
export type CampaignMeta = __Infer<typeof CampaignMeta>;

export const CampaignOpsPin = __t.object("CampaignOpsPin", {
  campaignId: __t.u64(),
  version: __t.u32(),
  extraction: __t.bool(),
  pinnedAt: __t.timestamp(),
});
export type CampaignOpsPin = __Infer<typeof CampaignOpsPin>;

export const CampaignReceipt = __t.object("CampaignReceipt", {
  receiptId: __t.u64(),
  campaignId: __t.u64(),
  identity: __t.identity(),
  side: __t.u8(),
  kind: __t.string(),
  ref: __t.string(),
  points: __t.u32(),
  paidSov: __t.i64(),
  at: __t.timestamp(),
});
export type CampaignReceipt = __Infer<typeof CampaignReceipt>;

export const CampaignSide = __t.object("CampaignSide", {
  sideId: __t.u64(),
  campaignId: __t.u64(),
  side: __t.u8(),
  civ: __t.string(),
  capsCommitted: __t.u32(),
  capsAlive: __t.u32(),
  skirmCommitted: __t.u32(),
  skirmAlive: __t.u32(),
  skLost: __t.u32(),
  capLost: __t.u32(),
  points: __t.u32(),
  updatedAt: __t.timestamp(),
});
export type CampaignSide = __Infer<typeof CampaignSide>;

export const CampaignSky = __t.object("CampaignSky", {
  cyc: __t.u64(),
  campaignId: __t.u64(),
  state: __t.string(),
  fort: __t.string(),
  front: __t.string(),
  openedAt: __t.timestamp(),
  endsAt: __t.timestamp(),
  capsA: __t.u8(),
  capsB: __t.u8(),
  capsComA: __t.u8(),
  capsComB: __t.u8(),
  frigA: __t.u8(),
  frigB: __t.u8(),
  corvA: __t.u8(),
  corvB: __t.u8(),
  gunA: __t.u8(),
  gunB: __t.u8(),
  retreatSide: __t.i8(),
  winner: __t.string(),
  validated: __t.bool(),
  rounds: __t.u16(),
  seq: __t.u32(),
  updatedAt: __t.timestamp(),
});
export type CampaignSky = __Infer<typeof CampaignSky>;

export const CampaignStance = __t.object("CampaignStance", {
  stanceId: __t.u64(),
  campaignId: __t.u64(),
  side: __t.u8(),
  stance: __t.string(),
  sinceRound: __t.u32(),
  reason: __t.string(),
  updatedAt: __t.timestamp(),
});
export type CampaignStance = __Infer<typeof CampaignStance>;

export const Caravan = __t.object("Caravan", {
  caravanId: __t.u64(),
  fromSid: __t.u64(),
  toSid: __t.u64(),
  ownerId: __t.u64(),
  commodity: __t.string(),
  qty: __t.i32(),
  coins: __t.i64(),
  departAt: __t.timestamp(),
  arriveAt: __t.timestamp(),
  status: __t.string(),
});
export type Caravan = __Infer<typeof Caravan>;

export const CargoConvoy = __t.object("CargoConvoy", {
  convoyId: __t.u64(),
  worldId: __t.u64(),
  fromSid: __t.u64(),
  toSid: __t.u64(),
  commodity: __t.string(),
  qty: __t.u32(),
  valueSov: __t.i64(),
  fromX: __t.f32(),
  fromZ: __t.f32(),
  toX: __t.f32(),
  toZ: __t.f32(),
  departAt: __t.timestamp(),
  arriveAt: __t.timestamp(),
  status: __t.string(),
  crashX: __t.f32(),
  crashZ: __t.f32(),
  downedBy: __t.identity(),
  updatedAt: __t.timestamp(),
});
export type CargoConvoy = __Infer<typeof CargoConvoy>;

export const CargoLot = __t.object("CargoLot", {
  lotId: __t.u64(),
  owner: __t.identity(),
  familyKey: __t.string(),
  name: __t.string(),
  statsJson: __t.string(),
  qty: __t.u32(),
  locKind: __t.string(),
  locId: __t.string(),
  tag: __t.string(),
  createdAt: __t.timestamp(),
});
export type CargoLot = __Infer<typeof CargoLot>;

export const CharterChallenge = __t.object("CharterChallenge", {
  challengeId: __t.u64(),
  groupId: __t.u64(),
  challenger: __t.identity(),
  reason: __t.string(),
  at: __t.timestamp(),
});
export type CharterChallenge = __Infer<typeof CharterChallenge>;

export const CharterClause = __t.object("CharterClause", {
  clauseId: __t.u64(),
  worldId: __t.u64(),
  settlementId: __t.u64(),
  kind: __t.string(),
  value: __t.i32(),
  status: __t.string(),
  proposedBy: __t.u64(),
  rationale: __t.string(),
  voteAt: __t.timestamp(),
  yesVotes: __t.u32(),
  noVotes: __t.u32(),
  decidedAt: __t.timestamp(),
});
export type CharterClause = __Infer<typeof CharterClause>;

export const ChatBudget = __t.object("ChatBudget", {
  identity: __t.identity(),
  tokens: __t.f32(),
  at: __t.timestamp(),
});
export type ChatBudget = __Infer<typeof ChatBudget>;

export const ChatLang = __t.object("ChatLang", {
  identity: __t.identity(),
  lang: __t.string(),
  at: __t.timestamp(),
});
export type ChatLang = __Infer<typeof ChatLang>;

export const ChatMessage = __t.object("ChatMessage", {
  msgId: __t.u64(),
  worldId: __t.u64(),
  sender: __t.identity(),
  senderName: __t.string(),
  kind: __t.string(),
  target: __t.identity(),
  posX: __t.f32(),
  posZ: __t.f32(),
  text: __t.string(),
  at: __t.timestamp(),
});
export type ChatMessage = __Infer<typeof ChatMessage>;

export const ChatTranslateRequest = __t.object("ChatTranslateRequest", {
  requestId: __t.u64(),
  msgId: __t.u64(),
  lang: __t.string(),
  requester: __t.identity(),
  at: __t.timestamp(),
});
export type ChatTranslateRequest = __Infer<typeof ChatTranslateRequest>;

export const ChatTranslation = __t.object("ChatTranslation", {
  key: __t.string(),
  msgId: __t.u64(),
  lang: __t.string(),
  source: __t.string(),
  text: __t.string(),
  engine: __t.string(),
  at: __t.timestamp(),
});
export type ChatTranslation = __Infer<typeof ChatTranslation>;

export const CheatFlag = __t.object("CheatFlag", {
  flagId: __t.u64(),
  sessionId: __t.u64(),
  player: __t.identity(),
  kind: __t.string(),
  confidence: __t.f32(),
  action: __t.string(),
  detail: __t.string(),
  at: __t.timestamp(),
});
export type CheatFlag = __Infer<typeof CheatFlag>;

export const Chronicle = __t.object("Chronicle", {
  chronId: __t.u64(),
  worldId: __t.u64(),
  settlementId: __t.u64(),
  kind: __t.string(),
  actorId: __t.u64(),
  otherId: __t.u64(),
  detail: __t.string(),
  at: __t.timestamp(),
});
export type Chronicle = __Infer<typeof Chronicle>;

export const ChroniclerEvent = __t.object("ChroniclerEvent", {
  eventId: __t.u64(),
  kind: __t.string(),
  startedAt: __t.timestamp(),
  endsAt: __t.timestamp(),
  active: __t.bool(),
  payload: __t.string(),
});
export type ChroniclerEvent = __Infer<typeof ChroniclerEvent>;

export const Citizen = __t.object("Citizen", {
  citizenId: __t.u64(),
  cityId: __t.u64(),
  identity: __t.identity(),
  residenceStructureId: __t.u64(),
  isMilitia: __t.bool(),
  declaredAt: __t.timestamp(),
});
export type Citizen = __Infer<typeof Citizen>;

export const City = __t.object("City", {
  cityId: __t.u64(),
  cityHallStructureId: __t.u64(),
  mayor: __t.identity(),
  name: __t.string(),
  centerX: __t.f32(),
  centerZ: __t.f32(),
  cityRank: __t.u8(),
  radiusM: __t.u32(),
  treasury: __t.i64(),
  incomeTax: __t.u16(),
  propertyTax: __t.u16(),
  salesTax: __t.u16(),
  specialization: __t.string(),
  status: __t.string(),
  foundedAt: __t.timestamp(),
  nextUpdateAt: __t.timestamp(),
  lastElectionAt: __t.timestamp(),
  lastSpecChangeAt: __t.timestamp(),
});
export type City = __Infer<typeof City>;

export const CityAllegiance = __t.object("CityAllegiance", {
  cityId: __t.u64(),
  civ: __t.string(),
  declaredAt: __t.timestamp(),
});
export type CityAllegiance = __Infer<typeof CityAllegiance>;

export const CitySpec = __t.object("CitySpec", {
  settlementId: __t.u64(),
  spec: __t.string(),
  since: __t.timestamp(),
});
export type CitySpec = __Infer<typeof CitySpec>;

export const CityTurretShot = __t.object("CityTurretShot", {
  shotId: __t.u64(),
  cityId: __t.u64(),
  turretStructureId: __t.u64(),
  targetKind: __t.string(),
  targetId: __t.u64(),
  targetX: __t.f32(),
  targetZ: __t.f32(),
  damage: __t.u32(),
  at: __t.timestamp(),
});
export type CityTurretShot = __Infer<typeof CityTurretShot>;

export const CityVersonaResident = __t.object("CityVersonaResident", {
  residentId: __t.u64(),
  cityId: __t.u64(),
  versonaId: __t.u64(),
  houseStructureId: __t.u64(),
  invitedBy: __t.identity(),
  originSettlementId: __t.u64(),
  since: __t.timestamp(),
});
export type CityVersonaResident = __Infer<typeof CityVersonaResident>;

export const CivFlipLog = __t.object("CivFlipLog", {
  flipId: __t.u64(),
  worldId: __t.u64(),
  settlementId: __t.u64(),
  fromCiv: __t.string(),
  toCiv: __t.string(),
  warId: __t.u64(),
  at: __t.timestamp(),
});
export type CivFlipLog = __Infer<typeof CivFlipLog>;

export const CivOperation = __t.object("CivOperation", {
  opId: __t.u64(),
  civ: __t.string(),
  cyc: __t.u64(),
  operation: __t.string(),
  targetSystem: __t.string(),
  capsReserved: __t.u32(),
  utilityJson: __t.string(),
  reason: __t.string(),
  decidedAt: __t.timestamp(),
});
export type CivOperation = __Infer<typeof CivOperation>;

export const CivReserve = __t.object("CivReserve", {
  civ: __t.string(),
  hulls: __t.u32(),
  capitals: __t.u32(),
  updatedAt: __t.timestamp(),
});
export type CivReserve = __Infer<typeof CivReserve>;

export const CivTreaty = __t.object("CivTreaty", {
  treatyId: __t.u64(),
  civA: __t.string(),
  civB: __t.string(),
  kind: __t.string(),
  state: __t.string(),
  proposedBy: __t.string(),
  fromCyc: __t.u64(),
  untilCyc: __t.u64(),
  breachedBy: __t.string(),
  breachedCyc: __t.u64(),
  updatedAt: __t.timestamp(),
});
export type CivTreaty = __Infer<typeof CivTreaty>;

export const CivicSign = __t.object("CivicSign", {
  signId: __t.u64(),
  identity: __t.identity(),
  kind: __t.string(),
  settlementId: __t.u64(),
  refId: __t.u64(),
  detail: __t.string(),
  at: __t.timestamp(),
});
export type CivicSign = __Infer<typeof CivicSign>;

export const CivicStructure = __t.object("CivicStructure", {
  structureId: __t.u64(),
  cityId: __t.u64(),
  civicType: __t.string(),
  minRank: __t.u8(),
  status: __t.string(),
});
export type CivicStructure = __Infer<typeof CivicStructure>;

export const CoinIssuance = __t.object("CoinIssuance", {
  source: __t.string(),
  coins: __t.i64(),
  units: __t.i64(),
  count: __t.u64(),
  updatedAt: __t.timestamp(),
});
export type CoinIssuance = __Infer<typeof CoinIssuance>;

export const CombatAction = __t.object("CombatAction", {
  scheduledId: __t.u64(),
  scheduledAt: __t.scheduleAt(),
  attacker: __t.identity(),
  attackerLife: __t.u32(),
  targetKind: __t.string(),
  targetPlayer: __t.identity(),
  targetId: __t.u64(),
  targetLife: __t.u32(),
  itemKey: __t.string(),
  feedKey: __t.string(),
  weaponKind: __t.string(),
  reachM: __t.f32(),
  dmg: __t.i32(),
  control: __t.string(),
  profile: __t.string(),
  contextKind: __t.string(),
  contextId: __t.u64(),
  contextGen: __t.u32(),
  startedAt: __t.timestamp(),
  impactAt: __t.timestamp(),
  hitIntervalMs: __t.u32(),
  missIntervalMs: __t.u32(),
  worldId: __t.u64(),
});
export type CombatAction = __Infer<typeof CombatAction>;

export const CombatActor = __t.object("CombatActor", {
  identity: __t.identity(),
  life: __t.u32(),
  attackReadyAt: __t.timestamp(),
  equipReadyAt: __t.timestamp(),
  pendingActionId: __t.u64(),
  combatLockUntil: __t.timestamp(),
  staggerResistUntil: __t.timestamp(),
  protectedUntil: __t.timestamp(),
  regenAt: __t.timestamp(),
  regenAcc: __t.f32(),
  lastDownedAt: __t.timestamp(),
  updatedAt: __t.timestamp(),
});
export type CombatActor = __Infer<typeof CombatActor>;

export const CombatResult = __t.object("CombatResult", {
  resultId: __t.u64(),
  actionId: __t.u64(),
  attacker: __t.identity(),
  attackerLife: __t.u32(),
  targetKind: __t.string(),
  targetPlayer: __t.identity(),
  targetId: __t.u64(),
  targetLife: __t.u32(),
  outcome: __t.string(),
  dmg: __t.i32(),
  itemKey: __t.string(),
  contextKind: __t.string(),
  contextId: __t.u64(),
  worldId: __t.u64(),
  at: __t.timestamp(),
});
export type CombatResult = __Infer<typeof CombatResult>;

export const Compass = __t.object("Compass", {
  identity: __t.identity(),
  want: __t.string(),
  fear: __t.string(),
  rotatedAt: __t.timestamp(),
  public: __t.bool(),
});
export type Compass = __Infer<typeof Compass>;

export const ContactBlock = __t.object("ContactBlock", {
  blockId: __t.u64(),
  blocker: __t.identity(),
  blocked: __t.identity(),
  at: __t.timestamp(),
});
export type ContactBlock = __Infer<typeof ContactBlock>;

export const ContactEdge = __t.object("ContactEdge", {
  edgeId: __t.u64(),
  a: __t.identity(),
  b: __t.identity(),
  state: __t.string(),
  at: __t.timestamp(),
  updatedAt: __t.timestamp(),
});
export type ContactEdge = __Infer<typeof ContactEdge>;

export const ContainerItem = __t.object("ContainerItem", {
  entryId: __t.u64(),
  containerId: __t.u64(),
  structureId: __t.u64(),
  kind: __t.string(),
  itemKey: __t.string(),
  name: __t.string(),
  quality: __t.u32(),
  qty: __t.u32(),
  packedJson: __t.string(),
  storedAt: __t.timestamp(),
});
export type ContainerItem = __Infer<typeof ContainerItem>;

export const ContingentRequest = __t.object("ContingentRequest", {
  requestId: __t.u64(),
  civ: __t.string(),
  settlementId: __t.u64(),
  asked: __t.i32(),
  sent: __t.i32(),
  at: __t.timestamp(),
});
export type ContingentRequest = __Infer<typeof ContingentRequest>;

export const Contract = __t.object("Contract", {
  contractId: __t.u64(),
  worldId: __t.u64(),
  assetId: __t.u64(),
  graphJson: __t.string(),
  bytecode: __t.string(),
  bytecodeRef: __t.string(),
  bytecodeSig: __t.string(),
  capsRequested: __t.string(),
  capsGranted: __t.string(),
  cpuBudgetMs: __t.u32(),
  memBudgetKb: __t.u32(),
  state: __t.string(),
  throttleUntil: __t.timestamp(),
  createdAt: __t.timestamp(),
  updatedAt: __t.timestamp(),
});
export type Contract = __Infer<typeof Contract>;

export const ContractEvent = __t.object("ContractEvent", {
  eventId: __t.u64(),
  contractId: __t.u64(),
  worldId: __t.u64(),
  type: __t.string(),
  payload: __t.string(),
  at: __t.timestamp(),
});
export type ContractEvent = __Infer<typeof ContractEvent>;

export const ContractState = __t.object("ContractState", {
  contractId: __t.u64(),
  kv: __t.string(),
});
export type ContractState = __Infer<typeof ContractState>;

export const CouncilAction = __t.object("CouncilAction", {
  actionId: __t.u64(),
  actor: __t.identity(),
  kind: __t.string(),
  target: __t.u64(),
  note: __t.string(),
  at: __t.timestamp(),
});
export type CouncilAction = __Infer<typeof CouncilAction>;

export const CouncilSeat = __t.object("CouncilSeat", {
  seatId: __t.u64(),
  termId: __t.u64(),
  holder: __t.identity(),
  infTotal: __t.i64(),
});
export type CouncilSeat = __Infer<typeof CouncilSeat>;

export const CouncilTerm = __t.object("CouncilTerm", {
  termId: __t.u64(),
  seasonIndex: __t.u32(),
  seats: __t.u8(),
  openedAt: __t.timestamp(),
  closed: __t.bool(),
});
export type CouncilTerm = __Infer<typeof CouncilTerm>;

export const CouncilVote = __t.object("CouncilVote", {
  voteId: __t.u64(),
  termId: __t.u64(),
  voter: __t.identity(),
  candidate: __t.identity(),
  infSpent: __t.i64(),
  at: __t.timestamp(),
});
export type CouncilVote = __Infer<typeof CouncilVote>;

export const CourierCargoLeg = __t.object("CourierCargoLeg", {
  familyKey: __t.string(),
  qty: __t.u32(),
});
export type CourierCargoLeg = __Infer<typeof CourierCargoLeg>;

export const CourierContract = __t.object("CourierContract", {
  contractId: __t.u64(),
  issuer: __t.identity(),
  courier: __t.identity(),
  originKey: __t.string(),
  destKey: __t.string(),
  cargoJson: __t.string(),
  rewardSov: __t.i64(),
  collateralSov: __t.i64(),
  state: __t.string(),
  createdAt: __t.timestamp(),
  acceptedAt: __t.timestamp(),
  expiresAt: __t.timestamp(),
  updatedAt: __t.timestamp(),
});
export type CourierContract = __Infer<typeof CourierContract>;

export const CreatorCert = __t.object("CreatorCert", {
  identity: __t.identity(),
  certified: __t.bool(),
  peerReviews: __t.u32(),
  at: __t.timestamp(),
});
export type CreatorCert = __Infer<typeof CreatorCert>;

export const Creature = __t.object("Creature", {
  creatureId: __t.u64(),
  denKey: __t.string(),
  species: __t.string(),
  x: __t.f32(),
  z: __t.f32(),
  hp: __t.i32(),
  state: __t.string(),
  targetKind: __t.string(),
  targetVersona: __t.u64(),
  targetPlayer: __t.identity(),
  respawnAt: __t.timestamp(),
  updatedAt: __t.timestamp(),
});
export type Creature = __Infer<typeof Creature>;

export const CreditFile = __t.object("CreditFile", {
  identity: __t.identity(),
  onTime: __t.u32(),
  late: __t.u32(),
  defaults: __t.u32(),
  repaidLoans: __t.u32(),
  kindsMask: __t.u32(),
  openedAt: __t.timestamp(),
  lastDefaultAt: __t.timestamp(),
  bannedUntil: __t.timestamp(),
});
export type CreditFile = __Infer<typeof CreditFile>;

export const CrewEpoch = __t.object("CrewEpoch", {
  epochKey: __t.string(),
  epoch: __t.u32(),
});
export type CrewEpoch = __Infer<typeof CrewEpoch>;

export const CrewLease = __t.object("CrewLease", {
  leaseId: __t.u64(),
  shipId: __t.u64(),
  captain: __t.identity(),
  holder: __t.identity(),
  role: __t.string(),
  actions: __t.string(),
  epoch: __t.u32(),
  state: __t.string(),
  endReason: __t.string(),
  kitBudget: __t.u32(),
  kitsUsed: __t.u32(),
  expiresAt: __t.timestamp(),
  graceUntil: __t.timestamp(),
  createdAt: __t.timestamp(),
  updatedAt: __t.timestamp(),
});
export type CrewLease = __Infer<typeof CrewLease>;

export const CrimeCase = __t.object("CrimeCase", {
  caseId: __t.u64(),
  worldId: __t.u64(),
  settlementId: __t.u64(),
  kind: __t.string(),
  accusedId: __t.u64(),
  victimId: __t.u64(),
  witnesses: __t.u32(),
  confidence: __t.u32(),
  status: __t.string(),
  detail: __t.string(),
  openedAt: __t.timestamp(),
  resolvedAt: __t.timestamp(),
});
export type CrimeCase = __Infer<typeof CrimeCase>;

export const DailySettlement = __t.object("DailySettlement", {
  settleId: __t.u64(),
  creator: __t.identity(),
  grossSov: __t.i64(),
  platformCutSov: __t.i64(),
  netSov: __t.i64(),
  forDay: __t.string(),
  at: __t.timestamp(),
});
export type DailySettlement = __Infer<typeof DailySettlement>;

export const DefeatReceipt = __t.object("DefeatReceipt", {
  receiptKey: __t.string(),
  target: __t.identity(),
  life: __t.u32(),
  attacker: __t.identity(),
  attackerKey: __t.string(),
  contextKind: __t.string(),
  contextId: __t.u64(),
  worldId: __t.u64(),
  at: __t.timestamp(),
});
export type DefeatReceipt = __Infer<typeof DefeatReceipt>;

export const DenHull = __t.object("DenHull", {
  hullId: __t.u64(),
  systemId: __t.string(),
  denKey: __t.string(),
  slot: __t.u8(),
  x: __t.f64(),
  y: __t.f64(),
  z: __t.f64(),
  yaw: __t.f64(),
  ai: __t.string(),
  writer: __t.identity(),
  updatedAt: __t.timestamp(),
});
export type DenHull = __Infer<typeof DenHull>;

export const DenHullSeat = __t.object("DenHullSeat", {
  denKey: __t.string(),
  slot: __t.u8(),
  x: __t.f64(),
  y: __t.f64(),
  z: __t.f64(),
  yaw: __t.f64(),
  ai: __t.string(),
});
export type DenHullSeat = __Infer<typeof DenHullSeat>;

export const DenSlot = __t.object("DenSlot", {
  slotId: __t.u64(),
  systemId: __t.string(),
  denKey: __t.string(),
  slot: __t.u8(),
  hp: __t.f64(),
  hpMax: __t.f64(),
  target: __t.identity(),
  engagedAt: __t.timestamp(),
  updatedAt: __t.timestamp(),
});
export type DenSlot = __Infer<typeof DenSlot>;

export const DenState = __t.object("DenState", {
  stateId: __t.u64(),
  systemId: __t.string(),
  denKey: __t.string(),
  alive: __t.u32(),
  capacity: __t.u32(),
  tier: __t.u8(),
  respawnAnchor: __t.timestamp(),
  authorityEpoch: __t.u64(),
  updatedAt: __t.timestamp(),
});
export type DenState = __Infer<typeof DenState>;

export const DepotResupply = __t.object("DepotResupply", {
  structId: __t.u64(),
  owner: __t.identity(),
  lastAt: __t.timestamp(),
  uses: __t.u32(),
});
export type DepotResupply = __Infer<typeof DepotResupply>;

export const DeviceTierHint = __t.object("DeviceTierHint", {
  identity: __t.identity(),
  tier: __t.string(),
});
export type DeviceTierHint = __Infer<typeof DeviceTierHint>;

export const DirectMessage = __t.object("DirectMessage", {
  msgId: __t.u64(),
  sender: __t.identity(),
  senderName: __t.string(),
  target: __t.identity(),
  text: __t.string(),
  nonce: __t.u32(),
  at: __t.timestamp(),
});
export type DirectMessage = __Infer<typeof DirectMessage>;

export const DiscoveryPrefs = __t.object("DiscoveryPrefs", {
  creator: __t.identity(),
  algoOptOut: __t.bool(),
  updatedAt: __t.timestamp(),
});
export type DiscoveryPrefs = __Infer<typeof DiscoveryPrefs>;

export const DisplayNameChange = __t.object("DisplayNameChange", {
  identity: __t.identity(),
  lastChangedAt: __t.timestamp(),
});
export type DisplayNameChange = __Infer<typeof DisplayNameChange>;

export const DroidBrain = __t.object("DroidBrain", {
  droidId: __t.u64(),
  owner: __t.identity(),
  codeJson: __t.string(),
  stateJson: __t.string(),
  line: __t.u32(),
  status: __t.string(),
  err: __t.string(),
  compiledAt: __t.timestamp(),
  updatedAt: __t.timestamp(),
});
export type DroidBrain = __Infer<typeof DroidBrain>;

export const DroidCargo = __t.object("DroidCargo", {
  entryId: __t.u64(),
  droidId: __t.u64(),
  kind: __t.string(),
  itemKey: __t.string(),
  name: __t.string(),
  quality: __t.u32(),
  qty: __t.u32(),
  packedJson: __t.string(),
  priceSov: __t.i64(),
  storedAt: __t.timestamp(),
});
export type DroidCargo = __Infer<typeof DroidCargo>;

export const DroidLog = __t.object("DroidLog", {
  droidId: __t.u64(),
  owner: __t.identity(),
  logJson: __t.string(),
  updatedAt: __t.timestamp(),
});
export type DroidLog = __Infer<typeof DroidLog>;

export const DroidPos = __t.object("DroidPos", {
  droidId: __t.u64(),
  x: __t.f32(),
  z: __t.f32(),
  yaw: __t.f32(),
  stepAt: __t.timestamp(),
  fromAt: __t.timestamp(),
});
export type DroidPos = __Infer<typeof DroidPos>;

export const DroidPurse = __t.object("DroidPurse", {
  droidId: __t.u64(),
  owner: __t.identity(),
  poolMilli: __t.i64(),
  bonusMilli: __t.i64(),
  spentMilli: __t.i64(),
  fundedTotal: __t.i64(),
  salesSov: __t.i64(),
  saleSeq: __t.u32(),
  saleSeen: __t.u32(),
  stepAt: __t.timestamp(),
  updatedAt: __t.timestamp(),
});
export type DroidPurse = __Infer<typeof DroidPurse>;

export const DroidReport = __t.object("DroidReport", {
  reportId: __t.u64(),
  droidId: __t.u64(),
  owner: __t.identity(),
  droidName: __t.string(),
  kind: __t.string(),
  title: __t.string(),
  bodyJson: __t.string(),
  at: __t.timestamp(),
});
export type DroidReport = __Infer<typeof DroidReport>;

export const DroidRoute = __t.object("DroidRoute", {
  droidId: __t.u64(),
  goalX: __t.f32(),
  goalZ: __t.f32(),
  speed: __t.f32(),
  at: __t.timestamp(),
});
export type DroidRoute = __Infer<typeof DroidRoute>;

export const DroidSay = __t.object("DroidSay", {
  sayId: __t.u64(),
  droidId: __t.u64(),
  worldId: __t.u64(),
  x: __t.f32(),
  z: __t.f32(),
  kind: __t.string(),
  text: __t.string(),
  at: __t.timestamp(),
});
export type DroidSay = __Infer<typeof DroidSay>;

export const DroidSource = __t.object("DroidSource", {
  droidId: __t.u64(),
  owner: __t.identity(),
  source: __t.string(),
  updatedAt: __t.timestamp(),
});
export type DroidSource = __Infer<typeof DroidSource>;

export const DroidTick = __t.object("DroidTick", {
  scheduledId: __t.u64(),
  scheduledAt: __t.scheduleAt(),
});
export type DroidTick = __Infer<typeof DroidTick>;

export const DroidUnit = __t.object("DroidUnit", {
  droidId: __t.u64(),
  owner: __t.identity(),
  worldId: __t.u64(),
  kind: __t.string(),
  name: __t.string(),
  quality: __t.u32(),
  posX: __t.f32(),
  posZ: __t.f32(),
  yaw: __t.f32(),
  homeX: __t.f32(),
  homeZ: __t.f32(),
  mode: __t.string(),
  programSrc: __t.string(),
  programJson: __t.string(),
  pc: __t.u32(),
  waitUntilMicros: __t.u64(),
  patrolPhase: __t.f32(),
  logJson: __t.string(),
  packedItemJson: __t.string(),
  deployedAt: __t.timestamp(),
  updatedAt: __t.timestamp(),
});
export type DroidUnit = __Infer<typeof DroidUnit>;

export const DroidUpkeep = __t.object("DroidUpkeep", {
  droidId: __t.u64(),
  bucketsJson: __t.string(),
  updatedAt: __t.timestamp(),
});
export type DroidUpkeep = __Infer<typeof DroidUpkeep>;

export const DroidVitals = __t.object("DroidVitals", {
  droidId: __t.u64(),
  owner: __t.identity(),
  cls: __t.string(),
  hp: __t.f32(),
  maxHp: __t.f32(),
  poolMilli: __t.i64(),
  bonusMilli: __t.i64(),
  spentMilli: __t.i64(),
  fundedTotal: __t.i64(),
  salesSov: __t.i64(),
  saleSeq: __t.u32(),
  saleSeen: __t.u32(),
  hurtSeq: __t.u32(),
  hurtSeen: __t.u32(),
  lastStepAt: __t.timestamp(),
  lastAdvertAt: __t.timestamp(),
  updatedAt: __t.timestamp(),
});
export type DroidVitals = __Infer<typeof DroidVitals>;

export const EconHealth = __t.object("EconHealth", {
  key: __t.string(),
  kind: __t.string(),
  civ: __t.string(),
  label: __t.string(),
  stationKey: __t.string(),
  numbersJson: __t.string(),
  sourcesJson: __t.string(),
  checkedAt: __t.timestamp(),
});
export type EconHealth = __Infer<typeof EconHealth>;

export const ElectionRace = __t.object("ElectionRace", {
  raceId: __t.u64(),
  worldId: __t.u64(),
  settlementId: __t.u64(),
  aId: __t.u64(),
  bId: __t.u64(),
  aFaction: __t.string(),
  bFaction: __t.string(),
  state: __t.string(),
  winnerId: __t.u64(),
  opensAt: __t.timestamp(),
  tallyAt: __t.timestamp(),
  updatedAt: __t.timestamp(),
});
export type ElectionRace = __Infer<typeof ElectionRace>;

export const Entitlement = __t.object("Entitlement", {
  identity: __t.identity(),
  tier: __t.string(),
  worldQuota: __t.u8(),
  priceCapSov: __t.i64(),
  forgeAccess: __t.bool(),
  analytics: __t.bool(),
  updatedAt: __t.timestamp(),
});
export type Entitlement = __Infer<typeof Entitlement>;

export const EscortExtraction = __t.object("EscortExtraction", {
  extractKey: __t.string(),
  campaignId: __t.u64(),
  rosterKey: __t.string(),
  side: __t.u8(),
  cls: __t.string(),
  slot: __t.u32(),
  opId: __t.u64(),
  pilot: __t.identity(),
  state: __t.string(),
  sx: __t.f64(),
  sy: __t.f64(),
  sz: __t.f64(),
  rx: __t.f64(),
  ry: __t.f64(),
  rz: __t.f64(),
  startS: __t.f64(),
  arriveS: __t.f64(),
  dwellMs: __t.u32(),
  withdrawnAt: __t.timestamp(),
  returnHulls: __t.u32(),
  cancelledShots: __t.u32(),
  cause: __t.string(),
  updatedAt: __t.timestamp(),
});
export type EscortExtraction = __Infer<typeof EscortExtraction>;

export const Escrow = __t.object("Escrow", {
  escrowId: __t.u64(),
  txId: __t.u64(),
  payer: __t.identity(),
  payee: __t.identity(),
  amountSov: __t.i64(),
  releaseAt: __t.timestamp(),
  state: __t.string(),
});
export type Escrow = __Infer<typeof Escrow>;

export const EssBank = __t.object("EssBank", {
  bankId: __t.u64(),
  systemKey: __t.string(),
  bankSov: __t.i64(),
  updatedAt: __t.timestamp(),
});
export type EssBank = __Infer<typeof EssBank>;

export const Event = __t.object("Event", {
  eventId: __t.u64(),
  host: __t.identity(),
  worldId: __t.u64(),
  title: __t.string(),
  theme: __t.string(),
  startAt: __t.timestamp(),
  recurrence: __t.string(),
  ticketPriceSov: __t.i64(),
  attendanceTarget: __t.u32(),
  checkedInCount: __t.u32(),
  hostInfPaid: __t.bool(),
  hostBonusPaid: __t.bool(),
  memorialCreated: __t.bool(),
  createdAt: __t.timestamp(),
});
export type Event = __Infer<typeof Event>;

export const EventAttendance = __t.object("EventAttendance", {
  attendanceId: __t.u64(),
  eventId: __t.u64(),
  identity: __t.identity(),
  escrowId: __t.u64(),
  sessionsAttended: __t.u32(),
  checkedIn: __t.bool(),
  lastSessionAt: __t.timestamp(),
  satisfactionRecorded: __t.bool(),
  satisfaction: __t.u8(),
  invitedAt: __t.timestamp(),
  firstSeenAt: __t.timestamp(),
});
export type EventAttendance = __Infer<typeof EventAttendance>;

export const EvidenceSnapshot = __t.object("EvidenceSnapshot", {
  snapId: __t.u64(),
  reportId: __t.u64(),
  kind: __t.string(),
  sender: __t.identity(),
  target: __t.identity(),
  text: __t.string(),
  messageAt: __t.timestamp(),
  at: __t.timestamp(),
});
export type EvidenceSnapshot = __Infer<typeof EvidenceSnapshot>;

export const EwEffect = __t.object("EwEffect", {
  effectId: __t.u64(),
  source: __t.identity(),
  target: __t.identity(),
  systemId: __t.string(),
  sourceShipId: __t.u64(),
  targetShipId: __t.u64(),
  sourceSeq: __t.u32(),
  targetSeq: __t.u32(),
  requestId: __t.string(),
  capSpent: __t.u32(),
  strength: __t.f64(),
  startedAt: __t.timestamp(),
  expiresAt: __t.timestamp(),
  state: __t.string(),
  endedAt: __t.timestamp(),
  endReason: __t.string(),
  farSince: __t.timestamp(),
  sepM: __t.f64(),
  updatedAt: __t.timestamp(),
});
export type EwEffect = __Infer<typeof EwEffect>;

export const EwPilot = __t.object("EwPilot", {
  identity: __t.identity(),
  jamReadyAt: __t.timestamp(),
  burstReadyAt: __t.timestamp(),
  resistUntil: __t.timestamp(),
  reqRing: __t.string(),
  jams: __t.u32(),
  bursts: __t.u32(),
  updatedAt: __t.timestamp(),
});
export type EwPilot = __Infer<typeof EwPilot>;

export const EwSweepJob = __t.object("EwSweepJob", {
  scheduledId: __t.u64(),
  scheduledAt: __t.scheduleAt(),
});
export type EwSweepJob = __Infer<typeof EwSweepJob>;

export const ExchangeOffice = __t.object("ExchangeOffice", {
  settlementId: __t.u64(),
  officeHex: __t.string(),
  dailyInSov: __t.i64(),
  dailyOutSov: __t.i64(),
  dayBucket: __t.u32(),
  updatedAt: __t.timestamp(),
});
export type ExchangeOffice = __Infer<typeof ExchangeOffice>;

export const ExpeditionLog = __t.object("ExpeditionLog", {
  logId: __t.u64(),
  owner: __t.identity(),
  kind: __t.string(),
  systemId: __t.string(),
  sigKey: __t.string(),
  text: __t.string(),
  at: __t.timestamp(),
  published: __t.bool(),
});
export type ExpeditionLog = __Infer<typeof ExpeditionLog>;

export const ExpeditionProfile = __t.object("ExpeditionProfile", {
  identity: __t.identity(),
  isPublic: __t.bool(),
  updatedAt: __t.timestamp(),
});
export type ExpeditionProfile = __Infer<typeof ExpeditionProfile>;

export const ExpeditionPublic = __t.object("ExpeditionPublic", {
  logId: __t.u64(),
  owner: __t.identity(),
  kind: __t.string(),
  systemId: __t.string(),
  day: __t.string(),
  text: __t.string(),
  at: __t.timestamp(),
});
export type ExpeditionPublic = __Infer<typeof ExpeditionPublic>;

export const ExploitAction = __t.object("ExploitAction", {
  eaId: __t.u64(),
  kind: __t.string(),
  subject: __t.identity(),
  worldId: __t.u64(),
  action: __t.string(),
  at: __t.timestamp(),
});
export type ExploitAction = __Infer<typeof ExploitAction>;

export const ExtractorCoreItem = __t.object("ExtractorCoreItem", {
  structureId: __t.u64(),
  packedJson: __t.string(),
  slottedBy: __t.identity(),
});
export type ExtractorCoreItem = __Infer<typeof ExtractorCoreItem>;

export const ExtractorMod = __t.object("ExtractorMod", {
  structureId: __t.u64(),
  coreQuality: __t.u32(),
  slottedAt: __t.timestamp(),
});
export type ExtractorMod = __Infer<typeof ExtractorMod>;

export const ExtractorState = __t.object("ExtractorState", {
  structureId: __t.u64(),
  owner: __t.identity(),
  targetSpawnId: __t.u64(),
  concentration: __t.f32(),
  storedQty: __t.f32(),
  lastAccrueAt: __t.timestamp(),
});
export type ExtractorState = __Infer<typeof ExtractorState>;

export const FabJob = __t.object("FabJob", {
  jobId: __t.u64(),
  owner: __t.identity(),
  stationKey: __t.string(),
  processKey: __t.string(),
  processVersion: __t.u32(),
  profile: __t.string(),
  runs: __t.u32(),
  inputFamily: __t.string(),
  inputName: __t.string(),
  inputStatsJson: __t.string(),
  inputQty: __t.u32(),
  ceiling: __t.u32(),
  durationS: __t.u32(),
  state: __t.string(),
  reservedAt: __t.timestamp(),
  startedAt: __t.timestamp(),
  readyAt: __t.timestamp(),
  endedAt: __t.timestamp(),
  outputsJson: __t.string(),
  note: __t.string(),
});
export type FabJob = __Infer<typeof FabJob>;

export const FaithAdherence = __t.object("FaithAdherence", {
  versonaId: __t.u64(),
  worldId: __t.u64(),
  faithId: __t.string(),
  intensity: __t.u32(),
  updatedAt: __t.timestamp(),
});
export type FaithAdherence = __Infer<typeof FaithAdherence>;

export const FederalBill = __t.object("FederalBill", {
  billId: __t.u64(),
  civ: __t.string(),
  kind: __t.string(),
  value: __t.i32(),
  prior: __t.i32(),
  status: __t.string(),
  round: __t.i32(),
  proposedBy: __t.u64(),
  text: __t.string(),
  yesVotes: __t.i32(),
  noVotes: __t.i32(),
  yesPop: __t.i32(),
  noPop: __t.i32(),
  source: __t.string(),
  openedAt: __t.timestamp(),
  decidesAt: __t.timestamp(),
});
export type FederalBill = __Infer<typeof FederalBill>;

export const FederalBlocVote = __t.object("FederalBlocVote", {
  voteId: __t.u64(),
  billId: __t.u64(),
  settlementId: __t.u64(),
  aye: __t.bool(),
  votes: __t.i32(),
  population: __t.i32(),
});
export type FederalBlocVote = __Infer<typeof FederalBlocVote>;

export const FederalBudget = __t.object("FederalBudget", {
  civ: __t.string(),
  split: __t.string(),
  source: __t.string(),
  say: __t.string(),
  setEpoch: __t.i64(),
  setAt: __t.timestamp(),
});
export type FederalBudget = __Infer<typeof FederalBudget>;

export const FederalChoice = __t.object("FederalChoice", {
  choiceId: __t.u64(),
  civ: __t.string(),
  topic: __t.string(),
  ref: __t.string(),
  optionJson: __t.string(),
  source: __t.string(),
  say: __t.string(),
  at: __t.timestamp(),
});
export type FederalChoice = __Infer<typeof FederalChoice>;

export const FederalCityVote = __t.object("FederalCityVote", {
  voteId: __t.u64(),
  billId: __t.u64(),
  cityId: __t.u64(),
  aye: __t.bool(),
  at: __t.timestamp(),
});
export type FederalCityVote = __Infer<typeof FederalCityVote>;

export const FederalMember = __t.object("FederalMember", {
  settlementId: __t.u64(),
  civ: __t.string(),
  tier: __t.string(),
  votes: __t.i32(),
  population: __t.i32(),
  households: __t.i32(),
  arrears: __t.i64(),
  suspended: __t.bool(),
  crossTrade: __t.i64(),
  defiant: __t.bool(),
  updatedAt: __t.timestamp(),
});
export type FederalMember = __Infer<typeof FederalMember>;

export const FederalOffice = __t.object("FederalOffice", {
  officeId: __t.u64(),
  civ: __t.string(),
  office: __t.string(),
  holderId: __t.u64(),
  holderName: __t.string(),
  settlementId: __t.u64(),
  sinceAt: __t.timestamp(),
});
export type FederalOffice = __Infer<typeof FederalOffice>;

export const FederalPref = __t.object("FederalPref", {
  prefId: __t.u64(),
  billId: __t.u64(),
  voter: __t.identity(),
  settlementId: __t.u64(),
  aye: __t.bool(),
  at: __t.timestamp(),
});
export type FederalPref = __Infer<typeof FederalPref>;

export const FederalPromise = __t.object("FederalPromise", {
  promiseId: __t.u64(),
  civ: __t.string(),
  settlementId: __t.u64(),
  kind: __t.string(),
  billId: __t.u64(),
  dueEpoch: __t.i64(),
  status: __t.string(),
  madeAt: __t.timestamp(),
});
export type FederalPromise = __Infer<typeof FederalPromise>;

export const FederalState = __t.object("FederalState", {
  civ: __t.string(),
  worldId: __t.u64(),
  treasury: __t.i64(),
  speakerId: __t.u64(),
  speakerSid: __t.u64(),
  speakerName: __t.string(),
  speakerSinceEpoch: __t.i64(),
  lastSpeakerId: __t.u64(),
  lastSpeakerUntilEpoch: __t.i64(),
  legitimacy: __t.f32(),
  levyBps: __t.i32(),
  customsBps: __t.i32(),
  sessionEpoch: __t.i64(),
  reserveGrain: __t.f32(),
  drillDay: __t.i32(),
  festivalDay: __t.i32(),
  atWarWith: __t.string(),
  updatedAt: __t.timestamp(),
});
export type FederalState = __Infer<typeof FederalState>;

export const FederalWork = __t.object("FederalWork", {
  workId: __t.u64(),
  civ: __t.string(),
  kind: __t.string(),
  aSid: __t.u64(),
  bSid: __t.u64(),
  progress: __t.f32(),
  target: __t.f32(),
  cost: __t.i64(),
  status: __t.string(),
  startedAt: __t.timestamp(),
  doneAt: __t.timestamp(),
});
export type FederalWork = __Infer<typeof FederalWork>;

export const FeedRank = __t.object("FeedRank", {
  rankPos: __t.u32(),
  worldId: __t.u64(),
  hotScore: __t.f32(),
  refreshedAt: __t.timestamp(),
});
export type FeedRank = __Infer<typeof FeedRank>;

export const FestivalAttendance = __t.object("FestivalAttendance", {
  key: __t.string(),
  epoch: __t.u32(),
  settlementId: __t.u64(),
  identity: __t.identity(),
  seconds: __t.u32(),
  lastPingAt: __t.timestamp(),
  keepsake: __t.bool(),
});
export type FestivalAttendance = __Infer<typeof FestivalAttendance>;

export const FestivalEntry = __t.object("FestivalEntry", {
  key: __t.string(),
  festivalKey: __t.string(),
  identity: __t.identity(),
  name: __t.string(),
  score: __t.f32(),
  label: __t.string(),
  place: __t.u8(),
  at: __t.timestamp(),
});
export type FestivalEntry = __Infer<typeof FestivalEntry>;

export const FestivalKeepsake = __t.object("FestivalKeepsake", {
  key: __t.string(),
  identity: __t.identity(),
  season: __t.string(),
  count: __t.u32(),
  lastAt: __t.timestamp(),
});
export type FestivalKeepsake = __Infer<typeof FestivalKeepsake>;

export const FieldGuide = __t.object("FieldGuide", {
  key: __t.string(),
  identity: __t.identity(),
  kind: __t.string(),
  species: __t.string(),
  count: __t.u32(),
  how: __t.string(),
  best: __t.f32(),
  firstAt: __t.timestamp(),
  lastAt: __t.timestamp(),
});
export type FieldGuide = __Infer<typeof FieldGuide>;

export const FireworkLaunch = __t.object("FireworkLaunch", {
  launchId: __t.u64(),
  worldId: __t.u64(),
  x: __t.f32(),
  y: __t.f32(),
  z: __t.f32(),
  kind: __t.string(),
  palette: __t.u8(),
  seed: __t.u32(),
  by: __t.identity(),
  at: __t.timestamp(),
});
export type FireworkLaunch = __Infer<typeof FireworkLaunch>;

export const FirmConsignment = __t.object("FirmConsignment", {
  consignId: __t.u64(),
  shipmentId: __t.u64(),
  firmId: __t.u64(),
  orderId: __t.u64(),
  buyer: __t.identity(),
  stationKey: __t.string(),
  familyKey: __t.string(),
  priceSov: __t.i64(),
  qty: __t.u32(),
  escrowSov: __t.i64(),
  state: __t.string(),
  createdAt: __t.timestamp(),
  updatedAt: __t.timestamp(),
});
export type FirmConsignment = __Infer<typeof FirmConsignment>;

export const FirmPlan = __t.object("FirmPlan", {
  firmId: __t.u64(),
  epoch: __t.u64(),
  cyc: __t.u64(),
  chosen: __t.string(),
  toKey: __t.string(),
  qty: __t.u32(),
  netSov: __t.i64(),
  perMinX100: __t.i64(),
  pLossX1000: __t.u32(),
  pLossLoX1000: __t.u32(),
  pLossHiX1000: __t.u32(),
  lost: __t.u32(),
  arrived: __t.u32(),
  rowsJson: __t.string(),
  stopReason: __t.string(),
  shipmentId: __t.u64(),
  decidedAt: __t.timestamp(),
});
export type FirmPlan = __Infer<typeof FirmPlan>;

export const FirmPolicy = __t.object("FirmPolicy", {
  firmId: __t.u64(),
  runs: __t.bool(),
  escortMult: __t.f64(),
  reason: __t.string(),
  runsLost: __t.u32(),
  runsArrived: __t.u32(),
  updatedAt: __t.timestamp(),
});
export type FirmPolicy = __Infer<typeof FirmPolicy>;

export const FishingCast = __t.object("FishingCast", {
  identity: __t.identity(),
  worldId: __t.u64(),
  water: __t.string(),
  x: __t.f32(),
  z: __t.f32(),
  species: __t.string(),
  cm: __t.f32(),
  castAt: __t.timestamp(),
  biteAt: __t.timestamp(),
});
export type FishingCast = __Infer<typeof FishingCast>;

export const FishingRoll = __t.object("FishingRoll", {
  identity: __t.identity(),
  species: __t.string(),
  cm: __t.f32(),
});
export type FishingRoll = __Infer<typeof FishingRoll>;

export const ForgeArtifact = __t.object("ForgeArtifact", {
  artifactId: __t.u64(),
  buildId: __t.u64(),
  kind: __t.string(),
  minioRef: __t.string(),
  checksum: __t.string(),
  content: __t.string(),
});
export type ForgeArtifact = __Infer<typeof ForgeArtifact>;

export const ForgeBuild = __t.object("ForgeBuild", {
  buildId: __t.u64(),
  projectId: __t.u64(),
  jobId: __t.u64(),
  bytecode: __t.string(),
  bytecodeHash: __t.string(),
  sig: __t.string(),
  signed: __t.bool(),
  verified: __t.bool(),
  verifiedAt: __t.timestamp(),
  createdAt: __t.timestamp(),
  publishedAt: __t.timestamp(),
});
export type ForgeBuild = __Infer<typeof ForgeBuild>;

export const ForgeCompileJob = __t.object("ForgeCompileJob", {
  jobId: __t.u64(),
  projectId: __t.u64(),
  status: __t.string(),
  buildId: __t.u64(),
  diagnostics: __t.string(),
  startedAt: __t.timestamp(),
  finishedAt: __t.timestamp(),
});
export type ForgeCompileJob = __Infer<typeof ForgeCompileJob>;

export const ForgeInstance = __t.object("ForgeInstance", {
  instanceId: __t.u64(),
  projectId: __t.u64(),
  parentId: __t.u64(),
  kind: __t.string(),
  transform: __t.string(),
  props: __t.string(),
  assetId: __t.u64(),
  createdAt: __t.timestamp(),
});
export type ForgeInstance = __Infer<typeof ForgeInstance>;

export const ForgeProject = __t.object("ForgeProject", {
  projectId: __t.u64(),
  owner: __t.identity(),
  worldId: __t.u64(),
  sdkVersion: __t.string(),
  fidelityTier: __t.u8(),
  status: __t.string(),
  createdAt: __t.timestamp(),
  updatedAt: __t.timestamp(),
});
export type ForgeProject = __Infer<typeof ForgeProject>;

export const ForgeRelease = __t.object("ForgeRelease", {
  releaseId: __t.u64(),
  projectId: __t.u64(),
  buildId: __t.u64(),
  version: __t.u32(),
  channel: __t.string(),
  monetized: __t.bool(),
  priceSov: __t.i64(),
  passId: __t.u64(),
  publishedAt: __t.timestamp(),
  publishedBy: __t.identity(),
});
export type ForgeRelease = __Infer<typeof ForgeRelease>;

export const ForgeScene = __t.object("ForgeScene", {
  sceneId: __t.u64(),
  projectId: __t.u64(),
  rootInstanceId: __t.u64(),
});
export type ForgeScene = __Infer<typeof ForgeScene>;

export const ForgeScript = __t.object("ForgeScript", {
  scriptId: __t.u64(),
  projectId: __t.u64(),
  instanceId: __t.u64(),
  source: __t.string(),
  capsRequested: __t.string(),
  capsValid: __t.bool(),
  createdAt: __t.timestamp(),
  updatedAt: __t.timestamp(),
});
export type ForgeScript = __Infer<typeof ForgeScript>;

export const ForgeValidation = __t.object("ForgeValidation", {
  validationId: __t.u64(),
  jobId: __t.u64(),
  buildId: __t.u64(),
  capsManifest: __t.string(),
  lintReport: __t.string(),
  typeReport: __t.string(),
  passed: __t.bool(),
  at: __t.timestamp(),
});
export type ForgeValidation = __Infer<typeof ForgeValidation>;

export const ForkBallot = __t.object("ForkBallot", {
  ballotId: __t.u64(),
  forkId: __t.u64(),
  voter: __t.identity(),
  yes: __t.bool(),
  at: __t.timestamp(),
});
export type ForkBallot = __Infer<typeof ForkBallot>;

export const ForkVote = __t.object("ForkVote", {
  forkId: __t.u64(),
  groupId: __t.u64(),
  initiator: __t.identity(),
  faction: __t.string(),
  openedAt: __t.timestamp(),
  closesAt: __t.timestamp(),
  passed: __t.bool(),
  resolved: __t.bool(),
});
export type ForkVote = __Infer<typeof ForkVote>;

export const FreelanceKillCredit = __t.object("FreelanceKillCredit", {
  bountyId: __t.u64(),
  identity: __t.identity(),
  pirateKey: __t.string(),
  at: __t.timestamp(),
});
export type FreelanceKillCredit = __Infer<typeof FreelanceKillCredit>;

export const FreelanceProject = __t.object("FreelanceProject", {
  projectId: __t.u64(),
  issuer: __t.identity(),
  title: __t.string(),
  kind: __t.string(),
  targetKey: __t.string(),
  goal: __t.u32(),
  rewardPerSov: __t.i64(),
  budgetSov: __t.i64(),
  paidSov: __t.i64(),
  progress: __t.u32(),
  state: __t.string(),
  createdAt: __t.timestamp(),
  expiresAt: __t.timestamp(),
});
export type FreelanceProject = __Infer<typeof FreelanceProject>;

export const FunctionLedger = __t.object("FunctionLedger", {
  fnLedgerId: __t.u64(),
  settlementId: __t.u64(),
  fn: __t.string(),
  cash: __t.i64(),
  revenueDay: __t.i64(),
  wageBillDay: __t.i64(),
  dayBucket: __t.u32(),
  updatedAt: __t.timestamp(),
});
export type FunctionLedger = __Infer<typeof FunctionLedger>;

export const GamePass = __t.object("GamePass", {
  passId: __t.u64(),
  worldId: __t.u64(),
  creator: __t.identity(),
  priceSov: __t.i64(),
  grants: __t.string(),
  createdAt: __t.timestamp(),
});
export type GamePass = __Infer<typeof GamePass>;

export const GamePassOwner = __t.object("GamePassOwner", {
  ownerRowId: __t.u64(),
  passId: __t.u64(),
  owner: __t.identity(),
  at: __t.timestamp(),
});
export type GamePassOwner = __Infer<typeof GamePassOwner>;

export const GameSession = __t.object("GameSession", {
  sessionId: __t.u64(),
  gameId: __t.u64(),
  worldId: __t.u64(),
  state: __t.string(),
  startedAt: __t.timestamp(),
  endedAt: __t.timestamp(),
});
export type GameSession = __Infer<typeof GameSession>;

export const GovernanceAudit = __t.object("GovernanceAudit", {
  auditId: __t.u64(),
  worldId: __t.u64(),
  actor: __t.identity(),
  change: __t.string(),
  at: __t.timestamp(),
});
export type GovernanceAudit = __Infer<typeof GovernanceAudit>;

export const Grave = __t.object("Grave", {
  graveId: __t.u64(),
  worldId: __t.u64(),
  settlementId: __t.u64(),
  versonaId: __t.u64(),
  name: __t.string(),
  cause: __t.string(),
  x: __t.f32(),
  z: __t.f32(),
  epitaph: __t.string(),
  diedAt: __t.timestamp(),
});
export type Grave = __Infer<typeof Grave>;

export const GroundContract = __t.object("GroundContract", {
  contractId: __t.u64(),
  kind: __t.string(),
  issuerKind: __t.string(),
  issuer: __t.identity(),
  originSid: __t.u64(),
  destSid: __t.u64(),
  title: __t.string(),
  note: __t.string(),
  reward: __t.i64(),
  collateral: __t.i64(),
  commodity: __t.string(),
  qty: __t.u32(),
  delivered: __t.u32(),
  caravanId: __t.u64(),
  recipient: __t.identity(),
  state: __t.string(),
  taker: __t.identity(),
  takenAt: __t.timestamp(),
  hours: __t.u32(),
  deadline: __t.timestamp(),
  postedAt: __t.timestamp(),
  updatedAt: __t.timestamp(),
});
export type GroundContract = __Infer<typeof GroundContract>;

export const GroundEscort = __t.object("GroundEscort", {
  contractId: __t.u64(),
  samples: __t.u32(),
  near: __t.u32(),
  lastAt: __t.timestamp(),
});
export type GroundEscort = __Infer<typeof GroundEscort>;

export const GroundParcel = __t.object("GroundParcel", {
  parcelId: __t.u64(),
  contractId: __t.u64(),
  issuer: __t.identity(),
  taker: __t.identity(),
  recipient: __t.identity(),
  kind: __t.string(),
  itemKey: __t.string(),
  name: __t.string(),
  qty: __t.u32(),
  packedJson: __t.string(),
  holder: __t.string(),
});
export type GroundParcel = __Infer<typeof GroundParcel>;

export const GroundWar = __t.object("GroundWar", {
  warId: __t.u64(),
  attackerKind: __t.string(),
  attackerId: __t.u64(),
  attackerName: __t.string(),
  defenderKind: __t.string(),
  defenderId: __t.u64(),
  defenderName: __t.string(),
  declaredBy: __t.identity(),
  state: __t.string(),
  stakeA: __t.i64(),
  stakeB: __t.i64(),
  scoreA: __t.u32(),
  scoreB: __t.u32(),
  result: __t.string(),
  peaceA: __t.bool(),
  peaceB: __t.bool(),
  lastBannerA: __t.timestamp(),
  lastBannerB: __t.timestamp(),
  declaredAt: __t.timestamp(),
  activeAt: __t.timestamp(),
  endsAt: __t.timestamp(),
  endedAt: __t.timestamp(),
});
export type GroundWar = __Infer<typeof GroundWar>;

export const GroundWarEvent = __t.object("GroundWarEvent", {
  eventId: __t.u64(),
  warId: __t.u64(),
  kind: __t.string(),
  text: __t.string(),
  at: __t.timestamp(),
});
export type GroundWarEvent = __Infer<typeof GroundWarEvent>;

export const GroundWarStake = __t.object("GroundWarStake", {
  stakeKey: __t.string(),
  warId: __t.u64(),
  side: __t.string(),
  payer: __t.identity(),
  at: __t.timestamp(),
});
export type GroundWarStake = __Infer<typeof GroundWarStake>;

export const Group = __t.object("Group", {
  groupId: __t.u64(),
  name: __t.string(),
  charterRef: __t.string(),
  hallWorldId: __t.u64(),
  treasurySov: __t.i64(),
  state: __t.string(),
  reviewUntil: __t.timestamp(),
  createdAt: __t.timestamp(),
});
export type Group = __Infer<typeof Group>;

export const GroupMember = __t.object("GroupMember", {
  memberId: __t.u64(),
  groupId: __t.u64(),
  identity: __t.identity(),
  role: __t.string(),
  joinedAt: __t.timestamp(),
});
export type GroupMember = __Infer<typeof GroupMember>;

export const GroupSignature = __t.object("GroupSignature", {
  signatureId: __t.u64(),
  groupId: __t.u64(),
  signer: __t.identity(),
  at: __t.timestamp(),
});
export type GroupSignature = __Infer<typeof GroupSignature>;

export const GroupSrp = __t.object("GroupSrp", {
  groupId: __t.u64(),
  enabled: __t.bool(),
  capSov: __t.i64(),
  updatedAt: __t.timestamp(),
});
export type GroupSrp = __Infer<typeof GroupSrp>;

export const GuideAward = __t.object("GuideAward", {
  key: __t.string(),
  at: __t.timestamp(),
});
export type GuideAward = __Infer<typeof GuideAward>;

export const GuideMessage = __t.object("GuideMessage", {
  msgId: __t.u64(),
  identity: __t.identity(),
  beat: __t.string(),
  body: __t.string(),
  sentAt: __t.timestamp(),
});
export type GuideMessage = __Infer<typeof GuideMessage>;

export const Guild = __t.object("Guild", {
  guildId: __t.u64(),
  hallStructureId: __t.u64(),
  name: __t.string(),
  tag: __t.string(),
  founder: __t.identity(),
  leaderId: __t.identity(),
  motd: __t.string(),
  createdAt: __t.timestamp(),
});
export type Guild = __Infer<typeof Guild>;

export const GuildApplication = __t.object("GuildApplication", {
  appKey: __t.string(),
  guildId: __t.u64(),
  applicant: __t.identity(),
  note: __t.string(),
  at: __t.timestamp(),
});
export type GuildApplication = __Infer<typeof GuildApplication>;

export const GuildCandidate = __t.object("GuildCandidate", {
  guildCandidateId: __t.u64(),
  guildElectionId: __t.u64(),
  identity: __t.identity(),
  pitch: __t.string(),
  at: __t.timestamp(),
});
export type GuildCandidate = __Infer<typeof GuildCandidate>;

export const GuildCourt = __t.object("GuildCourt", {
  guildId: __t.u64(),
  masterTermEnds: __t.timestamp(),
  councilTermEnds: __t.timestamp(),
  seats: __t.u32(),
  policy: __t.string(),
  updatedAt: __t.timestamp(),
});
export type GuildCourt = __Infer<typeof GuildCourt>;

export const GuildElection = __t.object("GuildElection", {
  guildElectionId: __t.u64(),
  guildId: __t.u64(),
  office: __t.string(),
  opensAt: __t.timestamp(),
  closesAt: __t.timestamp(),
  resolved: __t.bool(),
  winner: __t.identity(),
});
export type GuildElection = __Infer<typeof GuildElection>;

export const GuildMember = __t.object("GuildMember", {
  guildMemberId: __t.u64(),
  guildId: __t.u64(),
  identity: __t.identity(),
  title: __t.string(),
  joinedAt: __t.timestamp(),
});
export type GuildMember = __Infer<typeof GuildMember>;

export const GuildMotion = __t.object("GuildMotion", {
  motionId: __t.u64(),
  guildId: __t.u64(),
  kind: __t.string(),
  target: __t.identity(),
  amount: __t.i64(),
  text: __t.string(),
  proposer: __t.identity(),
  opensAt: __t.timestamp(),
  closesAt: __t.timestamp(),
  status: __t.string(),
  yes: __t.u32(),
  no: __t.u32(),
  outcome: __t.string(),
});
export type GuildMotion = __Infer<typeof GuildMotion>;

export const GuildMotionVote = __t.object("GuildMotionVote", {
  voteKey: __t.string(),
  motionId: __t.u64(),
  voter: __t.identity(),
  yes: __t.bool(),
  at: __t.timestamp(),
});
export type GuildMotionVote = __Infer<typeof GuildMotionVote>;

export const GuildStore = __t.object("GuildStore", {
  gsId: __t.u64(),
  guildId: __t.u64(),
  key: __t.string(),
  qty: __t.u32(),
  updatedAt: __t.timestamp(),
});
export type GuildStore = __Infer<typeof GuildStore>;

export const GuildStructure = __t.object("GuildStructure", {
  structureId: __t.u64(),
  guildId: __t.u64(),
  placedBy: __t.identity(),
  structureType: __t.string(),
  at: __t.timestamp(),
});
export type GuildStructure = __Infer<typeof GuildStructure>;

export const GuildTerritory = __t.object("GuildTerritory", {
  territoryKey: __t.string(),
  kind: __t.string(),
  guildId: __t.u64(),
  worldId: __t.u64(),
  x: __t.f64(),
  z: __t.f64(),
  tier: __t.u32(),
  radius: __t.f32(),
  upkeepDueAt: __t.timestamp(),
  upkeepNote: __t.string(),
  createdAt: __t.timestamp(),
  updatedAt: __t.timestamp(),
});
export type GuildTerritory = __Infer<typeof GuildTerritory>;

export const GuildVersona = __t.object("GuildVersona", {
  gvId: __t.u64(),
  guildId: __t.u64(),
  versonaId: __t.u64(),
  worldId: __t.u64(),
  job: __t.string(),
  recruitedBy: __t.identity(),
  lastWorkEpoch: __t.u64(),
  recruitedAt: __t.timestamp(),
  updatedAt: __t.timestamp(),
});
export type GuildVersona = __Infer<typeof GuildVersona>;

export const GuildVote = __t.object("GuildVote", {
  guildVoteId: __t.u64(),
  guildElectionId: __t.u64(),
  voter: __t.identity(),
  candidate: __t.identity(),
  at: __t.timestamp(),
});
export type GuildVote = __Infer<typeof GuildVote>;

export const GuildWar = __t.object("GuildWar", {
  gwId: __t.u64(),
  guildA: __t.u64(),
  guildB: __t.u64(),
  declaredBy: __t.identity(),
  state: __t.string(),
  declaredAt: __t.timestamp(),
  endsAt: __t.timestamp(),
});
export type GuildWar = __Infer<typeof GuildWar>;

export const Household = __t.object("Household", {
  householdId: __t.u64(),
  worldId: __t.u64(),
  settlementId: __t.u64(),
  surname: __t.string(),
  headId: __t.u64(),
  dwellingIdx: __t.u32(),
  updatedAt: __t.timestamp(),
});
export type Household = __Infer<typeof Household>;

export const HouseholdMember = __t.object("HouseholdMember", {
  memberId: __t.u64(),
  householdId: __t.u64(),
  versonaId: __t.u64(),
});
export type HouseholdMember = __Infer<typeof HouseholdMember>;

export const IncursionState = __t.object("IncursionState", {
  stateId: __t.u64(),
  epoch: __t.u64(),
  systemId: __t.string(),
  grip: __t.i32(),
  bossDown: __t.bool(),
  updatedAt: __t.timestamp(),
});
export type IncursionState = __Infer<typeof IncursionState>;

export const InstanceGroup = __t.object("InstanceGroup", {
  groupId: __t.u64(),
  worldId: __t.u64(),
  regionX: __t.i32(),
  regionZ: __t.i32(),
  assetId: __t.u64(),
  renderMode: __t.string(),
});
export type InstanceGroup = __Infer<typeof InstanceGroup>;

export const IntelLicence = __t.object("IntelLicence", {
  licenceId: __t.u64(),
  offerId: __t.u64(),
  seller: __t.identity(),
  buyer: __t.identity(),
  sigKey: __t.string(),
  systemId: __t.string(),
  scope: __t.string(),
  observedAt: __t.timestamp(),
  price: __t.i64(),
  at: __t.timestamp(),
});
export type IntelLicence = __Infer<typeof IntelLicence>;

export const IntelOffer = __t.object("IntelOffer", {
  offerId: __t.u64(),
  seller: __t.identity(),
  sigKey: __t.string(),
  systemId: __t.string(),
  kind: __t.string(),
  scope: __t.string(),
  evidence: __t.string(),
  observedAt: __t.timestamp(),
  price: __t.i64(),
  state: __t.string(),
  sold: __t.u32(),
  createdAt: __t.timestamp(),
  updatedAt: __t.timestamp(),
});
export type IntelOffer = __Infer<typeof IntelOffer>;

export const InteriorMarker = __t.object("InteriorMarker", {
  markerId: __t.u64(),
  worldId: __t.u64(),
  refKind: __t.string(),
  refId: __t.u64(),
  createdBy: __t.identity(),
  createdAt: __t.timestamp(),
});
export type InteriorMarker = __Infer<typeof InteriorMarker>;

export const InteriorOccupant = __t.object("InteriorOccupant", {
  identity: __t.identity(),
  buildingId: __t.string(),
  floor: __t.u32(),
  updatedAt: __t.timestamp(),
});
export type InteriorOccupant = __Infer<typeof InteriorOccupant>;

export const InventoryItem = __t.object("InventoryItem", {
  itemId: __t.u64(),
  owner: __t.identity(),
  assetId: __t.u64(),
  nextOwnerCopy: __t.bool(),
  nextOwnerModify: __t.bool(),
  nextOwnerTransfer: __t.bool(),
  acquiredAt: __t.timestamp(),
});
export type InventoryItem = __Infer<typeof InventoryItem>;

export const InviteRedeem = __t.object("InviteRedeem", {
  key: __t.string(),
  identity: __t.identity(),
  at: __t.timestamp(),
});
export type InviteRedeem = __Infer<typeof InviteRedeem>;

export const JobSlot = __t.object("JobSlot", {
  slotId: __t.u64(),
  settlementId: __t.u64(),
  fn: __t.string(),
  recipeKey: __t.string(),
  wage: __t.i32(),
  minSkill: __t.f32(),
  holderId: __t.u64(),
  updatedAt: __t.timestamp(),
});
export type JobSlot = __Infer<typeof JobSlot>;

export const KillRecord = __t.object("KillRecord", {
  killId: __t.u64(),
  victim: __t.identity(),
  victimName: __t.string(),
  chassisKey: __t.string(),
  shipName: __t.string(),
  systemKey: __t.string(),
  attackerKind: __t.string(),
  attackerRef: __t.string(),
  lostCompsJson: __t.string(),
  valueSov: __t.i64(),
  at: __t.timestamp(),
});
export type KillRecord = __Infer<typeof KillRecord>;

export const Kinship = __t.object("Kinship", {
  kinId: __t.u64(),
  worldId: __t.u64(),
  aId: __t.u64(),
  bId: __t.u64(),
  kind: __t.string(),
  establishedAt: __t.timestamp(),
});
export type Kinship = __Infer<typeof Kinship>;

export const Leaderboard = __t.object("Leaderboard", {
  lbId: __t.u64(),
  gameId: __t.u64(),
  player: __t.identity(),
  bestScore: __t.i64(),
  rank: __t.u32(),
  updatedAt: __t.timestamp(),
});
export type Leaderboard = __Infer<typeof Leaderboard>;

export const LeaderboardSnapshot = __t.object("LeaderboardSnapshot", {
  snapshotId: __t.u64(),
  gameId: __t.u64(),
  seasonId: __t.u64(),
  seasonNum: __t.u32(),
  topJson: __t.string(),
  at: __t.timestamp(),
});
export type LeaderboardSnapshot = __Infer<typeof LeaderboardSnapshot>;

export const LedgerEntry = __t.object("LedgerEntry", {
  entryId: __t.u64(),
  txId: __t.u64(),
  account: __t.identity(),
  currency: __t.string(),
  delta: __t.i64(),
  reason: __t.string(),
  ref: __t.string(),
  at: __t.timestamp(),
});
export type LedgerEntry = __Infer<typeof LedgerEntry>;

export const LedgerTx = __t.object("LedgerTx", {
  txId: __t.u64(),
  reason: __t.string(),
  initiator: __t.identity(),
  at: __t.timestamp(),
});
export type LedgerTx = __Infer<typeof LedgerTx>;

export const LegacyGrant = __t.object("LegacyGrant", {
  worldId: __t.u64(),
  grantedAt: __t.timestamp(),
  subsidyPct: __t.u8(),
  deleteProtected: __t.bool(),
});
export type LegacyGrant = __Infer<typeof LegacyGrant>;

export const Linkset = __t.object("Linkset", {
  linksetId: __t.u64(),
  worldId: __t.u64(),
  rootPartId: __t.u64(),
  owner: __t.identity(),
});
export type Linkset = __Infer<typeof Linkset>;

export const LivingEvent = __t.object("LivingEvent", {
  eventId: __t.u64(),
  worldId: __t.u64(),
  settlementId: __t.u64(),
  kind: __t.string(),
  family: __t.string(),
  x: __t.f32(),
  z: __t.f32(),
  hostId: __t.u64(),
  title: __t.string(),
  detail: __t.string(),
  participantsJson: __t.string(),
  startsAt: __t.timestamp(),
  endsAt: __t.timestamp(),
  phase: __t.string(),
  refId: __t.u64(),
});
export type LivingEvent = __Infer<typeof LivingEvent>;

export const LotBudget = __t.object("LotBudget", {
  identity: __t.identity(),
  lotsTotal: __t.u8(),
  lotsUsed: __t.u8(),
});
export type LotBudget = __Infer<typeof LotBudget>;

export const MarketBookRev = __t.object("MarketBookRev", {
  key: __t.string(),
  stationKey: __t.string(),
  familyKey: __t.string(),
  rev: __t.u64(),
  updatedAt: __t.timestamp(),
});
export type MarketBookRev = __Infer<typeof MarketBookRev>;

export const MarketFill = __t.object("MarketFill", {
  fillId: __t.u64(),
  stationKey: __t.string(),
  familyKey: __t.string(),
  priceSov: __t.i64(),
  qty: __t.u32(),
  buyer: __t.identity(),
  seller: __t.identity(),
  via: __t.string(),
  at: __t.timestamp(),
});
export type MarketFill = __Infer<typeof MarketFill>;

export const MarketLink = __t.object("MarketLink", {
  settlementId: __t.u64(),
  citySid: __t.u64(),
  trips: __t.i32(),
  since: __t.timestamp(),
});
export type MarketLink = __Infer<typeof MarketLink>;

export const MarketListing = __t.object("MarketListing", {
  listingId: __t.u64(),
  seller: __t.identity(),
  assetId: __t.u64(),
  priceSov: __t.i64(),
  active: __t.bool(),
  listedAt: __t.timestamp(),
});
export type MarketListing = __Infer<typeof MarketListing>;

export const MarketObservation = __t.object("MarketObservation", {
  stationKey: __t.string(),
  observedAt: __t.timestamp(),
  families: __t.u32(),
});
export type MarketObservation = __Infer<typeof MarketObservation>;

export const MarketOrder = __t.object("MarketOrder", {
  orderId: __t.u64(),
  owner: __t.identity(),
  stationKey: __t.string(),
  side: __t.string(),
  familyKey: __t.string(),
  priceSov: __t.i64(),
  qty: __t.u32(),
  placedAt: __t.timestamp(),
  expiresAt: __t.timestamp(),
});
export type MarketOrder = __Infer<typeof MarketOrder>;

export const MarketReceipt = __t.object("MarketReceipt", {
  receiptId: __t.u64(),
  owner: __t.identity(),
  actor: __t.identity(),
  kind: __t.string(),
  stationKey: __t.string(),
  familyKey: __t.string(),
  requested: __t.u32(),
  filled: __t.u32(),
  costSov: __t.i64(),
  brokerSov: __t.i64(),
  escrowSov: __t.i64(),
  refundSov: __t.i64(),
  detailJson: __t.string(),
  note: __t.string(),
  at: __t.timestamp(),
});
export type MarketReceipt = __Infer<typeof MarketReceipt>;

export const MarketRound = __t.object("MarketRound", {
  roundId: __t.u64(),
  settlementId: __t.u64(),
  commodity: __t.string(),
  avgPrice: __t.f32(),
  volume: __t.i32(),
  unfilled: __t.i32(),
  epoch: __t.u32(),
  at: __t.timestamp(),
});
export type MarketRound = __Infer<typeof MarketRound>;

export const MarketSummary = __t.object("MarketSummary", {
  key: __t.string(),
  stationKey: __t.string(),
  familyKey: __t.string(),
  bestBid: __t.i64(),
  bidUnits: __t.u32(),
  bidOrders: __t.u32(),
  bestAsk: __t.i64(),
  askUnits: __t.u32(),
  askOrders: __t.u32(),
  levelsJson: __t.string(),
  bookRev: __t.u64(),
  fills: __t.u32(),
  pairs: __t.u32(),
  excluded: __t.u32(),
  medianSov: __t.i64(),
  vwapX100: __t.i64(),
  changedAt: __t.timestamp(),
});
export type MarketSummary = __Infer<typeof MarketSummary>;

export const MatchEvent = __t.object("MatchEvent", {
  eventId: __t.u64(),
  sessionId: __t.u64(),
  player: __t.identity(),
  seq: __t.u32(),
  nonce: __t.string(),
  ts: __t.timestamp(),
  intent: __t.string(),
});
export type MatchEvent = __Infer<typeof MatchEvent>;

export const MatchParticipant = __t.object("MatchParticipant", {
  participantId: __t.u64(),
  sessionId: __t.u64(),
  gameId: __t.u64(),
  player: __t.identity(),
  team: __t.u8(),
});
export type MatchParticipant = __Infer<typeof MatchParticipant>;

export const MatchProposal = __t.object("MatchProposal", {
  proposalId: __t.u64(),
  gameId: __t.u64(),
  tickets: __t.string(),
  quality: __t.f32(),
  accepted: __t.bool(),
  sessionId: __t.u64(),
  at: __t.timestamp(),
});
export type MatchProposal = __Infer<typeof MatchProposal>;

export const MatchResult = __t.object("MatchResult", {
  sessionId: __t.u64(),
  gameId: __t.u64(),
  placements: __t.string(),
  rated: __t.bool(),
  at: __t.timestamp(),
});
export type MatchResult = __Infer<typeof MatchResult>;

export const MatchScore = __t.object("MatchScore", {
  scoreId: __t.u64(),
  sessionId: __t.u64(),
  player: __t.identity(),
  score: __t.i64(),
  placement: __t.u32(),
});
export type MatchScore = __Infer<typeof MatchScore>;

export const MatchTicket = __t.object("MatchTicket", {
  ticketId: __t.u64(),
  gameId: __t.u64(),
  player: __t.identity(),
  skill: __t.f32(),
  sigma: __t.f32(),
  region: __t.string(),
  partyId: __t.u64(),
  queuedAt: __t.timestamp(),
  matched: __t.bool(),
});
export type MatchTicket = __Infer<typeof MatchTicket>;

export const MatchVerdict = __t.object("MatchVerdict", {
  sessionId: __t.u64(),
  scored: __t.bool(),
  verified: __t.bool(),
  excluded: __t.bool(),
  at: __t.timestamp(),
});
export type MatchVerdict = __Infer<typeof MatchVerdict>;

export const MayorAudit = __t.object("MayorAudit", {
  auditId: __t.u64(),
  settlementId: __t.u64(),
  mayorId: __t.u64(),
  mayorName: __t.string(),
  verdict: __t.string(),
  note: __t.string(),
  at: __t.timestamp(),
});
export type MayorAudit = __Infer<typeof MayorAudit>;

export const MayorElection = __t.object("MayorElection", {
  electionId: __t.u64(),
  cityId: __t.u64(),
  opensAt: __t.timestamp(),
  closesAt: __t.timestamp(),
  winner: __t.identity(),
  resolved: __t.bool(),
});
export type MayorElection = __Infer<typeof MayorElection>;

export const MayorRecord = __t.object("MayorRecord", {
  recId: __t.u64(),
  worldId: __t.u64(),
  settlementId: __t.u64(),
  mayorId: __t.u64(),
  termStartAt: __t.timestamp(),
  treasuryStart: __t.i64(),
  lawsPassed: __t.u32(),
  warsWon: __t.u32(),
  warsLost: __t.u32(),
  famineEpochs: __t.u32(),
  updatedAt: __t.timestamp(),
});
export type MayorRecord = __Infer<typeof MayorRecord>;

export const MayorVote = __t.object("MayorVote", {
  voteId: __t.u64(),
  electionId: __t.u64(),
  voter: __t.identity(),
  candidate: __t.identity(),
  at: __t.timestamp(),
});
export type MayorVote = __Infer<typeof MayorVote>;

export const MemoryEntry = __t.object("MemoryEntry", {
  entryId: __t.u64(),
  kind: __t.string(),
  ref: __t.string(),
  author: __t.identity(),
  text: __t.string(),
  mediaRef: __t.string(),
  permanent: __t.bool(),
  expiresAt: __t.timestamp(),
  worldId: __t.u64(),
  at: __t.timestamp(),
});
export type MemoryEntry = __Infer<typeof MemoryEntry>;

export const MemoryProvenance = __t.object("MemoryProvenance", {
  memoryId: __t.u64(),
  versonaId: __t.u64(),
  tellerId: __t.u64(),
  originId: __t.u64(),
  originAt: __t.timestamp(),
  hops: __t.u8(),
  confidence: __t.u8(),
});
export type MemoryProvenance = __Infer<typeof MemoryProvenance>;

export const MerchantHold = __t.object("MerchantHold", {
  holdId: __t.u64(),
  listingId: __t.u64(),
  versonaId: __t.u64(),
  identity: __t.identity(),
  qty: __t.u32(),
  expiresTick: __t.u64(),
});
export type MerchantHold = __Infer<typeof MerchantHold>;

export const MerchantListing = __t.object("MerchantListing", {
  listingId: __t.u64(),
  lotId: __t.u64(),
  label: __t.string(),
  detail: __t.string(),
  priceSov: __t.i64(),
  stock: __t.i32(),
  updatedAt: __t.timestamp(),
});
export type MerchantListing = __Infer<typeof MerchantListing>;

export const MerchantLot = __t.object("MerchantLot", {
  lotId: __t.u64(),
  lotKey: __t.string(),
  tier: __t.string(),
  renter: __t.identity(),
  storeName: __t.string(),
  rentedAt: __t.timestamp(),
  expiresAt: __t.timestamp(),
  updatedAt: __t.timestamp(),
});
export type MerchantLot = __Infer<typeof MerchantLot>;

export const MerchantQueue = __t.object("MerchantQueue", {
  queueId: __t.u64(),
  versonaId: __t.u64(),
  identity: __t.identity(),
  arrivedTick: __t.u64(),
  expiresTick: __t.u64(),
});
export type MerchantQueue = __Infer<typeof MerchantQueue>;

export const MerchantReceipt = __t.object("MerchantReceipt", {
  receiptId: __t.u64(),
  identity: __t.identity(),
  requestId: __t.string(),
  fingerprint: __t.string(),
  kind: __t.string(),
  disposition: __t.string(),
  listingId: __t.u64(),
  qty: __t.u32(),
  atTick: __t.u64(),
  at: __t.timestamp(),
});
export type MerchantReceipt = __Infer<typeof MerchantReceipt>;

export const MerchantSale = __t.object("MerchantSale", {
  saleId: __t.u64(),
  listingId: __t.u64(),
  lotId: __t.u64(),
  buyer: __t.identity(),
  seller: __t.identity(),
  label: __t.string(),
  priceSov: __t.i64(),
  qty: __t.u32(),
  at: __t.timestamp(),
});
export type MerchantSale = __Infer<typeof MerchantSale>;

export const MerchantService = __t.object("MerchantService", {
  versonaId: __t.u64(),
  customer: __t.identity(),
  phase: __t.string(),
  revision: __t.u64(),
  sinceTick: __t.u64(),
  expiresTick: __t.u64(),
  handoverListingId: __t.u64(),
  updatedAt: __t.timestamp(),
});
export type MerchantService = __Infer<typeof MerchantService>;

export const MigrationLog = __t.object("MigrationLog", {
  moveId: __t.u64(),
  worldId: __t.u64(),
  versonaId: __t.u64(),
  fromSid: __t.u64(),
  toSid: __t.u64(),
  reason: __t.string(),
  at: __t.timestamp(),
});
export type MigrationLog = __Infer<typeof MigrationLog>;

export const MissionHold = __t.object("MissionHold", {
  missionHoldId: __t.u64(),
  identity: __t.identity(),
  sid: __t.u64(),
  slot: __t.u32(),
  epoch: __t.u32(),
  kind: __t.string(),
  species: __t.string(),
  targetSiteId: __t.i64(),
  wayX: __t.f32(),
  wayZ: __t.f32(),
  needed: __t.u32(),
  progress: __t.u32(),
  rewardSov: __t.i64(),
  standing: __t.u32(),
  state: __t.string(),
  takenAt: __t.timestamp(),
});
export type MissionHold = __Infer<typeof MissionHold>;

export const ModerationQueue = __t.object("ModerationQueue", {
  assetId: __t.u64(),
  submittedBy: __t.identity(),
  submittedAt: __t.timestamp(),
  state: __t.string(),
});
export type ModerationQueue = __Infer<typeof ModerationQueue>;

export const Mourning = __t.object("Mourning", {
  versonaId: __t.u64(),
  worldId: __t.u64(),
  deceasedId: __t.u64(),
  untilAt: __t.timestamp(),
  startedAt: __t.timestamp(),
});
export type Mourning = __Infer<typeof Mourning>;

export const MoveBudget = __t.object("MoveBudget", {
  identity: __t.identity(),
  steps: __t.f64(),
  secs: __t.f64(),
  at: __t.timestamp(),
});
export type MoveBudget = __Infer<typeof MoveBudget>;

export const MysteryClue = __t.object("MysteryClue", {
  clueId: __t.u64(),
  identity: __t.identity(),
  mysteryKey: __t.string(),
  step: __t.u8(),
  title: __t.string(),
  source: __t.string(),
  place: __t.string(),
  text: __t.string(),
  question: __t.string(),
  nextLabel: __t.string(),
  nextSystem: __t.string(),
  nextX: __t.f64(),
  nextY: __t.f64(),
  nextZ: __t.f64(),
  at: __t.timestamp(),
});
export type MysteryClue = __Infer<typeof MysteryClue>;

export const MysteryState = __t.object("MysteryState", {
  mysteryKey: __t.string(),
  stage: __t.string(),
  postKey: __t.string(),
  escrowSov: __t.i64(),
  restoredBy: __t.identity(),
  restoredName: __t.string(),
  choice: __t.string(),
  restoredAt: __t.timestamp(),
  serviceLine: __t.string(),
  updatedAt: __t.timestamp(),
});
export type MysteryState = __Infer<typeof MysteryState>;

export const NeedSatisfier = __t.object("NeedSatisfier", {
  worldId: __t.u64(),
  need: __t.string(),
  ratePerMin: __t.u8(),
});
export type NeedSatisfier = __Infer<typeof NeedSatisfier>;

export const NoBuildZone = __t.object("NoBuildZone", {
  zoneId: __t.u64(),
  worldId: __t.u64(),
  cellX: __t.i32(),
  cellZ: __t.i32(),
  reason: __t.string(),
});
export type NoBuildZone = __Infer<typeof NoBuildZone>;

export const NpcAgent = __t.object("NpcAgent", {
  versonaId: __t.u64(),
  worldId: __t.u64(),
  settlementId: __t.u64(),
  job: __t.string(),
  boldness: __t.u32(),
  greed: __t.u32(),
  diligence: __t.u32(),
  sociability: __t.u32(),
  homeX: __t.f32(),
  homeZ: __t.f32(),
  workX: __t.f32(),
  workZ: __t.f32(),
  wallet: __t.i64(),
  carry: __t.u32(),
  carryGood: __t.string(),
  hunger: __t.u32(),
  needRest: __t.u32(),
  needSocial: __t.u32(),
  mood: __t.u32(),
  updatedAt: __t.timestamp(),
});
export type NpcAgent = __Infer<typeof NpcAgent>;

export const NpcCombat = __t.object("NpcCombat", {
  npcKey: __t.string(),
  staggeredUntil: __t.timestamp(),
  updatedAt: __t.timestamp(),
});
export type NpcCombat = __Infer<typeof NpcCombat>;

export const NpcEvent = __t.object("NpcEvent", {
  eventId: __t.u64(),
  worldId: __t.u64(),
  settlementId: __t.u64(),
  versonaId: __t.u64(),
  kind: __t.string(),
  detail: __t.string(),
  at: __t.timestamp(),
});
export type NpcEvent = __Infer<typeof NpcEvent>;

export const NpcHost = __t.object("NpcHost", {
  npcId: __t.u64(),
  worldId: __t.u64(),
  ritualId: __t.u64(),
  kind: __t.string(),
  memory: __t.string(),
  createdAt: __t.timestamp(),
});
export type NpcHost = __Infer<typeof NpcHost>;

export const NpcMind = __t.object("NpcMind", {
  versonaId: __t.u64(),
  worldId: __t.u64(),
  joy: __t.u32(),
  anger: __t.u32(),
  fear: __t.u32(),
  hungerStreak: __t.u32(),
  emotionAt: __t.timestamp(),
  updatedAt: __t.timestamp(),
});
export type NpcMind = __Infer<typeof NpcMind>;

export const NpcMood = __t.object("NpcMood", {
  versonaId: __t.u64(),
  worldId: __t.u64(),
  pleasureX10: __t.i32(),
  arousalX10: __t.i32(),
  dominanceX10: __t.i32(),
  basePleasureX10: __t.i32(),
  baseArousalX10: __t.i32(),
  baseDominanceX10: __t.i32(),
  updatedAt: __t.timestamp(),
});
export type NpcMood = __Infer<typeof NpcMood>;

export const NpcPack = __t.object("NpcPack", {
  packId: __t.u64(),
  versonaId: __t.u64(),
  commodity: __t.string(),
  qty: __t.i32(),
});
export type NpcPack = __Infer<typeof NpcPack>;

export const NpcPantry = __t.object("NpcPantry", {
  versonaId: __t.u64(),
  foodDays: __t.f32(),
  updatedAt: __t.timestamp(),
});
export type NpcPantry = __Infer<typeof NpcPantry>;

export const NpcSkill = __t.object("NpcSkill", {
  skillId: __t.u64(),
  versonaId: __t.u64(),
  recipeKey: __t.string(),
  level: __t.f32(),
  updatedAt: __t.timestamp(),
});
export type NpcSkill = __Infer<typeof NpcSkill>;

export const NpcStrike = __t.object("NpcStrike", {
  scheduledId: __t.u64(),
  scheduledAt: __t.scheduleAt(),
  attackerKey: __t.string(),
  targetKind: __t.string(),
  targetPlayer: __t.identity(),
  targetVersona: __t.u64(),
  dmg: __t.i32(),
  reachM: __t.f32(),
  x: __t.f32(),
  z: __t.f32(),
  windupStartedAt: __t.timestamp(),
  windupMs: __t.u32(),
});
export type NpcStrike = __Infer<typeof NpcStrike>;

export const NpcUnit = __t.object("NpcUnit", {
  npcId: __t.u64(),
  worldId: __t.u64(),
  owner: __t.identity(),
  name: __t.string(),
  modelKey: __t.string(),
  posX: __t.f32(),
  posY: __t.f32(),
  posZ: __t.f32(),
  yaw: __t.f32(),
  scale: __t.f32(),
  scriptSrc: __t.string(),
  enabled: __t.bool(),
  configJson: __t.string(),
  createdAt: __t.timestamp(),
  updatedAt: __t.timestamp(),
});
export type NpcUnit = __Infer<typeof NpcUnit>;

export const Occupation = __t.object("Occupation", {
  settlementId: __t.u64(),
  worldId: __t.u64(),
  warId: __t.u64(),
  occupierCiv: __t.string(),
  resistance: __t.i32(),
  compliance: __t.i32(),
  state: __t.string(),
  sinceAt: __t.timestamp(),
  updatedAt: __t.timestamp(),
});
export type Occupation = __Infer<typeof Occupation>;

export const Onboarding = __t.object("Onboarding", {
  identity: __t.identity(),
  beat: __t.u32(),
  rollbackTokens: __t.u8(),
  safetyTutorialDone: __t.bool(),
  theLieRevealed: __t.bool(),
  firstHourComplete: __t.bool(),
  startedAt: __t.timestamp(),
});
export type Onboarding = __Infer<typeof Onboarding>;

export const OpCrewShare = __t.object("OpCrewShare", {
  who: __t.identity(),
  shareBps: __t.u32(),
});
export type OpCrewShare = __Infer<typeof OpCrewShare>;

export const OpEnrollment = __t.object("OpEnrollment", {
  enrollKey: __t.string(),
  opId: __t.u64(),
  template: __t.string(),
  identity: __t.identity(),
  crewJson: __t.string(),
  at: __t.timestamp(),
});
export type OpEnrollment = __Infer<typeof OpEnrollment>;

export const OpEvidence = __t.object("OpEvidence", {
  evidenceId: __t.string(),
  opId: __t.u64(),
  receiptKey: __t.string(),
  at: __t.timestamp(),
});
export type OpEvidence = __Infer<typeof OpEvidence>;

export const OpMeter = __t.object("OpMeter", {
  meterKey: __t.string(),
  opId: __t.u64(),
  kind: __t.string(),
  identity: __t.identity(),
  accMs: __t.u32(),
  lastBeatMs: __t.f64(),
  lastX: __t.f64(),
  lastY: __t.f64(),
  lastZ: __t.f64(),
  seq: __t.u32(),
  shipId: __t.u64(),
  reason: __t.string(),
  updatedAt: __t.timestamp(),
});
export type OpMeter = __Infer<typeof OpMeter>;

export const OpObjective = __t.object("OpObjective", {
  objKey: __t.string(),
  opId: __t.u64(),
  template: __t.string(),
  allocSov: __t.i64(),
  slotsJson: __t.string(),
  accepted: __t.u32(),
  state: __t.string(),
  beneficiary: __t.identity(),
  crewJson: __t.string(),
  splitRev: __t.u32(),
  target: __t.string(),
  resultText: __t.string(),
  completedAt: __t.timestamp(),
  updatedAt: __t.timestamp(),
});
export type OpObjective = __Infer<typeof OpObjective>;

export const OpReceipt = __t.object("OpReceipt", {
  receiptKey: __t.string(),
  opId: __t.u64(),
  template: __t.string(),
  slot: __t.string(),
  evidenceId: __t.string(),
  beneficiary: __t.identity(),
  amountSov: __t.i64(),
  crewJson: __t.string(),
  splitRev: __t.u32(),
  order: __t.u32(),
  detail: __t.string(),
  acceptedAt: __t.timestamp(),
  paidAt: __t.timestamp(),
  payTxId: __t.u64(),
});
export type OpReceipt = __Infer<typeof OpReceipt>;

export const Orbit = __t.object("Orbit", {
  orbitId: __t.u64(),
  createdAt: __t.timestamp(),
  lastActivityAt: __t.timestamp(),
  validated: __t.bool(),
  preferredWorldId: __t.u64(),
});
export type Orbit = __Infer<typeof Orbit>;

export const OrbitMember = __t.object("OrbitMember", {
  memberId: __t.u64(),
  orbitId: __t.u64(),
  identity: __t.identity(),
  joinedAt: __t.timestamp(),
});
export type OrbitMember = __Infer<typeof OrbitMember>;

export const Part = __t.object("Part", {
  partId: __t.u64(),
  worldId: __t.u64(),
  linksetId: __t.u64(),
  primType: __t.string(),
  meshRef: __t.string(),
  sourceAssetId: __t.u64(),
  modelAssetId: __t.u64(),
  posX: __t.f32(),
  posY: __t.f32(),
  posZ: __t.f32(),
  rotX: __t.f32(),
  rotY: __t.f32(),
  rotZ: __t.f32(),
  rotW: __t.f32(),
  scaleX: __t.f32(),
  scaleY: __t.f32(),
  scaleZ: __t.f32(),
  shapeJson: __t.string(),
  materialJson: __t.string(),
  phantom: __t.bool(),
  physics: __t.bool(),
  landImpact: __t.u16(),
  createdBy: __t.identity(),
  createdAt: __t.timestamp(),
});
export type Part = __Infer<typeof Part>;

export const PartScript = __t.object("PartScript", {
  scriptId: __t.u64(),
  worldId: __t.u64(),
  partId: __t.u64(),
  contractId: __t.u64(),
  attachedBy: __t.identity(),
  attachedAt: __t.timestamp(),
});
export type PartScript = __Infer<typeof PartScript>;

export const Party = __t.object("Party", {
  partyId: __t.u64(),
  leader: __t.identity(),
  rosterRev: __t.u32(),
  state: __t.string(),
  createdAt: __t.timestamp(),
  updatedAt: __t.timestamp(),
});
export type Party = __Infer<typeof Party>;

export const PartyHistory = __t.object("PartyHistory", {
  histId: __t.u64(),
  identity: __t.identity(),
  other: __t.identity(),
  otherName: __t.string(),
  partyId: __t.u64(),
  at: __t.timestamp(),
});
export type PartyHistory = __Infer<typeof PartyHistory>;

export const PartyInvite = __t.object("PartyInvite", {
  inviteId: __t.u64(),
  partyId: __t.u64(),
  inviter: __t.identity(),
  invitee: __t.identity(),
  expiresAt: __t.timestamp(),
  at: __t.timestamp(),
});
export type PartyInvite = __Infer<typeof PartyInvite>;

export const PartyMember = __t.object("PartyMember", {
  memberId: __t.u64(),
  partyId: __t.u64(),
  identity: __t.identity(),
  ready: __t.bool(),
  joinedAt: __t.timestamp(),
});
export type PartyMember = __Infer<typeof PartyMember>;

export const PartyMessage = __t.object("PartyMessage", {
  msgId: __t.u64(),
  partyId: __t.u64(),
  sender: __t.identity(),
  senderName: __t.string(),
  kind: __t.string(),
  text: __t.string(),
  phraseKey: __t.string(),
  nonce: __t.u32(),
  at: __t.timestamp(),
});
export type PartyMessage = __Infer<typeof PartyMessage>;

export const PartyPing = __t.object("PartyPing", {
  pingId: __t.u64(),
  partyId: __t.u64(),
  sender: __t.identity(),
  kind: __t.string(),
  worldId: __t.u64(),
  x: __t.f32(),
  y: __t.f32(),
  z: __t.f32(),
  targetKey: __t.string(),
  parentId: __t.u64(),
  expiresAt: __t.timestamp(),
  at: __t.timestamp(),
});
export type PartyPing = __Infer<typeof PartyPing>;

export const PartyQueueIntent = __t.object("PartyQueueIntent", {
  intentId: __t.u64(),
  partyId: __t.u64(),
  identity: __t.identity(),
  gameId: __t.u64(),
  rosterRev: __t.u32(),
  state: __t.string(),
  expiresAt: __t.timestamp(),
  at: __t.timestamp(),
});
export type PartyQueueIntent = __Infer<typeof PartyQueueIntent>;

export const PerfLeg = __t.object("PerfLeg", {
  legId: __t.u64(),
  legKey: __t.string(),
  runKey: __t.string(),
  tier: __t.string(),
  kind: __t.string(),
  x: __t.f64(),
  z: __t.f64(),
  spot: __t.string(),
  status: __t.string(),
  notes: __t.string(),
  samples: __t.u32(),
  fpsAvg: __t.f32(),
  fpsP05: __t.f32(),
  frameMsP50: __t.f32(),
  frameMsP95: __t.f32(),
  frameMsP99: __t.f32(),
  frameMsMax: __t.f32(),
  drawCallsAvg: __t.u32(),
  trianglesAvg: __t.u64(),
  trianglesMax: __t.u64(),
  pipelines: __t.u32(),
  heapMbAvg: __t.f32(),
  heapMbMax: __t.f32(),
  loafCount: __t.u32(),
  loafMsTotal: __t.f32(),
  gpuMsAvg: __t.f32(),
  censusJson: __t.string(),
  extrasJson: __t.string(),
  startedAt: __t.timestamp(),
  endedAt: __t.timestamp(),
});
export type PerfLeg = __Infer<typeof PerfLeg>;

export const PerfRun = __t.object("PerfRun", {
  runId: __t.u64(),
  runKey: __t.string(),
  identity: __t.identity(),
  label: __t.string(),
  backend: __t.string(),
  userAgent: __t.string(),
  tiers: __t.string(),
  legSeconds: __t.u32(),
  status: __t.string(),
  notes: __t.string(),
  startedAt: __t.timestamp(),
  endedAt: __t.timestamp(),
});
export type PerfRun = __Infer<typeof PerfRun>;

export const PerfSample = __t.object("PerfSample", {
  sampleId: __t.u64(),
  runKey: __t.string(),
  legKey: __t.string(),
  t: __t.f32(),
  fps: __t.f32(),
  frameMsP50: __t.f32(),
  frameMsP95: __t.f32(),
  frameMsMax: __t.f32(),
  drawCalls: __t.u32(),
  triangles: __t.u64(),
  pipelines: __t.u32(),
  heapMb: __t.f32(),
  gpuMs: __t.f32(),
  loaf: __t.u32(),
  x: __t.f64(),
  z: __t.f64(),
  censusJson: __t.string(),
  at: __t.timestamp(),
});
export type PerfSample = __Infer<typeof PerfSample>;

export const PilotLoyalty = __t.object("PilotLoyalty", {
  identity: __t.identity(),
  factionKey: __t.string(),
  lp: __t.u64(),
  updatedAt: __t.timestamp(),
});
export type PilotLoyalty = __Infer<typeof PilotLoyalty>;

export const PilotMission = __t.object("PilotMission", {
  missionId: __t.u64(),
  identity: __t.identity(),
  kind: __t.string(),
  targetPoi: __t.u32(),
  goal: __t.u32(),
  progress: __t.u32(),
  rewardSov: __t.u64(),
  rewardXp: __t.u64(),
  state: __t.string(),
  takenAt: __t.timestamp(),
});
export type PilotMission = __Infer<typeof PilotMission>;

export const PilotSkill = __t.object("PilotSkill", {
  rowId: __t.u64(),
  identity: __t.identity(),
  skillKey: __t.string(),
  level: __t.u32(),
});
export type PilotSkill = __Infer<typeof PilotSkill>;

export const PilotState = __t.object("PilotState", {
  identity: __t.identity(),
  factionKey: __t.string(),
  rank: __t.u32(),
  xp: __t.u64(),
  tokens: __t.u64(),
  arcStep: __t.u32(),
  updatedAt: __t.timestamp(),
});
export type PilotState = __Infer<typeof PilotState>;

export const PilotTraining = __t.object("PilotTraining", {
  identity: __t.identity(),
  skillKey: __t.string(),
  startedAt: __t.timestamp(),
  endsAt: __t.timestamp(),
});
export type PilotTraining = __Infer<typeof PilotTraining>;

export const PlanetaryPort = __t.object("PlanetaryPort", {
  portId: __t.u64(),
  settlementId: __t.u64(),
  firmId: __t.u64(),
  state: __t.string(),
  generation: __t.u32(),
  exported: __t.u32(),
  lifetimeCapU: __t.u32(),
  coinsPaid: __t.i64(),
  coinsReceived: __t.i64(),
  sovEarned: __t.i64(),
  sovSpent: __t.i64(),
  lastError: __t.string(),
  lastEpoch: __t.u64(),
  createdAt: __t.timestamp(),
  updatedAt: __t.timestamp(),
});
export type PlanetaryPort = __Infer<typeof PlanetaryPort>;

export const PlatformFlag = __t.object("PlatformFlag", {
  key: __t.string(),
  enabled: __t.bool(),
  updatedAt: __t.timestamp(),
});
export type PlatformFlag = __Infer<typeof PlatformFlag>;

export const PlayerAction = __t.object("PlayerAction", {
  identity: __t.identity(),
  lastWhiffAt: __t.timestamp(),
  staggeredUntil: __t.timestamp(),
  slideStartedAt: __t.timestamp(),
  moveMode: __t.u8(),
  updatedAt: __t.timestamp(),
});
export type PlayerAction = __Infer<typeof PlayerAction>;

export const PlayerBounty = __t.object("PlayerBounty", {
  bountyId: __t.u64(),
  target: __t.identity(),
  placedBy: __t.identity(),
  reward: __t.i64(),
  fee: __t.i64(),
  note: __t.string(),
  state: __t.string(),
  claimedBy: __t.identity(),
  placedAt: __t.timestamp(),
  expiresAt: __t.timestamp(),
  resolvedAt: __t.timestamp(),
});
export type PlayerBounty = __Infer<typeof PlayerBounty>;

export const PlayerBountyHunter = __t.object("PlayerBountyHunter", {
  takeId: __t.u64(),
  bountyId: __t.u64(),
  hunter: __t.identity(),
  state: __t.string(),
  takenAt: __t.timestamp(),
  updatedAt: __t.timestamp(),
});
export type PlayerBountyHunter = __Infer<typeof PlayerBountyHunter>;

export const PlayerBountyTrace = __t.object("PlayerBountyTrace", {
  traceKey: __t.string(),
  bountyId: __t.u64(),
  hunter: __t.identity(),
  found: __t.bool(),
  x: __t.f32(),
  z: __t.f32(),
  blurM: __t.f32(),
  near: __t.string(),
  at: __t.timestamp(),
});
export type PlayerBountyTrace = __Infer<typeof PlayerBountyTrace>;

export const PlayerCamp = __t.object("PlayerCamp", {
  campId: __t.u64(),
  owner: __t.identity(),
  worldId: __t.u64(),
  x: __t.f32(),
  y: __t.f32(),
  z: __t.f32(),
  yaw: __t.f32(),
  name: __t.string(),
  pitchedAt: __t.timestamp(),
  expiresAt: __t.timestamp(),
});
export type PlayerCamp = __Infer<typeof PlayerCamp>;

export const PlayerCiv = __t.object("PlayerCiv", {
  civId: __t.u64(),
  name: __t.string(),
  banner: __t.string(),
  founderCityId: __t.u64(),
  status: __t.string(),
  treasury: __t.i64(),
  titheBps: __t.u16(),
  proposedAt: __t.timestamp(),
  formedAt: __t.timestamp(),
});
export type PlayerCiv = __Infer<typeof PlayerCiv>;

export const PlayerCivMember = __t.object("PlayerCivMember", {
  memberId: __t.u64(),
  civId: __t.u64(),
  cityId: __t.u64(),
  joinedAt: __t.timestamp(),
});
export type PlayerCivMember = __Infer<typeof PlayerCivMember>;

export const PlayerCivStyle = __t.object("PlayerCivStyle", {
  civId: __t.u64(),
  tradition: __t.string(),
  updatedBy: __t.identity(),
  updatedAt: __t.timestamp(),
});
export type PlayerCivStyle = __Infer<typeof PlayerCivStyle>;

export const PlayerEquipment = __t.object("PlayerEquipment", {
  equipId: __t.u64(),
  owner: __t.identity(),
  slot: __t.string(),
  itemKey: __t.string(),
  name: __t.string(),
  quality: __t.u32(),
  propsJson: __t.string(),
  serial: __t.string(),
  equippedAt: __t.timestamp(),
});
export type PlayerEquipment = __Infer<typeof PlayerEquipment>;

export const PlayerFavor = __t.object("PlayerFavor", {
  favorId: __t.u64(),
  versonaId: __t.u64(),
  identity: __t.identity(),
  worldId: __t.u64(),
  kind: __t.string(),
  targetKey: __t.string(),
  qty: __t.u32(),
  detail: __t.string(),
  state: __t.string(),
  offeredAt: __t.timestamp(),
  expiresAt: __t.timestamp(),
  updatedAt: __t.timestamp(),
});
export type PlayerFavor = __Infer<typeof PlayerFavor>;

export const PlayerInterior = __t.object("PlayerInterior", {
  identity: __t.identity(),
  buildingId: __t.string(),
  floor: __t.u32(),
  roomId: __t.string(),
  verified: __t.bool(),
  enteredAt: __t.timestamp(),
  updatedAt: __t.timestamp(),
});
export type PlayerInterior = __Infer<typeof PlayerInterior>;

export const PlayerInvite = __t.object("PlayerInvite", {
  token: __t.string(),
  inviter: __t.identity(),
  worldId: __t.u64(),
  x: __t.f32(),
  z: __t.f32(),
  uses: __t.u16(),
  maxUses: __t.u16(),
  createdAt: __t.timestamp(),
  expiresAt: __t.timestamp(),
});
export type PlayerInvite = __Infer<typeof PlayerInvite>;

export const PlayerItem = __t.object("PlayerItem", {
  itemId: __t.u64(),
  owner: __t.identity(),
  itemKey: __t.string(),
  name: __t.string(),
  quality: __t.u32(),
  ceiling: __t.u32(),
  propsJson: __t.string(),
  componentsJson: __t.string(),
  craftedBy: __t.identity(),
  serial: __t.string(),
  createdAt: __t.timestamp(),
});
export type PlayerItem = __Infer<typeof PlayerItem>;

export const PlayerPost = __t.object("PlayerPost", {
  identity: __t.identity(),
  settlementId: __t.u64(),
  postKey: __t.string(),
  venueX: __t.f32(),
  venueZ: __t.f32(),
  takenAt: __t.timestamp(),
  lastDutyAt: __t.timestamp(),
  dutyDay: __t.u32(),
  dutyTodayS: __t.u32(),
  totalDutyS: __t.u32(),
  wageDueS: __t.u32(),
  served: __t.u32(),
  earned: __t.i64(),
  nextCustomerAt: __t.timestamp(),
});
export type PlayerPost = __Infer<typeof PlayerPost>;

export const PlayerRelation = __t.object("PlayerRelation", {
  relId: __t.u64(),
  versonaId: __t.u64(),
  identity: __t.identity(),
  worldId: __t.u64(),
  seenCount: __t.u32(),
  lastSeenAt: __t.timestamp(),
  lastTalkDay: __t.u32(),
  talkStreak: __t.u32(),
  lastGiftDay: __t.u32(),
  lastGiftKey: __t.string(),
  nemesis: __t.bool(),
  rival: __t.bool(),
  updatedAt: __t.timestamp(),
});
export type PlayerRelation = __Infer<typeof PlayerRelation>;

export const PlayerRelationEvent = __t.object("PlayerRelationEvent", {
  eventId: __t.u64(),
  versonaId: __t.u64(),
  identity: __t.identity(),
  worldId: __t.u64(),
  kind: __t.string(),
  label: __t.string(),
  weight: __t.i32(),
  halfLifeS: __t.u32(),
  at: __t.timestamp(),
});
export type PlayerRelationEvent = __Infer<typeof PlayerRelationEvent>;

export const PlayerReport = __t.object("PlayerReport", {
  reportId: __t.u64(),
  reporter: __t.identity(),
  target: __t.identity(),
  category: __t.string(),
  detail: __t.string(),
  refKind: __t.string(),
  refId: __t.u64(),
  state: __t.string(),
  at: __t.timestamp(),
});
export type PlayerReport = __Infer<typeof PlayerReport>;

export const PlayerResource = __t.object("PlayerResource", {
  stackId: __t.u64(),
  owner: __t.identity(),
  spawnId: __t.u64(),
  familyKey: __t.string(),
  name: __t.string(),
  statsJson: __t.string(),
  qty: __t.u32(),
});
export type PlayerResource = __Infer<typeof PlayerResource>;

export const PlayerSchematic = __t.object("PlayerSchematic", {
  schemId: __t.u64(),
  owner: __t.identity(),
  schematicKey: __t.string(),
  source: __t.string(),
  learnedAt: __t.timestamp(),
});
export type PlayerSchematic = __Infer<typeof PlayerSchematic>;

export const PlayerShip = __t.object("PlayerShip", {
  shipId: __t.u64(),
  owner: __t.identity(),
  chassisKey: __t.string(),
  name: __t.string(),
  active: __t.bool(),
  boughtAt: __t.timestamp(),
});
export type PlayerShip = __Infer<typeof PlayerShip>;

export const PlayerStance = __t.object("PlayerStance", {
  identity: __t.identity(),
  dashStartedAt: __t.timestamp(),
  guardRaisedAt: __t.timestamp(),
  guardReleasedAt: __t.timestamp(),
  parryWindowMs: __t.u32(),
  lastParryAt: __t.timestamp(),
  lastLandedAt: __t.timestamp(),
  updatedAt: __t.timestamp(),
});
export type PlayerStance = __Infer<typeof PlayerStance>;

export const PlayerStanding = __t.object("PlayerStanding", {
  standingId: __t.u64(),
  identity: __t.identity(),
  settlementId: __t.u64(),
  regard: __t.u32(),
  updatedAt: __t.timestamp(),
});
export type PlayerStanding = __Infer<typeof PlayerStanding>;

export const PlayerState = __t.object("PlayerState", {
  identity: __t.identity(),
  worldId: __t.u64(),
  cellX: __t.i32(),
  cellZ: __t.i32(),
  posX: __t.f32(),
  posY: __t.f32(),
  posZ: __t.f32(),
  yaw: __t.f32(),
  animState: __t.string(),
  inputSeq: __t.u32(),
  updatedAt: __t.timestamp(),
});
export type PlayerState = __Infer<typeof PlayerState>;

export const PlayerTale = __t.object("PlayerTale", {
  identity: __t.identity(),
  day: __t.u64(),
});
export type PlayerTale = __Infer<typeof PlayerTale>;

export const PlayerVitals = __t.object("PlayerVitals", {
  identity: __t.identity(),
  hp: __t.i32(),
  maxHp: __t.i32(),
  lastStrikeAt: __t.timestamp(),
  lastHurtAt: __t.timestamp(),
  updatedAt: __t.timestamp(),
});
export type PlayerVitals = __Infer<typeof PlayerVitals>;

export const PortCrewShare = __t.object("PortCrewShare", {
  who: __t.identity(),
  shareBps: __t.u32(),
});
export type PortCrewShare = __Infer<typeof PortCrewShare>;

export const PortHaul = __t.object("PortHaul", {
  haulId: __t.u64(),
  portId: __t.u64(),
  direction: __t.string(),
  familyKey: __t.string(),
  qty: __t.u32(),
  rewardSov: __t.i64(),
  state: __t.string(),
  hauler: __t.identity(),
  shipId: __t.u64(),
  stationKey: __t.string(),
  offeredAt: __t.timestamp(),
  acceptedAt: __t.timestamp(),
  deadlineAt: __t.timestamp(),
  updatedAt: __t.timestamp(),
});
export type PortHaul = __Infer<typeof PortHaul>;

export const PortHaulTerms = __t.object("PortHaulTerms", {
  haulId: __t.u64(),
  portId: __t.u64(),
  termsVersion: __t.u32(),
  captain: __t.identity(),
  splitJson: __t.string(),
  splitRev: __t.u32(),
  relayPartner: __t.identity(),
  custodianRev: __t.u32(),
  relayFrom: __t.identity(),
  relayFromShip: __t.u64(),
  relayAt: __t.timestamp(),
  offerTo: __t.identity(),
  offerBps: __t.u32(),
  offerExpiresAt: __t.timestamp(),
  beginBy: __t.identity(),
  beginAt: __t.timestamp(),
  beginJson: __t.string(),
  acceptedAt: __t.timestamp(),
  updatedAt: __t.timestamp(),
});
export type PortHaulTerms = __Infer<typeof PortHaulTerms>;

export const PortReceipt = __t.object("PortReceipt", {
  haulId: __t.u64(),
  portId: __t.u64(),
  direction: __t.string(),
  civ: __t.string(),
  yardFirmId: __t.u64(),
  stationKey: __t.string(),
  qty: __t.u32(),
  captain: __t.identity(),
  deliveredBy: __t.identity(),
  custodianRev: __t.u32(),
  termsVersion: __t.u32(),
  splitRev: __t.u32(),
  rewardSov: __t.i64(),
  payoutJson: __t.string(),
  payTxId: __t.u64(),
  oreQuote: __t.i64(),
  orePaid: __t.i64(),
  yardOreAfter: __t.u32(),
  yardHulls: __t.u32(),
  yardTarget: __t.u32(),
  shortHours: __t.u32(),
  acceptedAt: __t.timestamp(),
  deliveredAt: __t.timestamp(),
  stage: __t.string(),
  wait: __t.string(),
  builtAt: __t.timestamp(),
  reserveAt: __t.timestamp(),
  reserveHulls: __t.u32(),
  hullsSeen: __t.u32(),
  campaignId: __t.u64(),
  committed: __t.u32(),
  checkedAt: __t.timestamp(),
  updatedAt: __t.timestamp(),
});
export type PortReceipt = __Infer<typeof PortReceipt>;

export const PortStatus = __t.object("PortStatus", {
  portId: __t.u64(),
  procure: __t.bool(),
  reasonsJson: __t.string(),
  numbersJson: __t.string(),
  checkedAt: __t.timestamp(),
});
export type PortStatus = __Infer<typeof PortStatus>;

export const PostLedgerLeg = __t.object("PostLedgerLeg", {
  account: __t.identity(),
  currency: __t.string(),
  delta: __t.i64(),
  reason: __t.string(),
  ref: __t.string(),
});
export type PostLedgerLeg = __Infer<typeof PostLedgerLeg>;

export const PostRequest = __t.object("PostRequest", {
  requestId: __t.u64(),
  holder: __t.identity(),
  settlementId: __t.u64(),
  postKey: __t.string(),
  versonaId: __t.u64(),
  need: __t.string(),
  createdAt: __t.timestamp(),
  expiresAt: __t.timestamp(),
});
export type PostRequest = __Infer<typeof PostRequest>;

export const PrefabModel = __t.object("PrefabModel", {
  prefabModelId: __t.u64(),
  prefabKey: __t.string(),
  assetId: __t.u64(),
  category: __t.string(),
  defaultScale: __t.f32(),
  preferInstanced: __t.bool(),
  castShadow: __t.bool(),
});
export type PrefabModel = __Infer<typeof PrefabModel>;

export const Presence = __t.object("Presence", {
  identity: __t.identity(),
  online: __t.bool(),
  updatedAt: __t.timestamp(),
});
export type Presence = __Infer<typeof Presence>;

export const PresenceConn = __t.object("PresenceConn", {
  connKey: __t.string(),
  identity: __t.identity(),
  at: __t.timestamp(),
});
export type PresenceConn = __Infer<typeof PresenceConn>;

export const PriceBelief = __t.object("PriceBelief", {
  beliefId: __t.u64(),
  versonaId: __t.u64(),
  commodity: __t.string(),
  mu: __t.f32(),
  sigma: __t.f32(),
  updatedAt: __t.timestamp(),
});
export type PriceBelief = __Infer<typeof PriceBelief>;

export const ProvenanceEvent = __t.object("ProvenanceEvent", {
  eventId: __t.u64(),
  assetId: __t.u64(),
  actor: __t.identity(),
  action: __t.string(),
  detail: __t.string(),
  at: __t.timestamp(),
});
export type ProvenanceEvent = __Infer<typeof ProvenanceEvent>;

export const PublishedExperience = __t.object("PublishedExperience", {
  worldId: __t.u64(),
  projectId: __t.u64(),
  liveReleaseId: __t.u64(),
  loadedReleaseId: __t.u64(),
  runtimeVerified: __t.bool(),
  fidelityTier: __t.u8(),
  capManifest: __t.string(),
  updatedAt: __t.timestamp(),
});
export type PublishedExperience = __Infer<typeof PublishedExperience>;

export const Pulse = __t.object("Pulse", {
  identity: __t.identity(),
  social: __t.u8(),
  fun: __t.u8(),
  creativity: __t.u8(),
  rest: __t.u8(),
  visSocial: __t.bool(),
  visFun: __t.bool(),
  visCreativity: __t.bool(),
  visRest: __t.bool(),
  updatedAt: __t.timestamp(),
});
export type Pulse = __Infer<typeof Pulse>;

export const PvpArenaMatch = __t.object("PvpArenaMatch", {
  matchId: __t.u64(),
  worldId: __t.u64(),
  siteId: __t.u64(),
  state: __t.string(),
  teamSize: __t.u8(),
  round: __t.u8(),
  winsA: __t.u8(),
  winsB: __t.u8(),
  draws: __t.u8(),
  consecutiveDraws: __t.u8(),
  zoneX: __t.f32(),
  zoneZ: __t.f32(),
  zoneR: __t.f32(),
  relayX: __t.f32(),
  relayZ: __t.f32(),
  relayR: __t.f32(),
  stagingAx: __t.f32(),
  stagingAz: __t.f32(),
  stagingBx: __t.f32(),
  stagingBz: __t.f32(),
  capA: __t.f32(),
  capB: __t.f32(),
  capAt: __t.timestamp(),
  vacantSince: __t.timestamp(),
  roundStartedAt: __t.timestamp(),
  roundEndsAt: __t.timestamp(),
  relayActiveAt: __t.timestamp(),
  readyDeadline: __t.timestamp(),
  matchDeadline: __t.timestamp(),
  gen: __t.u32(),
  winner: __t.string(),
  result: __t.string(),
  createdAt: __t.timestamp(),
  finishedAt: __t.timestamp(),
  updatedAt: __t.timestamp(),
});
export type PvpArenaMatch = __Infer<typeof PvpArenaMatch>;

export const PvpArenaMember = __t.object("PvpArenaMember", {
  memberId: __t.u64(),
  matchId: __t.u64(),
  identity: __t.identity(),
  team: __t.string(),
  ready: __t.bool(),
  alive: __t.bool(),
  eliminatedRound: __t.u8(),
  absent: __t.bool(),
  offlineSince: __t.timestamp(),
  active: __t.bool(),
  joinedAt: __t.timestamp(),
  updatedAt: __t.timestamp(),
});
export type PvpArenaMember = __Infer<typeof PvpArenaMember>;

export const PvpArenaQueue = __t.object("PvpArenaQueue", {
  identity: __t.identity(),
  worldId: __t.u64(),
  siteId: __t.u64(),
  teamSize: __t.u8(),
  joinedAt: __t.timestamp(),
});
export type PvpArenaQueue = __Infer<typeof PvpArenaQueue>;

export const PvpDuel = __t.object("PvpDuel", {
  duelId: __t.u64(),
  worldId: __t.u64(),
  a: __t.identity(),
  b: __t.identity(),
  state: __t.string(),
  ruleset: __t.string(),
  siteId: __t.u64(),
  ringX: __t.f32(),
  ringZ: __t.f32(),
  ringR: __t.f32(),
  readyA: __t.bool(),
  readyB: __t.bool(),
  outSinceA: __t.timestamp(),
  outSinceB: __t.timestamp(),
  gen: __t.u32(),
  invitedAt: __t.timestamp(),
  startsAt: __t.timestamp(),
  endsAt: __t.timestamp(),
  winner: __t.identity(),
  result: __t.string(),
  finishedAt: __t.timestamp(),
  updatedAt: __t.timestamp(),
});
export type PvpDuel = __Infer<typeof PvpDuel>;

export const PvpEnrollment = __t.object("PvpEnrollment", {
  identity: __t.identity(),
  worldId: __t.u64(),
  sectorId: __t.u64(),
  side: __t.string(),
  state: __t.string(),
  stateAt: __t.timestamp(),
  lockUntil: __t.timestamp(),
  leaveAt: __t.timestamp(),
  updatedAt: __t.timestamp(),
});
export type PvpEnrollment = __Infer<typeof PvpEnrollment>;

export const PvpObjectiveReceipt = __t.object("PvpObjectiveReceipt", {
  receiptKey: __t.string(),
  sectorId: __t.u64(),
  warId: __t.u64(),
  side: __t.string(),
  at: __t.timestamp(),
});
export type PvpObjectiveReceipt = __Infer<typeof PvpObjectiveReceipt>;

export const PvpRecord = __t.object("PvpRecord", {
  identity: __t.identity(),
  duelsWon: __t.u32(),
  duelsLost: __t.u32(),
  duelsDrawn: __t.u32(),
  matchesWon: __t.u32(),
  matchesLost: __t.u32(),
  matchesDrawn: __t.u32(),
  objectives: __t.u32(),
  updatedAt: __t.timestamp(),
});
export type PvpRecord = __Infer<typeof PvpRecord>;

export const PvpSector = __t.object("PvpSector", {
  sectorId: __t.u64(),
  worldId: __t.u64(),
  name: __t.string(),
  x: __t.f32(),
  z: __t.f32(),
  r: __t.f32(),
  relayR: __t.f32(),
  warId: __t.u64(),
  sideA: __t.string(),
  sideB: __t.string(),
  active: __t.bool(),
  capA: __t.f32(),
  capB: __t.f32(),
  capAt: __t.timestamp(),
  vacantSince: __t.timestamp(),
  scoreA: __t.u32(),
  scoreB: __t.u32(),
  openedAt: __t.timestamp(),
  updatedAt: __t.timestamp(),
});
export type PvpSector = __Infer<typeof PvpSector>;

export const PvpTick = __t.object("PvpTick", {
  scheduledId: __t.u64(),
  scheduledAt: __t.scheduleAt(),
});
export type PvpTick = __Infer<typeof PvpTick>;

export const RaceEntry = __t.object("RaceEntry", {
  entryId: __t.u64(),
  raceId: __t.u64(),
  identity: __t.identity(),
  npc: __t.bool(),
  rival: __t.u8(),
  name: __t.string(),
  state: __t.string(),
  gatesPassed: __t.u16(),
  lastGateAt: __t.timestamp(),
  finishMs: __t.u32(),
  place: __t.u8(),
  points: __t.u8(),
  updatedAt: __t.timestamp(),
});
export type RaceEntry = __Infer<typeof RaceEntry>;

export const RaceEvent = __t.object("RaceEvent", {
  raceId: __t.u64(),
  season: __t.u32(),
  state: __t.string(),
  startsAt: __t.timestamp(),
  gridAt: __t.timestamp(),
  laps: __t.u8(),
  players: __t.u8(),
  field: __t.u8(),
  winnerName: __t.string(),
  finishedAt: __t.timestamp(),
  updatedAt: __t.timestamp(),
});
export type RaceEvent = __Infer<typeof RaceEvent>;

export const RaceStanding = __t.object("RaceStanding", {
  standingKey: __t.string(),
  season: __t.u32(),
  racerKey: __t.string(),
  identity: __t.identity(),
  npc: __t.bool(),
  name: __t.string(),
  points: __t.u32(),
  wins: __t.u16(),
  podiums: __t.u16(),
  starts: __t.u16(),
  bestMs: __t.u32(),
  updatedAt: __t.timestamp(),
});
export type RaceStanding = __Infer<typeof RaceStanding>;

export const RaceTick = __t.object("RaceTick", {
  scheduledId: __t.u64(),
  scheduledAt: __t.scheduleAt(),
});
export type RaceTick = __Infer<typeof RaceTick>;

export const Rating = __t.object("Rating", {
  ratingId: __t.u64(),
  gameId: __t.u64(),
  player: __t.identity(),
  mu: __t.f32(),
  sigma: __t.f32(),
  matches: __t.u32(),
  updatedAt: __t.timestamp(),
});
export type Rating = __Infer<typeof Rating>;

export const RecallPetition = __t.object("RecallPetition", {
  petitionId: __t.u64(),
  worldId: __t.u64(),
  settlementId: __t.u64(),
  mayorId: __t.u64(),
  reason: __t.string(),
  signatures: __t.u32(),
  votesFor: __t.u32(),
  votesAgainst: __t.u32(),
  status: __t.string(),
  openedAt: __t.timestamp(),
  decidedAt: __t.timestamp(),
});
export type RecallPetition = __Infer<typeof RecallPetition>;

export const RegionAssetSet = __t.object("RegionAssetSet", {
  setId: __t.u64(),
  worldId: __t.u64(),
  regionX: __t.i32(),
  regionZ: __t.i32(),
  assetIds: __t.string(),
  estVramMb: __t.u32(),
});
export type RegionAssetSet = __Infer<typeof RegionAssetSet>;

export const RenderAsset = __t.object("RenderAsset", {
  renderAssetId: __t.u64(),
  contentHash: __t.string(),
  kind: __t.string(),
  name: __t.string(),
  sourceUri: __t.string(),
  polyCount: __t.u32(),
  textureCount: __t.u16(),
  materialCount: __t.u16(),
  sizeBytes: __t.u64(),
  vramEstimateMb: __t.u32(),
  hasLods: __t.bool(),
  geometryCodec: __t.string(),
  textureCodec: __t.string(),
  license: __t.string(),
  creator: __t.identity(),
  status: __t.string(),
  thumbnailUri: __t.string(),
  createdAt: __t.timestamp(),
});
export type RenderAsset = __Infer<typeof RenderAsset>;

export const RenderAssetTextureTier = __t.object("RenderAssetTextureTier", {
  tierId: __t.u64(),
  renderAssetId: __t.u64(),
  lod: __t.u8(),
  maxTextureRes: __t.u16(),
  uri: __t.string(),
  sizeBytes: __t.u64(),
});
export type RenderAssetTextureTier = __Infer<typeof RenderAssetTextureTier>;

export const RenderAssetVariant = __t.object("RenderAssetVariant", {
  variantId: __t.u64(),
  renderAssetId: __t.u64(),
  lod: __t.u8(),
  uri: __t.string(),
  polyCount: __t.u32(),
  screenSizeThreshold: __t.f32(),
});
export type RenderAssetVariant = __Infer<typeof RenderAssetVariant>;

export const Rental = __t.object("Rental", {
  rentalId: __t.u64(),
  worldId: __t.u64(),
  owner: __t.identity(),
  renter: __t.identity(),
  upfrontSov: __t.i64(),
  collateralVouch: __t.bool(),
  startsAt: __t.timestamp(),
  endsAt: __t.timestamp(),
  returnedClean: __t.bool(),
  active: __t.bool(),
});
export type Rental = __Infer<typeof Rental>;

export const RentalContainer = __t.object("RentalContainer", {
  containerId: __t.u64(),
  leaseId: __t.u64(),
  structureId: __t.u64(),
  tenant: __t.identity(),
  key: __t.string(),
  kind: __t.string(),
  capacity: __t.u32(),
  createdAt: __t.timestamp(),
});
export type RentalContainer = __Infer<typeof RentalContainer>;

export const RentalLease = __t.object("RentalLease", {
  leaseId: __t.u64(),
  unitRowId: __t.u64(),
  structureId: __t.u64(),
  unitId: __t.string(),
  tenant: __t.identity(),
  tenantName: __t.string(),
  landlord: __t.identity(),
  rentPerDay: __t.u32(),
  since: __t.timestamp(),
  paidDays: __t.u32(),
  releasedDays: __t.u32(),
  paidUntil: __t.timestamp(),
  heldSov: __t.i64(),
  noticeAt: __t.timestamp(),
  endsAt: __t.timestamp(),
  state: __t.string(),
  endedAt: __t.timestamp(),
  entryPermId: __t.u64(),
});
export type RentalLease = __Infer<typeof RentalLease>;

export const RentalReceipt = __t.object("RentalReceipt", {
  receiptId: __t.u64(),
  leaseId: __t.u64(),
  structureId: __t.u64(),
  unitId: __t.string(),
  tenant: __t.identity(),
  owner: __t.identity(),
  kind: __t.string(),
  amountSov: __t.i64(),
  feeSov: __t.i64(),
  detail: __t.string(),
  at: __t.timestamp(),
});
export type RentalReceipt = __Infer<typeof RentalReceipt>;

export const RentalStored = __t.object("RentalStored", {
  entryId: __t.u64(),
  containerId: __t.u64(),
  leaseId: __t.u64(),
  tenant: __t.identity(),
  kind: __t.string(),
  itemKey: __t.string(),
  name: __t.string(),
  quality: __t.u32(),
  qty: __t.u32(),
  packedJson: __t.string(),
  storedAt: __t.timestamp(),
});
export type RentalStored = __Infer<typeof RentalStored>;

export const RentalUnit = __t.object("RentalUnit", {
  unitRowId: __t.u64(),
  structureId: __t.u64(),
  unitId: __t.string(),
  listed: __t.bool(),
  rentPerDay: __t.u32(),
  notes: __t.string(),
  layoutRevision: __t.u32(),
  digest: __t.string(),
  kind: __t.string(),
  floor: __t.u32(),
  x0: __t.f32(),
  z0: __t.f32(),
  x1: __t.f32(),
  z1: __t.f32(),
  tx: __t.f32(),
  tz: __t.f32(),
  ax: __t.f32(),
  az: __t.f32(),
  ox: __t.f32(),
  oz: __t.f32(),
  keysJson: __t.string(),
  source: __t.string(),
  listedBy: __t.identity(),
  listedAt: __t.timestamp(),
  updatedAt: __t.timestamp(),
});
export type RentalUnit = __Infer<typeof RentalUnit>;

export const Reputation = __t.object("Reputation", {
  identity: __t.identity(),
  trustworthiness: __t.i32(),
  creatorRatingX100: __t.i32(),
  ratingCount: __t.u32(),
  socialCapital: __t.i32(),
  notoriety: __t.i32(),
  traitorUntil: __t.timestamp(),
});
export type Reputation = __Infer<typeof Reputation>;

export const ResearchPost = __t.object("ResearchPost", {
  stationKey: __t.string(),
  systemId: __t.string(),
  name: __t.string(),
  postIndex: __t.u8(),
  channelsLit: __t.u8(),
  channelsMax: __t.u8(),
  channelAt: __t.timestamp(),
  lastGrantHour: __t.u64(),
  relaysReceived: __t.u32(),
  grantedTotal: __t.i64(),
  fundedTotal: __t.i64(),
  paidTotal: __t.i64(),
  status: __t.string(),
  updatedAt: __t.timestamp(),
});
export type ResearchPost = __Infer<typeof ResearchPost>;

export const ResearchTender = __t.object("ResearchTender", {
  tenderId: __t.u64(),
  postKey: __t.string(),
  sigKey: __t.string(),
  systemId: __t.string(),
  kind: __t.string(),
  rewardSov: __t.i64(),
  state: __t.string(),
  acceptedBy: __t.identity(),
  acceptedAt: __t.timestamp(),
  deadline: __t.timestamp(),
  outcome: __t.string(),
  paidSov: __t.i64(),
  refundSov: __t.i64(),
  receipt: __t.string(),
  createdAt: __t.timestamp(),
  updatedAt: __t.timestamp(),
});
export type ResearchTender = __Infer<typeof ResearchTender>;

export const Residency = __t.object("Residency", {
  identity: __t.identity(),
  settlementId: __t.u64(),
  sinceAt: __t.timestamp(),
  paidUntil: __t.timestamp(),
});
export type Residency = __Infer<typeof Residency>;

export const ResourceListing = __t.object("ResourceListing", {
  listingId: __t.u64(),
  seller: __t.identity(),
  kind: __t.string(),
  familyKey: __t.string(),
  itemKey: __t.string(),
  name: __t.string(),
  statsJson: __t.string(),
  propsJson: __t.string(),
  quality: __t.u32(),
  ceiling: __t.u32(),
  componentsJson: __t.string(),
  serial: __t.string(),
  spawnId: __t.u64(),
  qty: __t.u32(),
  priceSov: __t.i64(),
  active: __t.bool(),
  listedAt: __t.timestamp(),
});
export type ResourceListing = __Infer<typeof ResourceListing>;

export const ResourceNode = __t.object("ResourceNode", {
  nodeId: __t.u64(),
  worldId: __t.u64(),
  settlementId: __t.u64(),
  good: __t.string(),
  x: __t.f32(),
  z: __t.f32(),
  richness: __t.u32(),
  updatedAt: __t.timestamp(),
});
export type ResourceNode = __Infer<typeof ResourceNode>;

export const ResourceSpawn = __t.object("ResourceSpawn", {
  spawnId: __t.u64(),
  worldId: __t.u64(),
  familyKey: __t.string(),
  cls: __t.string(),
  name: __t.string(),
  statsJson: __t.string(),
  seed: __t.u32(),
  active: __t.bool(),
  spawnedAt: __t.timestamp(),
  expiresAt: __t.timestamp(),
});
export type ResourceSpawn = __Infer<typeof ResourceSpawn>;

export const RestStamp = __t.object("RestStamp", {
  identity: __t.identity(),
  lastRestAt: __t.timestamp(),
});
export type RestStamp = __Infer<typeof RestStamp>;

export const Review = __t.object("Review", {
  reviewId: __t.u64(),
  subject: __t.identity(),
  reviewer: __t.identity(),
  stars: __t.u8(),
  isCaution: __t.bool(),
  ref: __t.string(),
  at: __t.timestamp(),
});
export type Review = __Infer<typeof Review>;

export const RewardReceipt = __t.object("RewardReceipt", {
  receiptKey: __t.string(),
  identity: __t.identity(),
  contextKind: __t.string(),
  contextId: __t.u64(),
  category: __t.string(),
  amount: __t.i32(),
  at: __t.timestamp(),
});
export type RewardReceipt = __Infer<typeof RewardReceipt>;

export const Ritual = __t.object("Ritual", {
  ritualId: __t.u64(),
  eventId: __t.u64(),
  repetitions: __t.u32(),
  institutionalized: __t.bool(),
  npcHostId: __t.u64(),
  lastSessionAt: __t.timestamp(),
  humansThisSession: __t.u32(),
  humansLastSession: __t.u32(),
});
export type Ritual = __Infer<typeof Ritual>;

export const RitualMute = __t.object("RitualMute", {
  muteId: __t.u64(),
  ritualId: __t.u64(),
  identity: __t.identity(),
});
export type RitualMute = __Infer<typeof RitualMute>;

export const Royalty = __t.object("Royalty", {
  royaltyId: __t.u64(),
  assetId: __t.u64(),
  originalCreator: __t.identity(),
  fromSaleTx: __t.u64(),
  amountSov: __t.i64(),
  at: __t.timestamp(),
});
export type Royalty = __Infer<typeof Royalty>;

export const ScanState = __t.object("ScanState", {
  identity: __t.identity(),
  lastScanAt: __t.timestamp(),
});
export type ScanState = __Infer<typeof ScanState>;

export const Season = __t.object("Season", {
  seasonId: __t.u64(),
  seasonIndex: __t.u32(),
  startedAt: __t.timestamp(),
  endsAt: __t.timestamp(),
  subsidyBps: __t.i64(),
  active: __t.bool(),
});
export type Season = __Infer<typeof Season>;

export const SeasonFestival = __t.object("SeasonFestival", {
  key: __t.string(),
  epoch: __t.u32(),
  season: __t.string(),
  settlementId: __t.u64(),
  eventId: __t.u64(),
  x: __t.f32(),
  z: __t.f32(),
  startsAt: __t.timestamp(),
  endsAt: __t.timestamp(),
  resolved: __t.bool(),
});
export type SeasonFestival = __Infer<typeof SeasonFestival>;

export const SeasonScore = __t.object("SeasonScore", {
  ssId: __t.u64(),
  gameId: __t.u64(),
  seasonId: __t.u64(),
  player: __t.identity(),
  bestScore: __t.i64(),
});
export type SeasonScore = __Infer<typeof SeasonScore>;

export const SectorControl = __t.object("SectorControl", {
  systemId: __t.string(),
  score: __t.i32(),
  updatedAt: __t.timestamp(),
});
export type SectorControl = __Infer<typeof SectorControl>;

export const ServiceJob = __t.object("ServiceJob", {
  jobId: __t.u64(),
  quoteId: __t.u64(),
  requestId: __t.string(),
  owner: __t.identity(),
  stationKey: __t.string(),
  role: __t.string(),
  kind: __t.string(),
  version: __t.u32(),
  shipId: __t.u64(),
  fitRev: __t.string(),
  wreckId: __t.u64(),
  restoreHp: __t.u32(),
  missiles: __t.u32(),
  counters: __t.u32(),
  parts: __t.u32(),
  source: __t.string(),
  supplier: __t.identity(),
  engineer: __t.identity(),
  operator: __t.identity(),
  partsSov: __t.i64(),
  labourSov: __t.i64(),
  rearmSov: __t.i64(),
  operatorFeeSov: __t.i64(),
  platformFeeSov: __t.i64(),
  totalSov: __t.i64(),
  state: __t.string(),
  acceptedAt: __t.timestamp(),
  readyAt: __t.timestamp(),
  endedAt: __t.timestamp(),
  receiptJson: __t.string(),
  note: __t.string(),
});
export type ServiceJob = __Infer<typeof ServiceJob>;

export const ServiceQuote = __t.object("ServiceQuote", {
  quoteId: __t.u64(),
  owner: __t.identity(),
  stationKey: __t.string(),
  role: __t.string(),
  kind: __t.string(),
  version: __t.u32(),
  shipId: __t.u64(),
  fitRev: __t.string(),
  wreckId: __t.u64(),
  hpMax: __t.u32(),
  missingHp: __t.u32(),
  restoreHp: __t.u32(),
  missiles: __t.u32(),
  counters: __t.u32(),
  parts: __t.u32(),
  source: __t.string(),
  partUnitSov: __t.i64(),
  partsSov: __t.i64(),
  labourSov: __t.i64(),
  rearmSov: __t.i64(),
  operatorFeeSov: __t.i64(),
  platformFeeSov: __t.i64(),
  totalSov: __t.i64(),
  durationS: __t.u32(),
  mustered: __t.bool(),
  unitsJson: __t.string(),
  note: __t.string(),
  state: __t.string(),
  createdAt: __t.timestamp(),
  expiresAt: __t.timestamp(),
});
export type ServiceQuote = __Infer<typeof ServiceQuote>;

export const SettlementCiv = __t.object("SettlementCiv", {
  settlementId: __t.u64(),
  civ: __t.string(),
});
export type SettlementCiv = __Infer<typeof SettlementCiv>;

export const SettlementEcon = __t.object("SettlementEcon", {
  settlementId: __t.u64(),
  worldId: __t.u64(),
  centerX: __t.f32(),
  centerZ: __t.f32(),
  stockFood: __t.u32(),
  stockOre: __t.u32(),
  stockTools: __t.u32(),
  stockLuxury: __t.u32(),
  priceFood: __t.u32(),
  priceOre: __t.u32(),
  priceTools: __t.u32(),
  priceLuxury: __t.u32(),
  treasury: __t.i64(),
  taxBps: __t.u32(),
  mayorId: __t.u64(),
  nextElectionAt: __t.timestamp(),
  projectKey: __t.string(),
  projectProgress: __t.u32(),
  projectTarget: __t.u32(),
  updatedAt: __t.timestamp(),
});
export type SettlementEcon = __Infer<typeof SettlementEcon>;

export const SettlementGoodwill = __t.object("SettlementGoodwill", {
  goodwillId: __t.u64(),
  worldId: __t.u64(),
  aId: __t.u64(),
  bId: __t.u64(),
  goodwill: __t.u32(),
  updatedAt: __t.timestamp(),
});
export type SettlementGoodwill = __Infer<typeof SettlementGoodwill>;

export const SettlementMind = __t.object("SettlementMind", {
  settlementId: __t.u64(),
  worldId: __t.u64(),
  shortageStreak: __t.u32(),
  lastAmendAt: __t.timestamp(),
  lastNormAt: __t.timestamp(),
  lastSpeechAt: __t.timestamp(),
  lastCuriosityAt: __t.timestamp(),
  updatedAt: __t.timestamp(),
});
export type SettlementMind = __Infer<typeof SettlementMind>;

export const SettlementName = __t.object("SettlementName", {
  siteId: __t.u64(),
  name: __t.string(),
  updatedAt: __t.timestamp(),
});
export type SettlementName = __Infer<typeof SettlementName>;

export const SettlementNorm = __t.object("SettlementNorm", {
  normId: __t.u64(),
  worldId: __t.u64(),
  settlementId: __t.u64(),
  key: __t.string(),
  text: __t.string(),
  adoptionX10: __t.u32(),
  createdBy: __t.u64(),
  active: __t.bool(),
  createdAt: __t.timestamp(),
  updatedAt: __t.timestamp(),
});
export type SettlementNorm = __Infer<typeof SettlementNorm>;

export const SettlementOffice = __t.object("SettlementOffice", {
  officeId: __t.u64(),
  worldId: __t.u64(),
  settlementId: __t.u64(),
  office: __t.string(),
  holderId: __t.u64(),
  holderName: __t.string(),
  sinceAt: __t.timestamp(),
});
export type SettlementOffice = __Infer<typeof SettlementOffice>;

export const SettlementParty = __t.object("SettlementParty", {
  partyId: __t.u64(),
  worldId: __t.u64(),
  settlementId: __t.u64(),
  faction: __t.string(),
  name: __t.string(),
  platformJson: __t.string(),
  leaderId: __t.u64(),
  strongCount: __t.u32(),
  foundedAt: __t.timestamp(),
  updatedAt: __t.timestamp(),
});
export type SettlementParty = __Infer<typeof SettlementParty>;

export const SettlementResidue = __t.object("SettlementResidue", {
  settlementId: __t.u64(),
  lampsLit: __t.f32(),
  lampsAt: __t.timestamp(),
  woodpile: __t.f32(),
  swept: __t.f32(),
  updatedAt: __t.timestamp(),
});
export type SettlementResidue = __Infer<typeof SettlementResidue>;

export const SettlementRivalry = __t.object("SettlementRivalry", {
  rivalryId: __t.u64(),
  worldId: __t.u64(),
  aId: __t.u64(),
  bId: __t.u64(),
  grievance: __t.u32(),
  updatedAt: __t.timestamp(),
});
export type SettlementRivalry = __Infer<typeof SettlementRivalry>;

export const SettlementScore = __t.object("SettlementScore", {
  settlementId: __t.u64(),
  cohesion: __t.f32(),
  readiness: __t.f32(),
  learning: __t.f32(),
  health: __t.f32(),
  order: __t.f32(),
  piety: __t.f32(),
  prosperity: __t.f32(),
  inflowAcc: __t.i64(),
  lastTreasury: __t.i64(),
  updatedAt: __t.timestamp(),
});
export type SettlementScore = __Infer<typeof SettlementScore>;

export const SettlementStock = __t.object("SettlementStock", {
  stockId: __t.u64(),
  settlementId: __t.u64(),
  commodity: __t.string(),
  qty: __t.f32(),
  updatedAt: __t.timestamp(),
});
export type SettlementStock = __Infer<typeof SettlementStock>;

export const SettlementTreaty = __t.object("SettlementTreaty", {
  treatyId: __t.u64(),
  worldId: __t.u64(),
  aId: __t.u64(),
  bId: __t.u64(),
  kind: __t.string(),
  status: __t.string(),
  goodwillAtForm: __t.u32(),
  formedAt: __t.timestamp(),
  renewedAt: __t.timestamp(),
  endedAt: __t.timestamp(),
});
export type SettlementTreaty = __Infer<typeof SettlementTreaty>;

export const ShipBerth = __t.object("ShipBerth", {
  identity: __t.identity(),
  worldId: __t.u64(),
  chassisKey: __t.string(),
  posX: __t.f32(),
  posZ: __t.f32(),
  yaw: __t.f32(),
  landedAt: __t.timestamp(),
});
export type ShipBerth = __Infer<typeof ShipBerth>;

export const ShipComponent = __t.object("ShipComponent", {
  compId: __t.u64(),
  shipId: __t.u64(),
  slot: __t.string(),
  itemKey: __t.string(),
  name: __t.string(),
  quality: __t.u32(),
  propsJson: __t.string(),
  serial: __t.string(),
  equippedAt: __t.timestamp(),
});
export type ShipComponent = __Infer<typeof ShipComponent>;

export const ShipDeckItem = __t.object("ShipDeckItem", {
  deckItemId: __t.u64(),
  owner: __t.identity(),
  shipId: __t.u64(),
  propKey: __t.string(),
  x: __t.f32(),
  z: __t.f32(),
  yaw: __t.f32(),
  placedAt: __t.timestamp(),
});
export type ShipDeckItem = __Infer<typeof ShipDeckItem>;

export const ShipInsurance = __t.object("ShipInsurance", {
  shipId: __t.u64(),
  owner: __t.identity(),
  premiumSov: __t.i64(),
  payoutSov: __t.i64(),
  boughtAt: __t.timestamp(),
  expiresAt: __t.timestamp(),
});
export type ShipInsurance = __Infer<typeof ShipInsurance>;

export const ShipPower = __t.object("ShipPower", {
  shipId: __t.u64(),
  preset: __t.string(),
  writer: __t.identity(),
  writerRole: __t.string(),
  epoch: __t.u32(),
  at: __t.timestamp(),
});
export type ShipPower = __Infer<typeof ShipPower>;

export const ShipSubsystem = __t.object("ShipSubsystem", {
  shipId: __t.u64(),
  owner: __t.identity(),
  chassisKey: __t.string(),
  engine: __t.u32(),
  weapons: __t.u32(),
  judgedEngine: __t.u32(),
  judgedWeapons: __t.u32(),
  fitRev: __t.string(),
  bucket: __t.f64(),
  bucketAtMs: __t.f64(),
  reports: __t.u32(),
  lastCause: __t.string(),
  lastProv: __t.string(),
  rulesVersion: __t.u32(),
  updatedAt: __t.timestamp(),
});
export type ShipSubsystem = __Infer<typeof ShipSubsystem>;

export const ShipWreck = __t.object("ShipWreck", {
  wreckId: __t.u64(),
  killId: __t.u64(),
  victim: __t.identity(),
  victimName: __t.string(),
  chassisKey: __t.string(),
  systemId: __t.string(),
  x: __t.f64(),
  y: __t.f64(),
  z: __t.f64(),
  createdAt: __t.timestamp(),
  expiresAt: __t.timestamp(),
});
export type ShipWreck = __Infer<typeof ShipWreck>;

export const SigReveal = __t.object("SigReveal", {
  revealId: __t.u64(),
  identity: __t.identity(),
  sigKey: __t.string(),
  systemId: __t.string(),
  epoch: __t.u32(),
  kind: __t.string(),
  round: __t.u8(),
  bearingDeg: __t.f64(),
  rangeM: __t.f64(),
  x: __t.f64(),
  y: __t.f64(),
  z: __t.f64(),
  at: __t.timestamp(),
});
export type SigReveal = __Infer<typeof SigReveal>;

export const SimLod = __t.object("SimLod", {
  systemId: __t.string(),
  lod: __t.u8(),
  authorityEpoch: __t.u64(),
  observers: __t.u32(),
  lastPresenceAt: __t.timestamp(),
  changedAt: __t.timestamp(),
  updatedAt: __t.timestamp(),
});
export type SimLod = __Infer<typeof SimLod>;

export const SimTickLedger = __t.object("SimTickLedger", {
  name: __t.string(),
  seq: __t.u64(),
  lastAt: __t.timestamp(),
  gapMicros: __t.u64(),
});
export type SimTickLedger = __Infer<typeof SimTickLedger>;

export const SkyLightingProfile = __t.object("SkyLightingProfile", {
  profileId: __t.u64(),
  band: __t.string(),
  envmapAssetId: __t.u64(),
  sunColorHex: __t.string(),
  sunIntensity: __t.f32(),
  sunElevationDeg: __t.f32(),
  ambientIntensity: __t.f32(),
});
export type SkyLightingProfile = __Infer<typeof SkyLightingProfile>;

export const SkyShipAboard = __t.object("SkyShipAboard", {
  identity: __t.identity(),
  siteId: __t.u32(),
  at: __t.timestamp(),
});
export type SkyShipAboard = __Infer<typeof SkyShipAboard>;

export const SkyShipState = __t.object("SkyShipState", {
  identity: __t.identity(),
  lastAt: __t.timestamp(),
});
export type SkyShipState = __Infer<typeof SkyShipState>;

export const SkyState = __t.object("SkyState", {
  worldId: __t.u64(),
  timeOfDay: __t.f32(),
  weather: __t.string(),
  cycleSeconds: __t.u32(),
  updatedAt: __t.timestamp(),
});
export type SkyState = __Infer<typeof SkyState>;

export const SpaceAdvice = __t.object("SpaceAdvice", {
  adviceId: __t.u64(),
  civ: __t.string(),
  cyc: __t.u64(),
  operation: __t.string(),
  source: __t.string(),
  say: __t.string(),
  at: __t.timestamp(),
});
export type SpaceAdvice = __Infer<typeof SpaceAdvice>;

export const SpaceAmbush = __t.object("SpaceAmbush", {
  ambushId: __t.u64(),
  shipmentId: __t.u64(),
  denKey: __t.string(),
  raiders: __t.u32(),
  raidersAlive: __t.u32(),
  x: __t.f64(),
  y: __t.f64(),
  z: __t.f64(),
  startedAt: __t.timestamp(),
  resolveAt: __t.timestamp(),
  lastAttritionAt: __t.timestamp(),
  state: __t.string(),
  updatedAt: __t.timestamp(),
});
export type SpaceAmbush = __Infer<typeof SpaceAmbush>;

export const SpaceBookmark = __t.object("SpaceBookmark", {
  bookmarkId: __t.u64(),
  owner: __t.identity(),
  civ: __t.string(),
  systemId: __t.string(),
  x: __t.f64(),
  y: __t.f64(),
  z: __t.f64(),
  label: __t.string(),
  kind: __t.string(),
  createdAt: __t.timestamp(),
});
export type SpaceBookmark = __Infer<typeof SpaceBookmark>;

export const SpaceBounty = __t.object("SpaceBounty", {
  spaceBountyId: __t.u64(),
  identity: __t.identity(),
  pirateKey: __t.string(),
  paidSov: __t.i64(),
  at: __t.timestamp(),
});
export type SpaceBounty = __Infer<typeof SpaceBounty>;

export const SpaceCampaign = __t.object("SpaceCampaign", {
  campaignId: __t.u64(),
  cyc: __t.u64(),
  fortKey: __t.string(),
  targetSystem: __t.string(),
  state: __t.string(),
  openedAt: __t.timestamp(),
  endsAt: __t.timestamp(),
  winner: __t.string(),
  retreatSide: __t.i32(),
  rounds: __t.u32(),
  updatedAt: __t.timestamp(),
});
export type SpaceCampaign = __Infer<typeof SpaceCampaign>;

export const SpaceClaim = __t.object("SpaceClaim", {
  claimId: __t.u64(),
  identity: __t.identity(),
  claimKey: __t.string(),
  at: __t.timestamp(),
});
export type SpaceClaim = __Infer<typeof SpaceClaim>;

export const SpaceCrew = __t.object("SpaceCrew", {
  crewId: __t.u64(),
  captain: __t.identity(),
  crew: __t.identity(),
  seat: __t.string(),
  systemId: __t.string(),
  since: __t.timestamp(),
  updatedAt: __t.timestamp(),
});
export type SpaceCrew = __Infer<typeof SpaceCrew>;

export const SpaceDeposit = __t.object("SpaceDeposit", {
  depositId: __t.u64(),
  systemId: __t.string(),
  beltKey: __t.string(),
  oreKey: __t.string(),
  remaining: __t.u32(),
  capacity: __t.u32(),
  updatedAt: __t.timestamp(),
});
export type SpaceDeposit = __Infer<typeof SpaceDeposit>;

export const SpaceFirm = __t.object("SpaceFirm", {
  firmId: __t.u64(),
  key: __t.string(),
  name: __t.string(),
  civ: __t.string(),
  kind: __t.string(),
  stationKey: __t.string(),
  beltKey: __t.string(),
  hulls: __t.u32(),
  hullsTarget: __t.u32(),
  shortHours: __t.u32(),
  lastEpoch: __t.u64(),
  createdAt: __t.timestamp(),
  updatedAt: __t.timestamp(),
});
export type SpaceFirm = __Infer<typeof SpaceFirm>;

export const SpaceIntel = __t.object("SpaceIntel", {
  intelId: __t.u64(),
  observer: __t.identity(),
  civ: __t.string(),
  systemId: __t.string(),
  sensor: __t.string(),
  observedAt: __t.timestamp(),
  payload: __t.string(),
  updatedAt: __t.timestamp(),
});
export type SpaceIntel = __Infer<typeof SpaceIntel>;

export const SpaceLocation = __t.object("SpaceLocation", {
  identity: __t.identity(),
  systemId: __t.string(),
  mode: __t.string(),
  stationKey: __t.string(),
  seq: __t.u32(),
  updatedAt: __t.timestamp(),
});
export type SpaceLocation = __Infer<typeof SpaceLocation>;

export const SpaceMarketDepth = __t.object("SpaceMarketDepth", {
  depthId: __t.u64(),
  stationKey: __t.string(),
  commodity: __t.string(),
  epoch: __t.u64(),
  boughtU: __t.u32(),
  soldU: __t.u32(),
  updatedAt: __t.timestamp(),
});
export type SpaceMarketDepth = __Infer<typeof SpaceMarketDepth>;

export const SpaceOperation = __t.object("SpaceOperation", {
  opId: __t.u64(),
  guildId: __t.u64(),
  side: __t.u8(),
  civ: __t.string(),
  cyc: __t.u64(),
  campaignId: __t.u64(),
  state: __t.string(),
  rulesVersion: __t.u32(),
  allocJson: __t.string(),
  totalSov: __t.i64(),
  heldSov: __t.i64(),
  paidSov: __t.i64(),
  refundSov: __t.i64(),
  fundMotionId: __t.u64(),
  cancelMotionId: __t.u64(),
  proposer: __t.identity(),
  beaconKey: __t.string(),
  fundTxId: __t.u64(),
  payTxId: __t.u64(),
  settleCause: __t.string(),
  history: __t.string(),
  note: __t.string(),
  createdAt: __t.timestamp(),
  activeAt: __t.timestamp(),
  cutoffAt: __t.timestamp(),
  settledAt: __t.timestamp(),
  updatedAt: __t.timestamp(),
});
export type SpaceOperation = __Infer<typeof SpaceOperation>;

export const SpacePresence = __t.object("SpacePresence", {
  identity: __t.identity(),
  systemKey: __t.string(),
  chassisKey: __t.string(),
  updatedAt: __t.timestamp(),
});
export type SpacePresence = __Infer<typeof SpacePresence>;

export const SpacePriceMod = __t.object("SpacePriceMod", {
  modId: __t.u64(),
  stationKey: __t.string(),
  commodity: __t.string(),
  mult: __t.f32(),
  reason: __t.string(),
  updatedAt: __t.timestamp(),
});
export type SpacePriceMod = __Infer<typeof SpacePriceMod>;

export const SpacePvpHit = __t.object("SpacePvpHit", {
  hitId: __t.u64(),
  attacker: __t.identity(),
  target: __t.identity(),
  systemId: __t.string(),
  dmg: __t.f64(),
  x: __t.f64(),
  y: __t.f64(),
  z: __t.f64(),
  at: __t.timestamp(),
});
export type SpacePvpHit = __Infer<typeof SpacePvpHit>;

export const SpaceSecret = __t.object("SpaceSecret", {
  secretId: __t.u8(),
  salt: __t.string(),
  createdAt: __t.timestamp(),
});
export type SpaceSecret = __Infer<typeof SpaceSecret>;

export const SpaceSession = __t.object("SpaceSession", {
  identity: __t.identity(),
  originSid: __t.u64(),
  enteredAt: __t.timestamp(),
});
export type SpaceSession = __Infer<typeof SpaceSession>;

export const SpaceShipment = __t.object("SpaceShipment", {
  shipmentId: __t.u64(),
  firmId: __t.u64(),
  fromKey: __t.string(),
  toKey: __t.string(),
  familyKey: __t.string(),
  qty: __t.u32(),
  valueSov: __t.i64(),
  departAt: __t.timestamp(),
  arriveAt: __t.timestamp(),
  ambushAt: __t.timestamp(),
  ambushRoll: __t.f32(),
  ambushRolled: __t.bool(),
  state: __t.string(),
  escortedBy: __t.identity(),
  escortProjectId: __t.u64(),
  lossX: __t.f64(),
  lossY: __t.f64(),
  lossZ: __t.f64(),
  updatedAt: __t.timestamp(),
});
export type SpaceShipment = __Infer<typeof SpaceShipment>;

export const SpaceSig = __t.object("SpaceSig", {
  sigId: __t.u64(),
  sigKey: __t.string(),
  systemId: __t.string(),
  epoch: __t.u32(),
  kind: __t.string(),
  x: __t.f64(),
  y: __t.f64(),
  z: __t.f64(),
  createdAt: __t.timestamp(),
});
export type SpaceSig = __Infer<typeof SpaceSig>;

export const SpaceStructure = __t.object("SpaceStructure", {
  structId: __t.u64(),
  owner: __t.identity(),
  kind: __t.string(),
  systemId: __t.string(),
  x: __t.f64(),
  y: __t.f64(),
  z: __t.f64(),
  deedJson: __t.string(),
  deployedAt: __t.timestamp(),
});
export type SpaceStructure = __Infer<typeof SpaceStructure>;

export const SpaceTackle = __t.object("SpaceTackle", {
  identity: __t.identity(),
  by: __t.identity(),
  until: __t.timestamp(),
});
export type SpaceTackle = __Infer<typeof SpaceTackle>;

export const SpendVote = __t.object("SpendVote", {
  voteId: __t.u64(),
  spendId: __t.u64(),
  voter: __t.identity(),
  yes: __t.bool(),
  at: __t.timestamp(),
});
export type SpendVote = __Infer<typeof SpendVote>;

export const SpyMission = __t.object("SpyMission", {
  spyId: __t.u64(),
  worldId: __t.u64(),
  fromSid: __t.u64(),
  toSid: __t.u64(),
  agentId: __t.u64(),
  kind: __t.string(),
  state: __t.string(),
  detail: __t.string(),
  at: __t.timestamp(),
  updatedAt: __t.timestamp(),
});
export type SpyMission = __Infer<typeof SpyMission>;

export const StarterKit = __t.object("StarterKit", {
  identity: __t.identity(),
  grantedAt: __t.timestamp(),
});
export type StarterKit = __Infer<typeof StarterKit>;

export const StationMuster = __t.object("StationMuster", {
  key: __t.string(),
  cyc: __t.u64(),
  identity: __t.identity(),
  civ: __t.string(),
  stationKey: __t.string(),
  hull: __t.string(),
  at: __t.timestamp(),
});
export type StationMuster = __Infer<typeof StationMuster>;

export const StationService = __t.object("StationService", {
  stationKey: __t.string(),
  role: __t.string(),
  berths: __t.u8(),
  busy: __t.u8(),
  source: __t.string(),
  operatorFirmId: __t.u64(),
  partsAvail: __t.u32(),
  reliefStock: __t.u32(),
  reliefCap: __t.u32(),
  reliefHour: __t.u64(),
  budgetDay: __t.u64(),
  budgetUsed: __t.u32(),
  outage: __t.string(),
  numbersJson: __t.string(),
  changedAt: __t.timestamp(),
  checkedAt: __t.timestamp(),
});
export type StationService = __Infer<typeof StationService>;

export const Structure = __t.object("Structure", {
  structureId: __t.u64(),
  worldId: __t.u64(),
  owner: __t.identity(),
  structureType: __t.string(),
  cellX: __t.i32(),
  cellZ: __t.i32(),
  posX: __t.f32(),
  posY: __t.f32(),
  posZ: __t.f32(),
  yaw: __t.f32(),
  modelAssetId: __t.u64(),
  lotsUsed: __t.u8(),
  maintPool: __t.i64(),
  powerPool: __t.i64(),
  condition: __t.u32(),
  itemCap: __t.u32(),
  itemCount: __t.u32(),
  cityId: __t.u64(),
  outsideCity: __t.bool(),
  lastMaintAt: __t.timestamp(),
  redeedPendingAt: __t.timestamp(),
  placedAt: __t.timestamp(),
});
export type Structure = __Infer<typeof Structure>;

export const StructureContainer = __t.object("StructureContainer", {
  containerId: __t.u64(),
  structureId: __t.u64(),
  key: __t.string(),
  kind: __t.string(),
  capacity: __t.u32(),
  createdAt: __t.timestamp(),
});
export type StructureContainer = __Infer<typeof StructureContainer>;

export const StructureDeed = __t.object("StructureDeed", {
  deedId: __t.u64(),
  owner: __t.identity(),
  structureType: __t.string(),
  lotsRequired: __t.u8(),
  baseMaintPerHour: __t.u32(),
  redeedFactor: __t.u8(),
  itemCap: __t.u32(),
  isCivic: __t.bool(),
  packed: __t.bool(),
  storedMaint: __t.i64(),
  noTrade: __t.bool(),
  createdAt: __t.timestamp(),
});
export type StructureDeed = __Infer<typeof StructureDeed>;

export const StructureFurnish = __t.object("StructureFurnish", {
  structureId: __t.u64(),
  pack: __t.u8(),
  paidSov: __t.i64(),
  boughtAt: __t.timestamp(),
});
export type StructureFurnish = __Infer<typeof StructureFurnish>;

export const StructureItem = __t.object("StructureItem", {
  itemId: __t.u64(),
  structureId: __t.u64(),
  prefabId: __t.string(),
  modelAssetId: __t.u64(),
  lx: __t.f32(),
  ly: __t.f32(),
  lz: __t.f32(),
  pitch: __t.f32(),
  yaw: __t.f32(),
  roll: __t.f32(),
  placedBy: __t.identity(),
  placedAt: __t.timestamp(),
  itemKey: __t.string(),
  packedItemJson: __t.string(),
});
export type StructureItem = __Infer<typeof StructureItem>;

export const StructureLayout = __t.object("StructureLayout", {
  structureId: __t.u64(),
  layoutRevision: __t.u32(),
  digest: __t.string(),
  pinnedAt: __t.timestamp(),
});
export type StructureLayout = __Infer<typeof StructureLayout>;

export const StructureMeta = __t.object("StructureMeta", {
  structureId: __t.u64(),
  name: __t.string(),
  entry: __t.string(),
  updatedAt: __t.timestamp(),
});
export type StructureMeta = __Infer<typeof StructureMeta>;

export const StructureNote = __t.object("StructureNote", {
  noteId: __t.u64(),
  structureId: __t.u64(),
  author: __t.identity(),
  authorName: __t.string(),
  text: __t.string(),
  at: __t.timestamp(),
});
export type StructureNote = __Infer<typeof StructureNote>;

export const StructurePermission = __t.object("StructurePermission", {
  permId: __t.u64(),
  structureId: __t.u64(),
  subject: __t.identity(),
  level: __t.string(),
  at: __t.timestamp(),
});
export type StructurePermission = __Infer<typeof StructurePermission>;

export const StructurePlanter = __t.object("StructurePlanter", {
  planterId: __t.u64(),
  structureId: __t.u64(),
  key: __t.string(),
  familyKey: __t.string(),
  name: __t.string(),
  statsJson: __t.string(),
  spawnId: __t.u64(),
  plantedAt: __t.timestamp(),
  readyAt: __t.timestamp(),
});
export type StructurePlanter = __Infer<typeof StructurePlanter>;

export const StructureSiege = __t.object("StructureSiege", {
  structureId: __t.u64(),
  hp: __t.i32(),
  state: __t.string(),
  reinforcedUntil: __t.timestamp(),
  updatedAt: __t.timestamp(),
});
export type StructureSiege = __Infer<typeof StructureSiege>;

export const Subscription = __t.object("Subscription", {
  subId: __t.u64(),
  patron: __t.identity(),
  creator: __t.identity(),
  kind: __t.string(),
  amountSov: __t.i64(),
  periodDays: __t.u32(),
  nextChargeAt: __t.timestamp(),
  active: __t.bool(),
  createdAt: __t.timestamp(),
});
export type Subscription = __Infer<typeof Subscription>;

export const SubsystemAim = __t.object("SubsystemAim", {
  identity: __t.identity(),
  aim: __t.string(),
  at: __t.timestamp(),
});
export type SubsystemAim = __Infer<typeof SubsystemAim>;

export const SubsystemHit = __t.object("SubsystemHit", {
  hitId: __t.u64(),
  shipId: __t.u64(),
  at: __t.timestamp(),
});
export type SubsystemHit = __Infer<typeof SubsystemHit>;

export const SubsystemJob = __t.object("SubsystemJob", {
  jobId: __t.u64(),
  shipId: __t.u64(),
  owner: __t.identity(),
  actor: __t.identity(),
  role: __t.string(),
  leaseId: __t.u64(),
  epoch: __t.u32(),
  target: __t.string(),
  kitJson: __t.string(),
  kitSerial: __t.string(),
  kitOwner: __t.identity(),
  fitRev: __t.string(),
  locSeq: __t.u32(),
  workMs: __t.u32(),
  lastBeatMs: __t.f64(),
  requestId: __t.string(),
  startedAt: __t.timestamp(),
  updatedAt: __t.timestamp(),
});
export type SubsystemJob = __Infer<typeof SubsystemJob>;

export const SubsystemReceipt = __t.object("SubsystemReceipt", {
  receiptKey: __t.string(),
  actor: __t.identity(),
  owner: __t.identity(),
  shipId: __t.u64(),
  target: __t.string(),
  outcome: __t.string(),
  before: __t.u32(),
  after: __t.u32(),
  add: __t.u32(),
  eligibleRestored: __t.u32(),
  kitSerial: __t.string(),
  epoch: __t.u32(),
  detail: __t.string(),
  at: __t.timestamp(),
});
export type SubsystemReceipt = __Infer<typeof SubsystemReceipt>;

export const SurveyFirst = __t.object("SurveyFirst", {
  sigKey: __t.string(),
  systemId: __t.string(),
  kind: __t.string(),
  discoverer: __t.identity(),
  at: __t.timestamp(),
  contentVersion: __t.u8(),
});
export type SurveyFirst = __Infer<typeof SurveyFirst>;

export const SurveyLease = __t.object("SurveyLease", {
  leaseId: __t.u64(),
  sigKey: __t.string(),
  claimant: __t.identity(),
  systemId: __t.string(),
  kind: __t.string(),
  tenderId: __t.u64(),
  shipId: __t.u64(),
  reservedU: __t.u32(),
  bondSov: __t.i64(),
  mode: __t.string(),
  progressMs: __t.u32(),
  needMs: __t.u32(),
  lastBeatAt: __t.timestamp(),
  stepSeq: __t.u32(),
  state: __t.string(),
  endReason: __t.string(),
  expiresAt: __t.timestamp(),
  createdAt: __t.timestamp(),
  updatedAt: __t.timestamp(),
});
export type SurveyLease = __Infer<typeof SurveyLease>;

export const SurveySite = __t.object("SurveySite", {
  sigKey: __t.string(),
  systemId: __t.string(),
  epoch: __t.u32(),
  sigKind: __t.string(),
  kind: __t.string(),
  contentVersion: __t.u8(),
  state: __t.string(),
  stock: __t.u32(),
  stockMax: __t.u32(),
  hazard: __t.u8(),
  collapseAt: __t.u8(),
  quality: __t.u32(),
  famKey: __t.string(),
  recoverUntil: __t.timestamp(),
  leaseId: __t.u64(),
  extractedU: __t.u32(),
  lostU: __t.u32(),
  stabilizations: __t.u32(),
  updatedAt: __t.timestamp(),
});
export type SurveySite = __Infer<typeof SurveySite>;

export const SurveyView = __t.object("SurveyView", {
  viewId: __t.u64(),
  identity: __t.identity(),
  sigKey: __t.string(),
  systemId: __t.string(),
  epoch: __t.u32(),
  kind: __t.string(),
  stage: __t.string(),
  state: __t.string(),
  stock: __t.u32(),
  hazard: __t.u8(),
  collapseAt: __t.u8(),
  band: __t.string(),
  knownAt: __t.timestamp(),
  source: __t.string(),
  leasedBy: __t.string(),
  leaseExpiresAt: __t.timestamp(),
  recoverUntil: __t.timestamp(),
  workMode: __t.string(),
  workMs: __t.u32(),
  workNeedMs: __t.u32(),
  lastBeatAt: __t.timestamp(),
  stepSeq: __t.u32(),
  firstByMe: __t.bool(),
  updatedAt: __t.timestamp(),
});
export type SurveyView = __Infer<typeof SurveyView>;

export const TerrainEdit = __t.object("TerrainEdit", {
  editId: __t.u64(),
  worldId: __t.u64(),
  kind: __t.string(),
  x: __t.f32(),
  z: __t.f32(),
  radius: __t.f32(),
  value: __t.f32(),
  layer: __t.u8(),
  createdBy: __t.identity(),
  createdAt: __t.timestamp(),
});
export type TerrainEdit = __Infer<typeof TerrainEdit>;

export const TerrainRegion = __t.object("TerrainRegion", {
  regionId: __t.u64(),
  worldId: __t.u64(),
  regionX: __t.i32(),
  regionZ: __t.i32(),
  biome: __t.string(),
  noBuild: __t.bool(),
  heightmapRef: __t.string(),
});
export type TerrainRegion = __Infer<typeof TerrainRegion>;

export const TicketParty = __t.object("TicketParty", {
  partyId: __t.u64(),
  gameId: __t.u64(),
  leader: __t.identity(),
  members: __t.string(),
  queuedAt: __t.timestamp(),
});
export type TicketParty = __Infer<typeof TicketParty>;

export const TipRecord = __t.object("TipRecord", {
  tipId: __t.u64(),
  fromIdentity: __t.identity(),
  toIdentity: __t.identity(),
  worldId: __t.u64(),
  amountSov: __t.i64(),
  at: __t.timestamp(),
});
export type TipRecord = __Infer<typeof TipRecord>;

export const Trade = __t.object("Trade", {
  tradeId: __t.u64(),
  a: __t.identity(),
  b: __t.identity(),
  state: __t.string(),
  rev: __t.u32(),
  offerA: __t.string(),
  offerB: __t.string(),
  sovA: __t.i64(),
  sovB: __t.i64(),
  confirmA: __t.u32(),
  confirmB: __t.u32(),
  result: __t.string(),
  expiresAt: __t.timestamp(),
  at: __t.timestamp(),
  updatedAt: __t.timestamp(),
});
export type Trade = __Infer<typeof Trade>;

export const TradeOrder = __t.object("TradeOrder", {
  orderId: __t.u64(),
  settlementId: __t.u64(),
  commodity: __t.string(),
  qty: __t.f32(),
  premiumBps: __t.i32(),
  postedAt: __t.timestamp(),
  expiresAt: __t.timestamp(),
});
export type TradeOrder = __Infer<typeof TradeOrder>;

export const TradeReservation = __t.object("TradeReservation", {
  resKey: __t.string(),
  tradeId: __t.u64(),
  owner: __t.identity(),
});
export type TradeReservation = __Infer<typeof TradeReservation>;

export const TravelOrder = __t.object("TravelOrder", {
  travelId: __t.u64(),
  identity: __t.identity(),
  requestId: __t.string(),
  mode: __t.string(),
  fromSystem: __t.string(),
  toSystem: __t.string(),
  whKey: __t.string(),
  departAt: __t.timestamp(),
  arriveAt: __t.timestamp(),
  state: __t.string(),
});
export type TravelOrder = __Infer<typeof TravelOrder>;

export const TravelReturn = __t.object("TravelReturn", {
  identity: __t.identity(),
  worldId: __t.u64(),
  posX: __t.f32(),
  posY: __t.f32(),
  posZ: __t.f32(),
  yaw: __t.f32(),
  savedAt: __t.timestamp(),
});
export type TravelReturn = __Infer<typeof TravelReturn>;

export const TreasurySpend = __t.object("TreasurySpend", {
  spendId: __t.u64(),
  groupId: __t.u64(),
  officer: __t.identity(),
  amountSov: __t.i64(),
  purpose: __t.string(),
  requiresVote: __t.bool(),
  approved: __t.bool(),
  executed: __t.bool(),
  voteClosesAt: __t.timestamp(),
  at: __t.timestamp(),
});
export type TreasurySpend = __Infer<typeof TreasurySpend>;

export const TribunalCase = __t.object("TribunalCase", {
  caseId: __t.u64(),
  civ: __t.string(),
  aSid: __t.u64(),
  bSid: __t.u64(),
  payerSid: __t.u64(),
  tier: __t.i32(),
  award: __t.i64(),
  status: __t.string(),
  aAccepts: __t.bool(),
  bAccepts: __t.bool(),
  text: __t.string(),
  source: __t.string(),
  proposedAt: __t.timestamp(),
  coolUntil: __t.timestamp(),
  resolvedAt: __t.timestamp(),
});
export type TribunalCase = __Infer<typeof TribunalCase>;

export const UnitCondition = __t.object("UnitCondition", {
  versonaId: __t.u64(),
  worldId: __t.u64(),
  battleId: __t.u64(),
  suppression: __t.f32(),
  cover: __t.f32(),
  fatigue: __t.f32(),
  injuryTier: __t.u32(),
  fitForDutyAt: __t.timestamp(),
  lastFireAt: __t.timestamp(),
  updatedAt: __t.timestamp(),
});
export type UnitCondition = __Infer<typeof UnitCondition>;

export const UnstickRescueState = __t.object("UnstickRescueState", {
  identity: __t.identity(),
  lastAt: __t.timestamp(),
});
export type UnstickRescueState = __Infer<typeof UnstickRescueState>;

export const UnstickState = __t.object("UnstickState", {
  identity: __t.identity(),
  lastAt: __t.timestamp(),
});
export type UnstickState = __Infer<typeof UnstickState>;

export const Versona = __t.object("Versona", {
  versonaId: __t.u64(),
  worldId: __t.u64(),
  archetype: __t.string(),
  homeCityId: __t.u64(),
  spawnX: __t.f32(),
  spawnZ: __t.f32(),
  curX: __t.f32(),
  curZ: __t.f32(),
  behaviorTree: __t.string(),
  scheduleJson: __t.string(),
  state: __t.string(),
  updatedAt: __t.timestamp(),
});
export type Versona = __Infer<typeof Versona>;

export const VersonaAspiration = __t.object("VersonaAspiration", {
  versonaId: __t.u64(),
  worldId: __t.u64(),
  kind: __t.string(),
  targetId: __t.u64(),
  progress: __t.u32(),
  startedAt: __t.timestamp(),
  updatedAt: __t.timestamp(),
});
export type VersonaAspiration = __Infer<typeof VersonaAspiration>;

export const VersonaBelief = __t.object("VersonaBelief", {
  beliefId: __t.u64(),
  versonaId: __t.u64(),
  worldId: __t.u64(),
  kind: __t.string(),
  subjectId: __t.u64(),
  subjectKey: __t.string(),
  text: __t.string(),
  weight: __t.i32(),
  confidence: __t.u32(),
  updatedAt: __t.timestamp(),
});
export type VersonaBelief = __Infer<typeof VersonaBelief>;

export const VersonaChat = __t.object("VersonaChat", {
  chatId: __t.u64(),
  worldId: __t.u64(),
  versonaId: __t.u64(),
  speaker: __t.string(),
  speakerName: __t.string(),
  text: __t.string(),
  answered: __t.bool(),
  at: __t.timestamp(),
});
export type VersonaChat = __Infer<typeof VersonaChat>;

export const VersonaDeliberation = __t.object("VersonaDeliberation", {
  delibId: __t.u64(),
  worldId: __t.u64(),
  settlementId: __t.u64(),
  versonaId: __t.u64(),
  kind: __t.string(),
  fingerprint: __t.string(),
  contextJson: __t.string(),
  status: __t.string(),
  answerJson: __t.string(),
  createdAt: __t.timestamp(),
  expiresAt: __t.timestamp(),
});
export type VersonaDeliberation = __Infer<typeof VersonaDeliberation>;

export const VersonaEmotion = __t.object("VersonaEmotion", {
  emotionId: __t.u64(),
  versonaId: __t.u64(),
  worldId: __t.u64(),
  etype: __t.string(),
  targetId: __t.u64(),
  causeRef: __t.u64(),
  causeText: __t.string(),
  intensity: __t.u32(),
  halfLifeS: __t.u32(),
  attendantOf: __t.u64(),
  elicitedAt: __t.timestamp(),
});
export type VersonaEmotion = __Infer<typeof VersonaEmotion>;

export const VersonaEncounter = __t.object("VersonaEncounter", {
  encounterId: __t.u64(),
  worldId: __t.u64(),
  settlementId: __t.u64(),
  aId: __t.u64(),
  bId: __t.u64(),
  playerHex: __t.string(),
  kind: __t.string(),
  state: __t.string(),
  targetDist: __t.f32(),
  tier: __t.string(),
  escalation: __t.u32(),
  startedAt: __t.timestamp(),
  stateSince: __t.timestamp(),
  expiresAt: __t.timestamp(),
});
export type VersonaEncounter = __Infer<typeof VersonaEncounter>;

export const VersonaEquipment = __t.object("VersonaEquipment", {
  equipId: __t.u64(),
  versonaId: __t.u64(),
  slot: __t.string(),
  itemKey: __t.string(),
  name: __t.string(),
  quality: __t.u32(),
  acquiredAt: __t.timestamp(),
});
export type VersonaEquipment = __Infer<typeof VersonaEquipment>;

export const VersonaFavor = __t.object("VersonaFavor", {
  favorId: __t.u64(),
  aId: __t.u64(),
  bId: __t.u64(),
  worldId: __t.u64(),
  balance: __t.i32(),
  note: __t.string(),
  updatedAt: __t.timestamp(),
});
export type VersonaFavor = __Infer<typeof VersonaFavor>;

export const VersonaGoal = __t.object("VersonaGoal", {
  versonaId: __t.u64(),
  x: __t.f32(),
  z: __t.f32(),
  state: __t.string(),
  expiresAt: __t.timestamp(),
});
export type VersonaGoal = __Infer<typeof VersonaGoal>;

export const VersonaGrudge = __t.object("VersonaGrudge", {
  grudgeId: __t.u64(),
  versonaId: __t.u64(),
  targetId: __t.u64(),
  worldId: __t.u64(),
  causeText: __t.string(),
  intensity: __t.u32(),
  offenses: __t.u32(),
  lastRuminatedAt: __t.timestamp(),
  createdAt: __t.timestamp(),
});
export type VersonaGrudge = __Infer<typeof VersonaGrudge>;

export const VersonaGuild = __t.object("VersonaGuild", {
  vguildId: __t.u64(),
  settlementId: __t.u64(),
  trade: __t.string(),
  seat: __t.u32(),
  name: __t.string(),
  tag: __t.string(),
  worldId: __t.u64(),
  x: __t.f64(),
  z: __t.f64(),
  yaw: __t.f32(),
  tier: __t.u32(),
  masterVersona: __t.u64(),
  termEnds: __t.timestamp(),
  foundedAt: __t.timestamp(),
  lastMeetingEpoch: __t.u64(),
  lastDuesDay: __t.u32(),
  updatedAt: __t.timestamp(),
});
export type VersonaGuild = __Infer<typeof VersonaGuild>;

export const VersonaGuildMember = __t.object("VersonaGuildMember", {
  vgmKey: __t.string(),
  vguildId: __t.u64(),
  versonaId: __t.u64(),
  rank: __t.string(),
  joinedAt: __t.timestamp(),
});
export type VersonaGuildMember = __Infer<typeof VersonaGuildMember>;

export const VersonaInjury = __t.object("VersonaInjury", {
  versonaId: __t.u64(),
  hp: __t.i32(),
  lastAttackerId: __t.u64(),
  updatedAt: __t.timestamp(),
});
export type VersonaInjury = __Infer<typeof VersonaInjury>;

export const VersonaIntent = __t.object("VersonaIntent", {
  versonaId: __t.u64(),
  worldId: __t.u64(),
  activity: __t.string(),
  commitment: __t.u32(),
  adoptedAt: __t.timestamp(),
  expiresAt: __t.timestamp(),
});
export type VersonaIntent = __Infer<typeof VersonaIntent>;

export const VersonaJourney = __t.object("VersonaJourney", {
  versonaId: __t.u64(),
  worldId: __t.u64(),
  kind: __t.string(),
  chassisKey: __t.string(),
  reason: __t.string(),
  fromX: __t.f32(),
  fromZ: __t.f32(),
  destX: __t.f32(),
  destZ: __t.f32(),
  curX: __t.f32(),
  curZ: __t.f32(),
  cruiseAlt: __t.f32(),
  altitude: __t.f32(),
  speed: __t.f32(),
  yaw: __t.f32(),
  arriveState: __t.string(),
  startedAt: __t.timestamp(),
  updatedAt: __t.timestamp(),
});
export type VersonaJourney = __Infer<typeof VersonaJourney>;

export const VersonaLineage = __t.object("VersonaLineage", {
  childId: __t.u64(),
  parentA: __t.u64(),
  parentB: __t.u64(),
  worldId: __t.u64(),
  settlementId: __t.u64(),
  generation: __t.u32(),
  bornAt: __t.timestamp(),
});
export type VersonaLineage = __Infer<typeof VersonaLineage>;

export const VersonaListing = __t.object("VersonaListing", {
  listingId: __t.u64(),
  versonaId: __t.u64(),
  settlementId: __t.u64(),
  good: __t.string(),
  name: __t.string(),
  qty: __t.u32(),
  priceSov: __t.i64(),
  active: __t.bool(),
  listedAt: __t.timestamp(),
});
export type VersonaListing = __Infer<typeof VersonaListing>;

export const VersonaMadeItem = __t.object("VersonaMadeItem", {
  itemId: __t.u64(),
  versonaId: __t.u64(),
  settlementId: __t.u64(),
  itemKey: __t.string(),
  quality: __t.i32(),
  madeAt: __t.timestamp(),
});
export type VersonaMadeItem = __Infer<typeof VersonaMadeItem>;

export const VersonaMemory = __t.object("VersonaMemory", {
  memoryId: __t.u64(),
  versonaId: __t.u64(),
  worldId: __t.u64(),
  kind: __t.string(),
  factKey: __t.string(),
  text: __t.string(),
  importance: __t.u32(),
  at: __t.timestamp(),
});
export type VersonaMemory = __Infer<typeof VersonaMemory>;

export const VersonaOpinion = __t.object("VersonaOpinion", {
  versonaId: __t.u64(),
  worldId: __t.u64(),
  leanX10: __t.i32(),
  updatedAt: __t.timestamp(),
});
export type VersonaOpinion = __Infer<typeof VersonaOpinion>;

export const VersonaOrigin = __t.object("VersonaOrigin", {
  versonaId: __t.u64(),
  civ: __t.string(),
  settlementId: __t.u64(),
  bornAt: __t.timestamp(),
});
export type VersonaOrigin = __Infer<typeof VersonaOrigin>;

export const VersonaPair = __t.object("VersonaPair", {
  pairId: __t.u64(),
  aId: __t.u64(),
  bId: __t.u64(),
  worldId: __t.u64(),
  familiarity: __t.u32(),
  lastMetAt: __t.timestamp(),
});
export type VersonaPair = __Infer<typeof VersonaPair>;

export const VersonaProfile = __t.object("VersonaProfile", {
  versonaId: __t.u64(),
  worldId: __t.u64(),
  owner: __t.identity(),
  custom: __t.bool(),
  name: __t.string(),
  archetype: __t.string(),
  persona: __t.string(),
  context: __t.string(),
  greeting: __t.string(),
  deflect: __t.string(),
  topicsJson: __t.string(),
  llm: __t.bool(),
  strict: __t.bool(),
  temperature: __t.f32(),
  maxWords: __t.u32(),
  wanderM: __t.f32(),
  updatedAt: __t.timestamp(),
});
export type VersonaProfile = __Infer<typeof VersonaProfile>;

export const VersonaRoute = __t.object("VersonaRoute", {
  versonaId: __t.u64(),
  worldId: __t.u64(),
  x0: __t.f32(),
  z0: __t.f32(),
  x1: __t.f32(),
  z1: __t.f32(),
  x2: __t.f32(),
  z2: __t.f32(),
  x3: __t.f32(),
  z3: __t.f32(),
  n: __t.u8(),
  stepM: __t.f32(),
  updatedAt: __t.timestamp(),
});
export type VersonaRoute = __Infer<typeof VersonaRoute>;

export const VersonaStance = __t.object("VersonaStance", {
  versonaId: __t.u64(),
  worldId: __t.u64(),
  concordX10: __t.i32(),
  updatedAt: __t.timestamp(),
});
export type VersonaStance = __Infer<typeof VersonaStance>;

export const VersonaState = __t.object("VersonaState", {
  versonaId: __t.u64(),
  worldId: __t.u64(),
  curX: __t.f32(),
  curZ: __t.f32(),
  state: __t.string(),
  updatedAt: __t.timestamp(),
});
export type VersonaState = __Infer<typeof VersonaState>;

export const VersonaThought = __t.object("VersonaThought", {
  versonaId: __t.u64(),
  worldId: __t.u64(),
  text: __t.string(),
  activity: __t.string(),
  updatedAt: __t.timestamp(),
});
export type VersonaThought = __Infer<typeof VersonaThought>;

export const VoiceRoom = __t.object("VoiceRoom", {
  roomId: __t.u64(),
  kind: __t.string(),
  refKey: __t.string(),
  name: __t.string(),
  topic: __t.string(),
  owner: __t.identity(),
  access: __t.string(),
  mode: __t.string(),
  capacity: __t.u32(),
  createdAt: __t.timestamp(),
  lastActiveAt: __t.timestamp(),
});
export type VoiceRoom = __Infer<typeof VoiceRoom>;

export const VoiceRoomBan = __t.object("VoiceRoomBan", {
  banKey: __t.string(),
  roomId: __t.u64(),
  identity: __t.identity(),
  by: __t.identity(),
  until: __t.timestamp(),
});
export type VoiceRoomBan = __Infer<typeof VoiceRoomBan>;

export const VoiceRoomInvite = __t.object("VoiceRoomInvite", {
  inviteKey: __t.string(),
  roomId: __t.u64(),
  invitee: __t.identity(),
  invitedBy: __t.identity(),
  at: __t.timestamp(),
});
export type VoiceRoomInvite = __Infer<typeof VoiceRoomInvite>;

export const VoiceRoomMember = __t.object("VoiceRoomMember", {
  memberKey: __t.string(),
  roomId: __t.u64(),
  identity: __t.identity(),
  role: __t.string(),
  serverMuted: __t.bool(),
  handRaised: __t.bool(),
  connected: __t.bool(),
  joinedAt: __t.timestamp(),
  changedAt: __t.timestamp(),
});
export type VoiceRoomMember = __Infer<typeof VoiceRoomMember>;

export const VoiceSfuAdmission = __t.object("VoiceSfuAdmission", {
  token: __t.string(),
  sfu: __t.identity(),
  identity: __t.identity(),
  roomId: __t.u64(),
  at: __t.timestamp(),
});
export type VoiceSfuAdmission = __Infer<typeof VoiceSfuAdmission>;

export const VoiceSfuBlock = __t.object("VoiceSfuBlock", {
  pairKey: __t.string(),
  sfu: __t.identity(),
  a: __t.identity(),
  b: __t.identity(),
  at: __t.timestamp(),
});
export type VoiceSfuBlock = __Infer<typeof VoiceSfuBlock>;

export const VoiceSfuRole = __t.object("VoiceSfuRole", {
  identity: __t.identity(),
  label: __t.string(),
  grantedBy: __t.identity(),
  grantedAt: __t.timestamp(),
  lastSeenAt: __t.timestamp(),
});
export type VoiceSfuRole = __Infer<typeof VoiceSfuRole>;

export const VoiceSfuState = __t.object("VoiceSfuState", {
  key: __t.string(),
  startedAt: __t.timestamp(),
  lastBeatAt: __t.timestamp(),
  rooms: __t.u32(),
  peers: __t.u32(),
  version: __t.string(),
});
export type VoiceSfuState = __Infer<typeof VoiceSfuState>;

export const VoiceSignal = __t.object("VoiceSignal", {
  signalId: __t.u64(),
  sender: __t.identity(),
  target: __t.identity(),
  payload: __t.string(),
  at: __t.timestamp(),
});
export type VoiceSignal = __Infer<typeof VoiceSignal>;

export const VoiceTicket = __t.object("VoiceTicket", {
  token: __t.string(),
  identity: __t.identity(),
  roomId: __t.u64(),
  issuedAt: __t.timestamp(),
  expiresAt: __t.timestamp(),
});
export type VoiceTicket = __Infer<typeof VoiceTicket>;

export const Vouch = __t.object("Vouch", {
  vouchId: __t.u64(),
  voucher: __t.identity(),
  vouchee: __t.identity(),
  infStaked: __t.i64(),
  weightX100: __t.i32(),
  at: __t.timestamp(),
  active: __t.bool(),
});
export type Vouch = __Infer<typeof Vouch>;

export const Wallet = __t.object("Wallet", {
  identity: __t.identity(),
  sov: __t.i64(),
  inf: __t.i64(),
  updatedAt: __t.timestamp(),
});
export type Wallet = __Infer<typeof Wallet>;

export const WarAirClock = __t.object("WarAirClock", {
  warId: __t.u64(),
  worldId: __t.u64(),
  lastExchangeEpoch: __t.u64(),
  exchanges: __t.u32(),
  updatedAt: __t.timestamp(),
});
export type WarAirClock = __Infer<typeof WarAirClock>;

export const WarAirDuel = __t.object("WarAirDuel", {
  warId: __t.u64(),
  worldId: __t.u64(),
  lastBurstEpoch: __t.u64(),
  bursts: __t.u32(),
  updatedAt: __t.timestamp(),
});
export type WarAirDuel = __Infer<typeof WarAirDuel>;

export const WarAirUnit = __t.object("WarAirUnit", {
  airId: __t.u64(),
  warId: __t.u64(),
  worldId: __t.u64(),
  side: __t.string(),
  versonaId: __t.u64(),
  kind: __t.string(),
  chassisKey: __t.string(),
  hp: __t.i32(),
  state: __t.string(),
  anchorX: __t.f32(),
  anchorZ: __t.f32(),
  escortRef: __t.u64(),
  crashX: __t.f32(),
  crashZ: __t.f32(),
  downedBy: __t.identity(),
  updatedAt: __t.timestamp(),
});
export type WarAirUnit = __Infer<typeof WarAirUnit>;

export const WarAssignment = __t.object("WarAssignment", {
  versonaId: __t.u64(),
  warId: __t.u64(),
  worldId: __t.u64(),
  kind: __t.string(),
  refId: __t.u64(),
  side: __t.string(),
  sinceAt: __t.timestamp(),
  updatedAt: __t.timestamp(),
});
export type WarAssignment = __Infer<typeof WarAssignment>;

export const WarAuthority = __t.object("WarAuthority", {
  campaignId: __t.u64(),
  version: __t.u32(),
  epoch: __t.u32(),
  pinned: __t.bool(),
  pinnedAt: __t.timestamp(),
  shots: __t.u64(),
  hits: __t.u64(),
  updatedAt: __t.timestamp(),
});
export type WarAuthority = __Infer<typeof WarAuthority>;

export const WarBannerHold = __t.object("WarBannerHold", {
  key: __t.string(),
  warId: __t.u64(),
  identity: __t.identity(),
  side: __t.string(),
  x: __t.f32(),
  z: __t.f32(),
  startedAt: __t.timestamp(),
});
export type WarBannerHold = __Infer<typeof WarBannerHold>;

export const WarBond = __t.object("WarBond", {
  bondId: __t.u64(),
  civ: __t.string(),
  holderId: __t.u64(),
  principal: __t.i64(),
  status: __t.string(),
  issuedAt: __t.timestamp(),
  dueEpoch: __t.i64(),
});
export type WarBond = __Infer<typeof WarBond>;

export const WarClash = __t.object("WarClash", {
  clashId: __t.u64(),
  warId: __t.u64(),
  worldId: __t.u64(),
  x: __t.f32(),
  z: __t.f32(),
  aggressorSid: __t.u64(),
  defenderSid: __t.u64(),
  fallenName: __t.string(),
  endsAt: __t.timestamp(),
  at: __t.timestamp(),
});
export type WarClash = __Infer<typeof WarClash>;

export const WarHit = __t.object("WarHit", {
  hitKey: __t.string(),
  lifeKey: __t.string(),
  life: __t.u32(),
  campaignId: __t.u64(),
  identity: __t.identity(),
  damage: __t.f64(),
  hits: __t.u32(),
  firstAt: __t.timestamp(),
  lastAt: __t.timestamp(),
});
export type WarHit = __Infer<typeof WarHit>;

export const WarLife = __t.object("WarLife", {
  lifeKey: __t.string(),
  campaignId: __t.u64(),
  rosterKey: __t.string(),
  kind: __t.string(),
  side: __t.u8(),
  slot: __t.u32(),
  life: __t.u32(),
  hp: __t.f64(),
  hpMax: __t.f64(),
  seq: __t.u32(),
  lastBy: __t.string(),
  endedAt: __t.timestamp(),
  endCause: __t.string(),
  version: __t.u32(),
  updatedAt: __t.timestamp(),
});
export type WarLife = __Infer<typeof WarLife>;

export const WarMemorial = __t.object("WarMemorial", {
  memId: __t.u64(),
  worldId: __t.u64(),
  settlementId: __t.u64(),
  warId: __t.u64(),
  inscription: __t.string(),
  fallenJson: __t.string(),
  x: __t.f32(),
  z: __t.f32(),
  erectedAt: __t.timestamp(),
});
export type WarMemorial = __Infer<typeof WarMemorial>;

export const WarPetition = __t.object("WarPetition", {
  warId: __t.u64(),
  worldId: __t.u64(),
  settlementId: __t.u64(),
  signatures: __t.u32(),
  threshold: __t.u32(),
  state: __t.string(),
  updatedAt: __t.timestamp(),
});
export type WarPetition = __Infer<typeof WarPetition>;

export const WarReadiness = __t.object("WarReadiness", {
  warId: __t.u64(),
  worldId: __t.u64(),
  fitA: __t.u32(),
  fitB: __t.u32(),
  blockerA: __t.string(),
  blockerB: __t.string(),
  nextBattleAt: __t.timestamp(),
  updatedAt: __t.timestamp(),
});
export type WarReadiness = __Infer<typeof WarReadiness>;

export const WarSchedule = __t.object("WarSchedule", {
  warId: __t.u64(),
  worldId: __t.u64(),
  nextBattleAt: __t.timestamp(),
  updatedAt: __t.timestamp(),
});
export type WarSchedule = __Infer<typeof WarSchedule>;

export const WarStake = __t.object("WarStake", {
  warId: __t.u64(),
  worldId: __t.u64(),
  stakeSid: __t.u64(),
  stakeCiv: __t.string(),
  defenderLosses: __t.u32(),
  battlesAtStake: __t.u32(),
  updatedAt: __t.timestamp(),
});
export type WarStake = __Infer<typeof WarStake>;

export const WarState = __t.object("WarState", {
  warId: __t.u64(),
  worldId: __t.u64(),
  aggressorSid: __t.u64(),
  defenderSid: __t.u64(),
  status: __t.string(),
  grievanceAtStart: __t.u32(),
  exhaustionA: __t.u32(),
  exhaustionB: __t.u32(),
  casualties: __t.u32(),
  lastClashAt: __t.timestamp(),
  startedAt: __t.timestamp(),
  endedAt: __t.timestamp(),
});
export type WarState = __Infer<typeof WarState>;

export const WarStream = __t.object("WarStream", {
  streamKey: __t.string(),
  identity: __t.identity(),
  mount: __t.string(),
  hi: __t.u64(),
  mask: __t.u64(),
  hashes: __t.string(),
  tokens: __t.f64(),
  tokensAt: __t.f64(),
  energy: __t.f64(),
  energyAt: __t.f64(),
  shots: __t.u64(),
  updatedAt: __t.timestamp(),
});
export type WarStream = __Infer<typeof WarStream>;

export const WarSupplyRun = __t.object("WarSupplyRun", {
  runId: __t.u64(),
  warId: __t.u64(),
  battleId: __t.u64(),
  side: __t.string(),
  originSid: __t.u64(),
  outpostId: __t.u64(),
  cargo: __t.string(),
  crates: __t.u8(),
  reward: __t.i64(),
  state: __t.string(),
  taker: __t.identity(),
  takenAt: __t.timestamp(),
  deadline: __t.timestamp(),
  postedAt: __t.timestamp(),
  doneAt: __t.timestamp(),
});
export type WarSupplyRun = __Infer<typeof WarSupplyRun>;

export const WarmthStamp = __t.object("WarmthStamp", {
  identity: __t.identity(),
  lastAt: __t.timestamp(),
});
export type WarmthStamp = __Infer<typeof WarmthStamp>;

export const Wave = __t.object("Wave", {
  waveId: __t.u64(),
  fromIdentity: __t.identity(),
  toIdentity: __t.identity(),
  boosted: __t.bool(),
  at: __t.timestamp(),
});
export type Wave = __Infer<typeof Wave>;

export const Waypoint = __t.object("Waypoint", {
  waypointId: __t.u64(),
  owner: __t.identity(),
  worldId: __t.u64(),
  name: __t.string(),
  posX: __t.f32(),
  posZ: __t.f32(),
  createdAt: __t.timestamp(),
});
export type Waypoint = __Infer<typeof Waypoint>;

export const WeaponFeed = __t.object("WeaponFeed", {
  feedKey: __t.string(),
  owner: __t.identity(),
  serial: __t.string(),
  itemKey: __t.string(),
  rounds: __t.u32(),
  charge: __t.f32(),
  chargeAt: __t.timestamp(),
  reloadUntil: __t.timestamp(),
  updatedAt: __t.timestamp(),
});
export type WeaponFeed = __Infer<typeof WeaponFeed>;

export const WeaponState = __t.object("WeaponState", {
  identity: __t.identity(),
  itemKey: __t.string(),
  rounds: __t.u32(),
  charge: __t.f32(),
  chargeAt: __t.timestamp(),
  reloadUntil: __t.timestamp(),
  updatedAt: __t.timestamp(),
});
export type WeaponState = __Infer<typeof WeaponState>;

export const WeatherProfile = __t.object("WeatherProfile", {
  profileId: __t.u64(),
  weather: __t.string(),
  particleKind: __t.string(),
  particleDensity: __t.f32(),
  fogDensity: __t.f32(),
  fogColorHex: __t.string(),
  windStrength: __t.f32(),
  wetness: __t.f32(),
});
export type WeatherProfile = __Infer<typeof WeatherProfile>;

export const WildsState = __t.object("WildsState", {
  id: __t.u8(),
  lastTickAt: __t.timestamp(),
});
export type WildsState = __Infer<typeof WildsState>;

export const World = __t.object("World", {
  worldId: __t.u64(),
  owner: __t.identity(),
  name: __t.string(),
  kind: __t.string(),
  terrainSeed: __t.string(),
  sizeM: __t.u32(),
  visibility: __t.string(),
  lifecycle: __t.string(),
  createdAt: __t.timestamp(),
});
export type World = __Infer<typeof World>;

export const WorldBuildBudget = __t.object("WorldBuildBudget", {
  worldId: __t.u64(),
  liMax: __t.u32(),
  liUsed: __t.u32(),
});
export type WorldBuildBudget = __Infer<typeof WorldBuildBudget>;

export const WorldCoAuthor = __t.object("WorldCoAuthor", {
  coAuthorId: __t.u64(),
  worldId: __t.u64(),
  identity: __t.identity(),
  creditedAt: __t.timestamp(),
});
export type WorldCoAuthor = __Infer<typeof WorldCoAuthor>;

export const WorldDevice = __t.object("WorldDevice", {
  deviceId: __t.u64(),
  worldId: __t.u64(),
  owner: __t.identity(),
  kind: __t.string(),
  name: __t.string(),
  posX: __t.f32(),
  posY: __t.f32(),
  posZ: __t.f32(),
  yaw: __t.f32(),
  sx: __t.f32(),
  sy: __t.f32(),
  sz: __t.f32(),
  configJson: __t.string(),
  enabled: __t.bool(),
  createdAt: __t.timestamp(),
  updatedAt: __t.timestamp(),
});
export type WorldDevice = __Infer<typeof WorldDevice>;

export const WorldEnvironment = __t.object("WorldEnvironment", {
  worldId: __t.u64(),
  timeMode: __t.string(),
  fixedTimeOfDay: __t.f32(),
  weatherMode: __t.string(),
  fogMul: __t.f32(),
  fogColorHex: __t.string(),
  sunMul: __t.f32(),
  ambientMul: __t.f32(),
  sunTintHex: __t.string(),
  ambienceKey: __t.string(),
  ambienceGain: __t.f32(),
  updatedBy: __t.identity(),
  updatedAt: __t.timestamp(),
});
export type WorldEnvironment = __Infer<typeof WorldEnvironment>;

export const WorldGovernance = __t.object("WorldGovernance", {
  worldId: __t.u64(),
  template: __t.string(),
  authorship: __t.string(),
  jurisdiction: __t.string(),
  capacity: __t.u32(),
  quarantined: __t.bool(),
  platformLocked: __t.bool(),
  legacyProtected: __t.bool(),
  visitorCount: __t.u32(),
  verifiedReports: __t.u32(),
  archivedAt: __t.timestamp(),
  seasonStartedAt: __t.timestamp(),
  royaltyBps: __t.u32(),
  updatedAt: __t.timestamp(),
});
export type WorldGovernance = __Infer<typeof WorldGovernance>;

export const WorldMetric = __t.object("WorldMetric", {
  worldId: __t.u64(),
  visits7D: __t.u32(),
  uniqueVisitors7D: __t.u32(),
  avgRating: __t.f32(),
  ratingCount: __t.u32(),
  visualPollution: __t.f32(),
  hotScore: __t.f32(),
  lastVisitAt: __t.timestamp(),
  hidden: __t.bool(),
  delisted: __t.bool(),
  updatedAt: __t.timestamp(),
});
export type WorldMetric = __Infer<typeof WorldMetric>;

export const WorldObject = __t.object("WorldObject", {
  objectId: __t.u64(),
  worldId: __t.u64(),
  cellX: __t.i32(),
  cellZ: __t.i32(),
  prefabId: __t.string(),
  posX: __t.f32(),
  posY: __t.f32(),
  posZ: __t.f32(),
  rotX: __t.f32(),
  rotY: __t.f32(),
  rotZ: __t.f32(),
  rotW: __t.f32(),
  scale: __t.f32(),
  placedBy: __t.identity(),
  placedAt: __t.timestamp(),
  sourceAssetId: __t.u64(),
  rezzedBy: __t.identity(),
});
export type WorldObject = __Infer<typeof WorldObject>;

export const WorldPatch = __t.object("WorldPatch", {
  patchId: __t.u64(),
  worldId: __t.u64(),
  patchKey: __t.string(),
  value: __t.string(),
  version: __t.u32(),
  updatedBy: __t.identity(),
  updatedAt: __t.timestamp(),
});
export type WorldPatch = __Infer<typeof WorldPatch>;

export const WorldPreset = __t.object("WorldPreset", {
  worldId: __t.u64(),
  preset: __t.string(),
  updatedAt: __t.timestamp(),
});
export type WorldPreset = __Infer<typeof WorldPreset>;

export const WorldRating = __t.object("WorldRating", {
  ratingRowId: __t.u64(),
  worldId: __t.u64(),
  rater: __t.identity(),
  stars: __t.u8(),
  at: __t.timestamp(),
});
export type WorldRating = __Infer<typeof WorldRating>;

export const WorldReport = __t.object("WorldReport", {
  reportId: __t.u64(),
  worldId: __t.u64(),
  reporter: __t.identity(),
  reason: __t.string(),
  verified: __t.bool(),
  at: __t.timestamp(),
});
export type WorldReport = __Infer<typeof WorldReport>;

export const WorldRole = __t.object("WorldRole", {
  roleId: __t.u64(),
  worldId: __t.u64(),
  identity: __t.identity(),
  role: __t.string(),
  caps: __t.string(),
  grantedBy: __t.identity(),
  grantedAt: __t.timestamp(),
});
export type WorldRole = __Infer<typeof WorldRole>;

export const WorldRules = __t.object("WorldRules", {
  worldId: __t.u64(),
  hasSpawn: __t.bool(),
  spawnX: __t.f32(),
  spawnY: __t.f32(),
  spawnZ: __t.f32(),
  spawnYaw: __t.f32(),
  objective: __t.string(),
  roundSeconds: __t.u32(),
  respawnMode: __t.string(),
  scoreTopic: __t.string(),
  updatedBy: __t.identity(),
  updatedAt: __t.timestamp(),
});
export type WorldRules = __Infer<typeof WorldRules>;

export const WorldScript = __t.object("WorldScript", {
  scriptId: __t.u64(),
  worldId: __t.u64(),
  name: __t.string(),
  source: __t.string(),
  enabled: __t.bool(),
  updatedBy: __t.identity(),
  updatedAt: __t.timestamp(),
});
export type WorldScript = __Infer<typeof WorldScript>;

export const WorldSnapshot = __t.object("WorldSnapshot", {
  snapshotId: __t.u64(),
  worldId: __t.u64(),
  seq: __t.u32(),
  kind: __t.string(),
  inverse: __t.string(),
  editor: __t.identity(),
  undone: __t.bool(),
  at: __t.timestamp(),
});
export type WorldSnapshot = __Infer<typeof WorldSnapshot>;

export const WorldVisit = __t.object("WorldVisit", {
  visitRowId: __t.u64(),
  worldId: __t.u64(),
  visitor: __t.identity(),
  visitCount: __t.u32(),
  lastAt: __t.timestamp(),
});
export type WorldVisit = __Infer<typeof WorldVisit>;

export const WormholeFlux = __t.object("WormholeFlux", {
  fluxId: __t.u64(),
  whKey: __t.string(),
  massUsed: __t.u32(),
  collapsed: __t.bool(),
  updatedAt: __t.timestamp(),
});
export type WormholeFlux = __Infer<typeof WormholeFlux>;

export const ZoningGrant = __t.object("ZoningGrant", {
  grantId: __t.u64(),
  cityId: __t.u64(),
  grantee: __t.identity(),
  grantedBy: __t.identity(),
  expiresAt: __t.timestamp(),
});
export type ZoningGrant = __Infer<typeof ZoningGrant>;

